(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[924],{

/***/ 54025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LpB": function() { return /* binding */ goPcmBookReviewMatrixGetReviews; }
});

// UNUSED EXPORTS: ajaxActivityGetTags, ajaxActivitySaveTags, ajaxActivitySaveTags2, ajaxAdBookShelf, ajaxBadgeGetBadgeDetail, ajaxBadgeGetMyBadges, ajaxBookGetBookDetailPage, ajaxBookGetRelatedBooksAjax, ajaxBookGetRssMidPage, ajaxBookstoreGetUpdateNums, ajaxBookstoreIndexV2Page, ajaxBookstoreIndexV3page, ajaxBookstoreTopic, ajaxBookstoreUserBadge, ajaxCategoryCategoryPage, ajaxCategoryGetAllAjax, ajaxCategoryGetCategories, ajaxCdkeyNeedCaptcha, ajaxCdkeyRedeem, ajaxChapterGetAmpContent, ajaxChapterGetChapterListAjax, ajaxChapterGetContent, ajaxChapterGetLatestUpdates, ajaxChapterReviewAdd, ajaxChapterReviewList, ajaxChapterReviewReport, ajaxComicAddbullet, ajaxComicComicDetailPage, ajaxComicGetComicChapterListAjax, ajaxComicGetContent, ajaxComicGetLatestUpdates, ajaxComicGetbullet, ajaxComicList, ajaxComicUnlockChapter, ajaxComicUnlockChapter_1574142720938, ajaxComicUpdateList, ajaxFansGetBookFansRankingList, ajaxGiftDonateGift, ajaxGiftGetBookGiftList, ajaxGiftGetGiftInfo, ajaxLibraryAddLibraryItemsAjax, ajaxLibraryDeleteLibraryItemsAjax, ajaxLibraryLibraryAjax, ajaxLibrarySetUserPreferenceAjax, ajaxLoginCheckAndActivate, ajaxLoginGetThirdPartyInfo, ajaxLoginLogin, ajaxLoginRedirect, ajaxMembershipGetInfoAjax, ajaxMessageGetMessagesAjax, ajaxMessageList, ajaxNotificationListAjax, ajaxNotificationNotificationListAjax, ajaxNotificationStatus, ajaxNotificationSystemListAjax, ajaxProfileUserPage, ajaxPublishBookGetBookDetailPage, ajaxRankingGetAllRank, ajaxRankingGetRanking, ajaxRankingGetlist, ajaxReadingHistoryClearReadingHistoryAjax, ajaxReadingHistoryDeleteReadingHistoryAjax, ajaxReadingHistoryReadingHistoryAjax, ajaxRecommendList, ajaxReportReportUserOrBook, ajaxReviewAddReview, ajaxReviewAddReviewAjax, ajaxReviewAddReviewLikeAjax, ajaxReviewAddReviewReplyAjax, ajaxReviewAddReviewReportAjax, ajaxReviewDeleteReviewAjax, ajaxReviewGetReviewDetailAjax, ajaxReviewGetReviewsAjax, ajaxSearchAuto, ajaxSearchGetHotSearch, ajaxSearchSearchAjax, ajaxSettingSendCaptchaNEmail, ajaxSettingsCheckEmailAjax, ajaxSettingsCheckNameAjax, ajaxSettingsFirstAddEmail, ajaxSettingsInfoAjax, ajaxSettingsModifyMail, ajaxSettingsModifyUserInfoAjax, ajaxSettingsSendCaptchaOEmail, ajaxSettingsVerifyCaptcha, ajaxSpiritStoneCheckInAjax, ajaxSpiritStoneGetAnnoucement, ajaxSpiritStoneGetGearInfo, ajaxSpiritStoneGetInviteFriendPage, ajaxSpiritStoneGetSsHistoryAjax, ajaxSpiritStoneGetSsHistoryPage, ajaxSpiritStoneUseSsUnlockChapterAjax, ajaxSpiritStoneUseSsUnlockChapterAjax2, ajaxStoneGetPowerStoneRankingByBookIdList, ajaxStonePowerInfoAjax, ajaxStonePowerListAjax, ajaxStonePowerVoteAjax, ajaxStoneStoneDetailAjax, ajaxTagBookListAjax, ajaxTagBookTagList, ajaxTagSupport, ajaxTaskClaimTaskReward, ajaxTaskTaskList, ajaxUserLevelListAjax, ajaxUserSetUserAvatarAjax, ajaxUserTagAddDeleteUserTagsAjax, ajaxUserTagEditUserTagPage, ajaxUserTagGetBookTagsAjax, ajaxUserUserInfoAjax, ajaxVoteLike, ajaxVoteList, chapterReviewIndex, goPcm, goPcmAdGetPool, goPcmAffiliateAdd, goPcmBadgeGetBadgeDetail, goPcmBadgeGetMyBadges, goPcmBookGetAudioBookLandingPage, goPcmBookGetBatchSubscribeGrade, goPcmBookGetBatchSubscribeGrade2, goPcmBookGetBookDetail, goPcmBookGetBookDetail2, goPcmBookGetBookDetailPage, goPcmBookGetBookDetailPagePc, goPcmBookGetBookLandingPage, goPcmBookGetBookRssPage, goPcmBookGetComicLandingPage, goPcmBookGetOffLineBook, goPcmBookGetRelatedBooksAjax, goPcmBookGetSearchLandingPage, goPcmBookGetShortplayLandingPage, goPcmBookReviewAdd, goPcmBookReviewAddReply, goPcmBookReviewDetail, goPcmBookReviewEssence, goPcmBookReviewEssence2, goPcmBookReviewGetReviews, goPcmBookReviewLike, goPcmBookReviewRemove, goPcmBookReviewReport, goPcmBookReviewSetTop, goPcmBookReviewSetTop2, goPcmBookReviwReport, goPcmBookSetReadingSettings, goPcmBookUnlockBatchChapters, goPcmBookUnlockBatchChapters2, goPcmBookUnlockChapter, goPcmBookcityCountryLanguage, goPcmBookcityGetChange, goPcmBookcityGetComicFeedList, goPcmBookcityGetFeedList, goPcmBookcityGetHistory, goPcmBookcityGetHistoryList, goPcmBookcityGetMoreList, goPcmBookcityGetQdList, goPcmBookcityGetRelationPage, goPcmBookcityPage, goPcmBookcityPageList, goPcmBookstoreGetUpdateNums, goPcmBookstoreIndexV3Page, goPcmBookstoreTopic, goPcmBookstoreUserBadge, goPcmCategoryCategoryAjax, goPcmCategoryCategoryPage, goPcmCategoryGetAllAjax, goPcmCategoryGetCategories, goPcmCategoryGetRankCollections, goPcmCategoryGetRankConfig, goPcmCategoryGetRankList, goPcmCategoryGetRankListPage, goPcmCdkeyNeedCaptcha, goPcmCdkeyRedeem, goPcmCdkeyUserStatus, goPcmChapterGetAmpContent, goPcmChapterGetAmpContentPage, goPcmChapterGetChapterContentToken, goPcmChapterGetChapterList, goPcmChapterGetChapterList2, goPcmChapterGetContent, goPcmChapterGetContent2, goPcmChapterGetContentByToken, goPcmChapterGetContentPage, goPcmChapterGetLatestUpdates, goPcmChapterReviewAddReview, goPcmChapterReviewDeleteReview, goPcmChapterReviewGetReviewList, goPcmChapterReviewGetReviewList2, goPcmChapterReviewGetReviewReplys, goPcmChapterReviewLikeReview, goPcmComicAddBullet, goPcmComicGetBullet, goPcmComicGetCalendar, goPcmComicGetChapterList, goPcmComicGetComicDetailPage, goPcmComicGetComicDetailPc, goPcmComicGetContent, goPcmComicGetContent2, goPcmComicGetContentPage, goPcmComicGetDateComic, goPcmComicGetLatestUpdates, goPcmComicGetList, goPcmComicGetListPage, goPcmComicGetUpdateList, goPcmComicUnlockChapter, goPcmDiscordBind, goPcmEmojiGetEmoji, goPcmEmojiGetEmoji2, goPcmExpectEsList, goPcmExpectEsList2, goPcmExpectTrailerList, goPcmExpectTrailerList2, goPcmExpectTryReadBookList, goPcmFansGetBookFansRanking, goPcmFansGetBookFansRankingList, goPcmFastpassGetLogList, goPcmFastpassGetMyList, goPcmGetReviewDetail, goPcmGiftDonateGift, goPcmGiftGetBookGiftList, goPcmGiftGetGiftInfo, goPcmGiftGetGiftInfo2, goPcmGoPcmGoPcmPowerStonePowerListAjax, goPcmGoPcmPowerStonePowerInfoAjax, goPcmGoPcmUserUploadTmpAvatar, goPcmLibraryAddLibraryItemsAjax, goPcmLibraryCheckInLibraryAjax, goPcmLibraryDeleteLibraryItemsAjax, goPcmLibraryGetReadingProgress, goPcmLibraryLibrary, goPcmLibrarySetReadingProgressAjax, goPcmLibrarySetUserPreferenceAjax, goPcmLoginCheckAndActivate, goPcmLoginFromApp, goPcmLoginGetThirdPartyInfo, goPcmLoginGetUserInfo, goPcmLoginLogin, goPcmMachineTransAddContent, goPcmMachineTransDelContent, goPcmMachineTransGetContentList, goPcmMachineTransLike, goPcmMachineTransReport, goPcmMachineTransUpdateContent, goPcmMailSendAppLink, goPcmMatrixBookcityGetContentInfo, goPcmMatrixBookcityGetFeedList, goPcmMatrixBookcityPage, goPcmMatrixRankGetConfig, goPcmMatrixRankGetList, goPcmMatrixSearchGetAutoComplete, goPcmMatrixSearchGetFilterConfig, goPcmMatrixSearchGetHotWord, goPcmMatrixSearchGetResult, goPcmMatrixSearchGetTagBookList, goPcmMatrixSearchGetTopList, goPcmMembershipCancel, goPcmMembershipGetBonus, goPcmMembershipGetInfoAjax, goPcmMembershipGetMemberShip, goPcmMembershipGetMemberShipManager, goPcmMessageGetFollowing, goPcmMessageGetFollowing2, goPcmMessageGetMessages, goPcmMessageGetMessagesAjax, goPcmModeratorApplyModerator, goPcmModeratorGetApplyRecord, goPcmNotificationListAjax, goPcmNotificationListAjax2, goPcmNotificationListPage, goPcmNotificationStatus, goPcmNotificationSystemList, goPcmParagraphReviewAdd, goPcmParagraphReviewDelete, goPcmParagraphReviewGetReiewList, goPcmParagraphReviewGetReiewNum, goPcmParagraphReviewGetReieweReplys, goPcmParagraphReviewGetReviewDetail, goPcmParagraphReviewLike, goPcmParagraphReviewReport, goPcmPcbookcityEssay, goPcmPcbookcityGameLoop, goPcmPcbookcityGetChange, goPcmPcbookcityGetFeedList, goPcmPcbookcityPage, goPcmPing, goPcmPowerStoneGetHistoryAjax, goPcmPowerStoneGetHistoryPage, goPcmPowerStoneGetList, goPcmPowerStoneGetListAjax, goPcmPowerStoneGetPowerStoneRankingByBookId, goPcmPowerStoneGetPowerStoneRankingByBookIdList, goPcmPowerStoneGetRankInfoAjax, goPcmPowerStoneStoneDetailAjax, goPcmPowerStoneVote, goPcmPublishBookGetBookDetailPage, goPcmRankingGetRanking, goPcmReadingHistoryClearReadingHistory, goPcmReadingHistoryDeleteReadingHistory, goPcmReadingHistoryReadingHistoryAjax, goPcmReadingHistoryReadingHistoryPage, goPcmReadingLastPage, goPcmReadingLastPage2, goPcmReadingReport, goPcmReadsdkGetConfig, goPcmReadsdkSetConfig, goPcmRechargeGetGearInfo, goPcmRechargeGetGearInfo2, goPcmRechargeGetGearInfoByMobileNew, goPcmRecommendGetRecommendList, goPcmRecommendGetRecommendList2, goPcmRecommendGetRecommendListPage, goPcmRecommendList, goPcmRecommendYouMayAlsoLike, goPcmReviewAddReview, goPcmReviewGetReviewsAjax, goPcmSearchAutoComplete, goPcmSearchGetHotSearch, goPcmSearchResult, goPcmSearchResultPage, goPcmSeoBookGetBookDetail, goPcmSeoBookGetBookDetailPage, goPcmSeoBookGetChapterInfo, goPcmSeoBookGetChapterList, goPcmSeoBookReviewGetReviews, goPcmSeoCategorySearch, goPcmSeoChapterGetChapterList, goPcmSeoChapterGetContent, goPcmSeoCrTopicDetail, goPcmSeoCrTopicList, goPcmSeoCrTopicRandom, goPcmSeoEmojiGetEmoji, goPcmSeoGetFriendShipLink, goPcmSeoGetKeywordList, goPcmSeoGetLongLinkByShortLink, goPcmSeoGetRandomBookList, goPcmSeoGetTagBookList, goPcmSeoGetTagBookList2, goPcmSeoGetTagList, goPcmSeoGiftGetGiftInfo, goPcmSeoIndex, goPcmSeoJavaSeoAskQueryAnswerInfo, goPcmSeoJavaSeoAskQueryAskInfo, goPcmSeoJavaSeoAskQueryAskList, goPcmSeoJavaSeoAskQueryHotAskRandom, goPcmSeoJavaSeoAskQueryHotTopic, goPcmSeoJavaSeoAskQueryRelationBook, goPcmSeoJavaSeoAskQueryRelationTopicList, goPcmSeoJavaSeoAskQueryTopicAskList, goPcmSeoJavaSeoAskQueryTopicList, goPcmSeoPath, goPcmSeoPowerStoneGetRankInfoAjax, goPcmSeoRecommendGetRecommendList, goPcmSeoSearchHotWord, goPcmSeoSearchResult, goPcmSeoTopicDetail, goPcmSeoTopicDetail2, goPcmSeoTopicList, goPcmShortUrlGenerate, goPcmShortUrlJump, goPcmSpiritStoneCheckIn, goPcmSpiritStoneGetAnnouncement, goPcmSpiritStoneGetInviteFriendPage, goPcmSpiritStoneGetSsHistory, goPcmSpiritStoneGetSsHistory2, goPcmSpiritStoneGetSsHistoryPage, goPcmStoneGetPowerInfo, goPcmTagGetBookTagList, goPcmTagGetBookTagList2, goPcmTagGetTagList, goPcmTagSupport, goPcmTaskClaimTaskReward, goPcmTaskGetTaskList, goPcmTranslationVoteGetAjax, goPcmTranslationVoteGetHistoryPage, goPcmTranslationVoteGetHistoryPageAjax, goPcmUserCancelUser, goPcmUserCheckUserEmail, goPcmUserCheckUserName, goPcmUserFirstAddEmail, goPcmUserGetAuthorPage, goPcmUserGetCancelUserData, goPcmUserGetCashFlow, goPcmUserGetFirstCharge, goPcmUserGetFirstCharge2, goPcmUserGetHomePage, goPcmUserGetHomePage2, goPcmUserGetMomentList, goPcmUserGetMomentList2, goPcmUserGetPage, goPcmUserGetProfileInfo, goPcmUserGetUserLevel, goPcmUserGetUserMSettings, goPcmUserGetUserSettings, goPcmUserLike, goPcmUserModifyEmail, goPcmUserReportUserOrBook, goPcmUserSendCaptchaToEmail, goPcmUserSetBackgroundImage, goPcmUserSetUserAvatar, goPcmUserSetUserSettings, goPcmUserUserInfoAjax, goPcmUserUserInfoReact, goPcmUserVerifyCaptcha, goPcmUtilsGaIdReport, goPcmUtilsGetCosTempKey, goPcmUtilsRealtimeReport, goPcmUtilsUploadImage, goPcmValidatorActivate, goPcmValidatorDeactivate, goPcmValidatorGenerate, goPcmValidatorQueryActivate, goPcmVoteLike, goPcmVoteList, msiteserviceBookcityCountrylanguage, msiteserviceBookcityCountrylanguage_1551923127181, msiteserviceBookcityIndex, notificationGetSsAjax, notificationNotificationListPage, pageActivityGetTags, pageBookGetBookDetailPage, pageBookGetBookReadingPage, pageCategoryBookListPage, pageCategoryGetAllPage, pageCdkeyUserStatus, pageFansGetBookFansRanking, pageLibraryLibraryPage, pageProfileUserPage, pageSpiritStoneGetSsHistoryPage, pageStoneGetPowerStoneRankingByBookIdBookId, pageUserUserInfoReact, utilsGetCosTempKey

// EXTERNAL MODULE: ./node_modules/yapi-to-typescript/lib/esm/types.js
var types = __webpack_require__(76080);
// EXTERNAL MODULE: ./node_modules/yapi-to-typescript/lib/esm/helpers.js
var helpers = __webpack_require__(47027);
// EXTERNAL MODULE: ./src/utils/REST.ts + 1 modules
var REST = __webpack_require__(25108);
;// CONCATENATED MODULE: ./src/api/request.ts

var RestType;
(function(RestType) {
    RestType["Read"] = "read";
    RestType["Create"] = "create";
    RestType["Form"] = "form";
})(RestType || (RestType = {}));
function request(payload) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, // 服务端发起请求时需要
    ctx = arguments.length > 2 ? arguments[2] : void 0;
    return new Promise((resolve, reject)=>{
        // 请求地址
        const url = payload.path;
        // 具体请求逻
        const restMethod = {
            GET: RestType.Read,
            POST: RestType.Create,
            FORM: RestType.Form,
            DELETE: RestType.Read,
            PUT: RestType.Read,
            PATCH: RestType.Read,
            OPTIONS: RestType.Read,
            HEAD: RestType.Read
        }[payload.hasFileData ? "FORM" : payload.method];
        if (!restMethod) {
            throw new Error("unknown req method: ".concat(payload.method));
        }
        if (!REST/* default */.Z[restMethod]) {
            throw new Error("no req method: ".concat(payload.method, "->").concat(restMethod));
        }
        // get post form
        REST/* default */.Z[restMethod]({
            url,
            data: payload.hasFileData ? payload.getFormData() : payload.data,
            options: {
                ...options,
                headers: {
                    ...payload.hasFileData ? {} : payload.requestBodyType === "json" ? {
                        "Content-Type": "application/json; charset=UTF-8"
                    } : payload.requestBodyType === "form" ? {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                    } : {}
                }
            },
            ctx
        }).then((response)=>{
            resolve(response != null && typeof response === "object" ? response.data : response);
        }).catch((error)=>{
            reject(error);
        });
    });
}

;// CONCATENATED MODULE: ./src/api/index.ts
/* prettier-ignore-start */ /* tslint:disable */ /* eslint-disable */ /* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */ // @ts-ignore
// prettier-ignore

// @ts-ignore

const mockUrl_0_2_0_0 = "https://yapi.yuewen.com/mock/3297";
const devUrl_0_2_0_0 = "https://oawww.webnovel.com";
const prodUrl_0_2_0_0 = "https://www.webnovel.com";
const dataKey_0_2_0_0 = "data";
/**
 * 接口 [首页 index↗](https://yapi.yuewen.com/project/3297/interface/api/285397) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/index`
 * @更新时间 `2024-04-28 17:39:18`
 */ const goPcmSeoIndexRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/index",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoIndex",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [首页 index↗](https://yapi.yuewen.com/project/3297/interface/api/285397) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/index`
 * @更新时间 `2024-04-28 17:39:18`
 */ const goPcmSeoIndex = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoIndexRequestConfig, requestData), ...args);
};
goPcmSeoIndex.requestConfig = goPcmSeoIndexRequestConfig;
/**
 * 接口 [搜索词列表查询↗](https://yapi.yuewen.com/project/3297/interface/api/285489) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/getKeywordList`
 * @更新时间 `2024-05-11 15:05:20`
 */ const goPcmSeoGetKeywordListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/getKeywordList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "cate",
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetKeywordList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [搜索词列表查询↗](https://yapi.yuewen.com/project/3297/interface/api/285489) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/getKeywordList`
 * @更新时间 `2024-05-11 15:05:20`
 */ const goPcmSeoGetKeywordList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGetKeywordListRequestConfig, requestData), ...args);
};
goPcmSeoGetKeywordList.requestConfig = goPcmSeoGetKeywordListRequestConfig;
/**
 * 接口 [书详情↗](https://yapi.yuewen.com/project/3297/interface/api/285782) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/book/getBookDetailPage`
 * @更新时间 `2024-04-28 17:39:21`
 */ const goPcmSeoBookGetBookDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/book/getBookDetailPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetBookDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情↗](https://yapi.yuewen.com/project/3297/interface/api/285782) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/book/getBookDetailPage`
 * @更新时间 `2024-04-28 17:39:21`
 */ const goPcmSeoBookGetBookDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoBookGetBookDetailPageRequestConfig, requestData), ...args);
};
goPcmSeoBookGetBookDetailPage.requestConfig = goPcmSeoBookGetBookDetailPageRequestConfig;
/**
 * 接口 [书详情-获取礼物详情↗](https://yapi.yuewen.com/project/3297/interface/api/285785) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/gift/getGiftInfo`
 * @更新时间 `2024-04-28 17:39:22`
 */ const goPcmSeoGiftGetGiftInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/gift/getGiftInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGiftGetGiftInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情-获取礼物详情↗](https://yapi.yuewen.com/project/3297/interface/api/285785) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/gift/getGiftInfo`
 * @更新时间 `2024-04-28 17:39:22`
 */ const goPcmSeoGiftGetGiftInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGiftGetGiftInfoRequestConfig, requestData), ...args);
};
goPcmSeoGiftGetGiftInfo.requestConfig = goPcmSeoGiftGetGiftInfoRequestConfig;
/**
 * 接口 [书详情_获取ps榜排行↗](https://yapi.yuewen.com/project/3297/interface/api/285794) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/powerStone/getRankInfoAjax`
 * @更新时间 `2024-04-28 17:39:23`
 */ const goPcmSeoPowerStoneGetRankInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/powerStone/getRankInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoPowerStoneGetRankInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情_获取ps榜排行↗](https://yapi.yuewen.com/project/3297/interface/api/285794) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/powerStone/getRankInfoAjax`
 * @更新时间 `2024-04-28 17:39:23`
 */ const goPcmSeoPowerStoneGetRankInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoPowerStoneGetRankInfoAjaxRequestConfig, requestData), ...args);
};
goPcmSeoPowerStoneGetRankInfoAjax.requestConfig = goPcmSeoPowerStoneGetRankInfoAjaxRequestConfig;
/**
 * 接口 [书详情_获取推荐you may also like↗](https://yapi.yuewen.com/project/3297/interface/api/285797) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/recommend/getRecommendList`
 * @更新时间 `2024-04-28 17:39:23`
 */ const goPcmSeoRecommendGetRecommendListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/recommend/getRecommendList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoRecommendGetRecommendList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情_获取推荐you may also like↗](https://yapi.yuewen.com/project/3297/interface/api/285797) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/recommend/getRecommendList`
 * @更新时间 `2024-04-28 17:39:23`
 */ const goPcmSeoRecommendGetRecommendList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoRecommendGetRecommendListRequestConfig, requestData), ...args);
};
goPcmSeoRecommendGetRecommendList.requestConfig = goPcmSeoRecommendGetRecommendListRequestConfig;
/**
 * 接口 [书详情_获取评论↗](https://yapi.yuewen.com/project/3297/interface/api/285800) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/bookReview/getReviews`
 * @更新时间 `2024-04-28 17:39:24`
 */ const goPcmSeoBookReviewGetReviewsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/bookReview/getReviews",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "bookId",
        "pageIndex",
        "pageSize",
        "orderBy"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookReviewGetReviews",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情_获取评论↗](https://yapi.yuewen.com/project/3297/interface/api/285800) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/bookReview/getReviews`
 * @更新时间 `2024-04-28 17:39:24`
 */ const goPcmSeoBookReviewGetReviews = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoBookReviewGetReviewsRequestConfig, requestData), ...args);
};
goPcmSeoBookReviewGetReviews.requestConfig = goPcmSeoBookReviewGetReviewsRequestConfig;
/**
 * 接口 [书详情_Emoji↗](https://yapi.yuewen.com/project/3297/interface/api/285809) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/emoji/getEmoji`
 * @更新时间 `2024-04-28 17:39:27`
 */ const goPcmSeoEmojiGetEmojiRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/emoji/getEmoji",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoEmojiGetEmoji",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情_Emoji↗](https://yapi.yuewen.com/project/3297/interface/api/285809) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/emoji/getEmoji`
 * @更新时间 `2024-04-28 17:39:27`
 */ const goPcmSeoEmojiGetEmoji = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoEmojiGetEmojiRequestConfig, requestData), ...args);
};
goPcmSeoEmojiGetEmoji.requestConfig = goPcmSeoEmojiGetEmojiRequestConfig;
/**
 * 接口 [书详情_获取内容↗](https://yapi.yuewen.com/project/3297/interface/api/285812) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getContent`
 * @更新时间 `2024-05-11 15:43:55`
 */ const goPcmSeoChapterGetContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/chapter/getContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "encryptType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoChapterGetContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情_获取内容↗](https://yapi.yuewen.com/project/3297/interface/api/285812) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getContent`
 * @更新时间 `2024-05-11 15:43:55`
 */ const goPcmSeoChapterGetContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoChapterGetContentRequestConfig, requestData), ...args);
};
goPcmSeoChapterGetContent.requestConfig = goPcmSeoChapterGetContentRequestConfig;
/**
 * 接口 [搜索_search↗](https://yapi.yuewen.com/project/3297/interface/api/285985) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/result`
 * @更新时间 `2024-05-09 16:48:09`
 */ const goPcmSeoSearchResultRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/search/result",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "keywords",
        "pageIndex",
        "categoryType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoSearchResult",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [搜索_search↗](https://yapi.yuewen.com/project/3297/interface/api/285985) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/result`
 * @更新时间 `2024-05-09 16:48:09`
 */ const goPcmSeoSearchResult = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoSearchResultRequestConfig, requestData), ...args);
};
goPcmSeoSearchResult.requestConfig = goPcmSeoSearchResultRequestConfig;
/**
 * 接口 [分类_分类搜索↗](https://yapi.yuewen.com/project/3297/interface/api/285992) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `POST /go/pcm/seo/category/search`
 * @更新时间 `2024-05-07 20:05:45`
 */ const goPcmSeoCategorySearchRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/category/search",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCategorySearch",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [分类_分类搜索↗](https://yapi.yuewen.com/project/3297/interface/api/285992) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `POST /go/pcm/seo/category/search`
 * @更新时间 `2024-05-07 20:05:45`
 */ const goPcmSeoCategorySearch = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoCategorySearchRequestConfig, requestData), ...args);
};
goPcmSeoCategorySearch.requestConfig = goPcmSeoCategorySearchRequestConfig;
/**
 * 接口 [搜索_热词↗](https://yapi.yuewen.com/project/3297/interface/api/286203) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/hotWord`
 * @更新时间 `2024-05-09 15:02:08`
 */ const goPcmSeoSearchHotWordRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/search/hotWord",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoSearchHotWord",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [搜索_热词↗](https://yapi.yuewen.com/project/3297/interface/api/286203) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/search/hotWord`
 * @更新时间 `2024-05-09 15:02:08`
 */ const goPcmSeoSearchHotWord = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoSearchHotWordRequestConfig, requestData), ...args);
};
goPcmSeoSearchHotWord.requestConfig = goPcmSeoSearchHotWordRequestConfig;
/**
 * 接口 [书详情_获取章节列表↗](https://yapi.yuewen.com/project/3297/interface/api/286303) 的 **请求配置**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getChapterList`
 * @更新时间 `2024-05-14 11:26:54`
 */ const goPcmSeoChapterGetChapterListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_0,
    devUrl: devUrl_0_2_0_0,
    prodUrl: prodUrl_0_2_0_0,
    path: "/go/pcm/seo/chapter/getChapterList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_0,
    paramNames: [],
    queryNames: [
        "bookId",
        "pageIndex",
        "pageSize",
        "encryptType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoChapterGetChapterList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情_获取章节列表↗](https://yapi.yuewen.com/project/3297/interface/api/286303) 的 **请求函数**
 *
 * @分类 [全部接口↗](https://yapi.yuewen.com/project/3297/interface/api/cat_36813)
 * @请求头 `GET /go/pcm/seo/chapter/getChapterList`
 * @更新时间 `2024-05-14 11:26:54`
 */ const goPcmSeoChapterGetChapterList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoChapterGetChapterListRequestConfig, requestData), ...args);
};
goPcmSeoChapterGetChapterList.requestConfig = goPcmSeoChapterGetChapterListRequestConfig;
const mockUrl_0_2_0_1 = "https://yapi.yuewen.com/mock/3297";
const devUrl_0_2_0_1 = "https://oawww.webnovel.com";
const prodUrl_0_2_0_1 = "https://www.webnovel.com";
const dataKey_0_2_0_1 = "data";
/**
 * 接口 [话题热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/288383) 的 **请求配置**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/list`
 * @更新时间 `2024-07-04 14:00:21`
 */ const goPcmSeoTopicListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: "/go/pcm/seo/topic/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: [
        "cate",
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoTopicList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [话题热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/288383) 的 **请求函数**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/list`
 * @更新时间 `2024-07-04 14:00:21`
 */ const goPcmSeoTopicList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoTopicListRequestConfig, requestData), ...args);
};
goPcmSeoTopicList.requestConfig = goPcmSeoTopicListRequestConfig;
/**
 * 接口 [话题详情↗](https://yapi.yuewen.com/project/3297/interface/api/288392) 的 **请求配置**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-09-25 16:16:14`
 */ const goPcmSeoTopicDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_1,
    devUrl: devUrl_0_2_0_1,
    prodUrl: prodUrl_0_2_0_1,
    path: "/go/pcm/seo/topic/detail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_1,
    paramNames: [],
    queryNames: [
        "topicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoTopicDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [话题详情↗](https://yapi.yuewen.com/project/3297/interface/api/288392) 的 **请求函数**
 *
 * @分类 [话题↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37312)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-09-25 16:16:14`
 */ const goPcmSeoTopicDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoTopicDetailRequestConfig, requestData), ...args);
};
goPcmSeoTopicDetail.requestConfig = goPcmSeoTopicDetailRequestConfig;
const mockUrl_0_2_0_2 = "https://yapi.yuewen.com/mock/3297";
const devUrl_0_2_0_2 = "https://oawww.webnovel.com";
const prodUrl_0_2_0_2 = "https://www.webnovel.com";
const dataKey_0_2_0_2 = "data";
/**
 * 接口 [查询问答详情 ↗](https://yapi.yuewen.com/project/3297/interface/api/288837) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskInfo`
 * @更新时间 `2024-07-16 11:05:04`
 */ const goPcmSeoJavaSeoAskQueryAskInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryAskInfo",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {
        Accept: "*/*"
    },
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryAskInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [查询问答详情 ↗](https://yapi.yuewen.com/project/3297/interface/api/288837) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskInfo`
 * @更新时间 `2024-07-16 11:05:04`
 */ const goPcmSeoJavaSeoAskQueryAskInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryAskInfoRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryAskInfo.requestConfig = goPcmSeoJavaSeoAskQueryAskInfoRequestConfig;
/**
 * 接口 [问答列表（分页）↗](https://yapi.yuewen.com/project/3297/interface/api/288839) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskList`
 * @更新时间 `2024-10-10 15:34:30`
 */ const goPcmSeoJavaSeoAskQueryAskListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryAskList",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {
        Accept: "*/*"
    },
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryAskList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [问答列表（分页）↗](https://yapi.yuewen.com/project/3297/interface/api/288839) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAskList`
 * @更新时间 `2024-10-10 15:34:30`
 */ const goPcmSeoJavaSeoAskQueryAskList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryAskListRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryAskList.requestConfig = goPcmSeoJavaSeoAskQueryAskListRequestConfig;
/**
 * 接口 [热门回答（随机查询30条）↗](https://yapi.yuewen.com/project/3297/interface/api/288842) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotAskRandom`
 * @更新时间 `2024-07-16 11:05:34`
 */ const goPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryHotAskRandom",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {
        Accept: "*/*"
    },
    requestBodyType: types/* RequestBodyType.raw */.Py.raw,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryHotAskRandom",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [热门回答（随机查询30条）↗](https://yapi.yuewen.com/project/3297/interface/api/288842) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotAskRandom`
 * @更新时间 `2024-07-16 11:05:34`
 */ const goPcmSeoJavaSeoAskQueryHotAskRandom = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryHotAskRandom.requestConfig = goPcmSeoJavaSeoAskQueryHotAskRandomRequestConfig;
/**
 * 接口 [话题列表A-Z & 最新搜索↗](https://yapi.yuewen.com/project/3297/interface/api/288845) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicList`
 * @更新时间 `2024-07-16 11:05:42`
 */ const goPcmSeoJavaSeoAskQueryTopicListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryTopicList",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {
        Accept: "*/*"
    },
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryTopicList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [话题列表A-Z & 最新搜索↗](https://yapi.yuewen.com/project/3297/interface/api/288845) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicList`
 * @更新时间 `2024-07-16 11:05:42`
 */ const goPcmSeoJavaSeoAskQueryTopicList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryTopicListRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryTopicList.requestConfig = goPcmSeoJavaSeoAskQueryTopicListRequestConfig;
/**
 * 接口 [根据topicId查询列表（话题详情页）↗](https://yapi.yuewen.com/project/3297/interface/api/289088) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicAskList`
 * @更新时间 `2024-10-10 15:35:24`
 */ const goPcmSeoJavaSeoAskQueryTopicAskListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryTopicAskList",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {
        Accept: "*/*"
    },
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryTopicAskList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [根据topicId查询列表（话题详情页）↗](https://yapi.yuewen.com/project/3297/interface/api/289088) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryTopicAskList`
 * @更新时间 `2024-10-10 15:35:24`
 */ const goPcmSeoJavaSeoAskQueryTopicAskList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryTopicAskListRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryTopicAskList.requestConfig = goPcmSeoJavaSeoAskQueryTopicAskListRequestConfig;
/**
 * 接口 [查询回答详情↗](https://yapi.yuewen.com/project/3297/interface/api/289091) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAnswerInfo`
 * @更新时间 `2024-07-16 11:05:58`
 */ const goPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryAnswerInfo",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {
        Accept: "*/*"
    },
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryAnswerInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [查询回答详情↗](https://yapi.yuewen.com/project/3297/interface/api/289091) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryAnswerInfo`
 * @更新时间 `2024-07-16 11:05:58`
 */ const goPcmSeoJavaSeoAskQueryAnswerInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryAnswerInfo.requestConfig = goPcmSeoJavaSeoAskQueryAnswerInfoRequestConfig;
/**
 * 接口 [热门话题A-Z（随机展示）↗](https://yapi.yuewen.com/project/3297/interface/api/289100) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotTopic`
 * @更新时间 `2024-07-16 11:06:05`
 */ const goPcmSeoJavaSeoAskQueryHotTopicRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryHotTopic",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {
        Accept: "*/*"
    },
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryHotTopic",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [热门话题A-Z（随机展示）↗](https://yapi.yuewen.com/project/3297/interface/api/289100) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryHotTopic`
 * @更新时间 `2024-07-16 11:06:05`
 */ const goPcmSeoJavaSeoAskQueryHotTopic = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryHotTopicRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryHotTopic.requestConfig = goPcmSeoJavaSeoAskQueryHotTopicRequestConfig;
/**
 * 接口 [搜索相关话题↗](https://yapi.yuewen.com/project/3297/interface/api/289216) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationTopicList`
 * @更新时间 `2024-07-16 11:07:26`
 */ const goPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryRelationTopicList",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryRelationTopicList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [搜索相关话题↗](https://yapi.yuewen.com/project/3297/interface/api/289216) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationTopicList`
 * @更新时间 `2024-07-16 11:07:26`
 */ const goPcmSeoJavaSeoAskQueryRelationTopicList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryRelationTopicList.requestConfig = goPcmSeoJavaSeoAskQueryRelationTopicListRequestConfig;
/**
 * 接口 [搜索相关书信息↗](https://yapi.yuewen.com/project/3297/interface/api/294701) 的 **请求配置**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationBook`
 * @更新时间 `2024-10-31 15:51:13`
 */ const goPcmSeoJavaSeoAskQueryRelationBookRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_2,
    devUrl: devUrl_0_2_0_2,
    prodUrl: prodUrl_0_2_0_2,
    path: "/go/pcm/seo/java/seo/ask/queryRelationBook",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoJavaSeoAskQueryRelationBook",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [搜索相关书信息↗](https://yapi.yuewen.com/project/3297/interface/api/294701) 的 **请求函数**
 *
 * @分类 [问答↗](https://yapi.yuewen.com/project/3297/interface/api/cat_37373)
 * @请求头 `POST /go/pcm/seo/java/seo/ask/queryRelationBook`
 * @更新时间 `2024-10-31 15:51:13`
 */ const goPcmSeoJavaSeoAskQueryRelationBook = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoJavaSeoAskQueryRelationBookRequestConfig, requestData), ...args);
};
goPcmSeoJavaSeoAskQueryRelationBook.requestConfig = goPcmSeoJavaSeoAskQueryRelationBookRequestConfig;
const mockUrl_0_2_0_3 = "https://yapi.yuewen.com/mock/3297";
const devUrl_0_2_0_3 = "https://oawww.webnovel.com";
const prodUrl_0_2_0_3 = "https://www.webnovel.com";
const dataKey_0_2_0_3 = "data";
/**
 * 接口 [书详情页↗](https://yapi.yuewen.com/project/3297/interface/api/292680) 的 **请求配置**
 *
 * @分类 [站群↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38317)
 * @请求头 `GET /go/pcm/seo/path`
 * @更新时间 `2024-09-23 11:19:59`
 */ const goPcmSeoPathRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_3,
    devUrl: devUrl_0_2_0_3,
    prodUrl: prodUrl_0_2_0_3,
    path: "/go/pcm/seo/path",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoPath",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书详情页↗](https://yapi.yuewen.com/project/3297/interface/api/292680) 的 **请求函数**
 *
 * @分类 [站群↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38317)
 * @请求头 `GET /go/pcm/seo/path`
 * @更新时间 `2024-09-23 11:19:59`
 */ const goPcmSeoPath = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoPathRequestConfig, requestData), ...args);
};
goPcmSeoPath.requestConfig = goPcmSeoPathRequestConfig;
const mockUrl_0_2_0_4 = "https://yapi.yuewen.com/mock/3297";
const devUrl_0_2_0_4 = "https://oawww.webnovel.com";
const prodUrl_0_2_0_4 = "https://www.webnovel.com";
const dataKey_0_2_0_4 = "data";
/**
 * 接口 [关键词热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/293812) 的 **请求配置**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/list`
 * @更新时间 `2024-10-22 16:49:30`
 */ const goPcmSeoCrTopicListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: "/go/pcm/seo/cr/topic/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [
        "cate",
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCrTopicList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [关键词热词列表↗](https://yapi.yuewen.com/project/3297/interface/api/293812) 的 **请求函数**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/list`
 * @更新时间 `2024-10-22 16:49:30`
 */ const goPcmSeoCrTopicList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoCrTopicListRequestConfig, requestData), ...args);
};
goPcmSeoCrTopicList.requestConfig = goPcmSeoCrTopicListRequestConfig;
/**
 * 接口 [关键词详情↗](https://yapi.yuewen.com/project/3297/interface/api/293819) 的 **请求配置**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/detail`
 * @更新时间 `2024-10-22 16:49:23`
 */ const goPcmSeoCrTopicDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: "/go/pcm/seo/cr/topic/detail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [
        "topicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCrTopicDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [关键词详情↗](https://yapi.yuewen.com/project/3297/interface/api/293819) 的 **请求函数**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/detail`
 * @更新时间 `2024-10-22 16:49:23`
 */ const goPcmSeoCrTopicDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoCrTopicDetailRequestConfig, requestData), ...args);
};
goPcmSeoCrTopicDetail.requestConfig = goPcmSeoCrTopicDetailRequestConfig;
/**
 * 接口 [关键词随机列表↗](https://yapi.yuewen.com/project/3297/interface/api/294002) 的 **请求配置**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/random`
 * @更新时间 `2024-10-23 17:14:52`
 */ const goPcmSeoCrTopicRandomRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_2_0_4,
    devUrl: devUrl_0_2_0_4,
    prodUrl: prodUrl_0_2_0_4,
    path: "/go/pcm/seo/cr/topic/random",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_2_0_4,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoCrTopicRandom",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [关键词随机列表↗](https://yapi.yuewen.com/project/3297/interface/api/294002) 的 **请求函数**
 *
 * @分类 [cr关键词↗](https://yapi.yuewen.com/project/3297/interface/api/cat_38652)
 * @请求头 `GET /go/pcm/seo/cr/topic/random`
 * @更新时间 `2024-10-23 17:14:52`
 */ const goPcmSeoCrTopicRandom = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoCrTopicRandomRequestConfig, requestData), ...args);
};
goPcmSeoCrTopicRandom.requestConfig = goPcmSeoCrTopicRandomRequestConfig;
const mockUrl_0_1_0_0 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_0 = "https://oam.webnovel.com";
const prodUrl_0_1_0_0 = "https://m.webnovel.com";
const dataKey_0_1_0_0 = "data";
/**
 * 接口 [获取所有排行榜信息↗](https://yapi.yuewen.com/project/28/interface/api/60857) 的 **请求配置**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getAllRank`
 * @更新时间 `2021-01-14 10:26:15`
 */ const ajaxRankingGetAllRankRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: "/ajax/ranking/getAllRank",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRankingGetAllRank",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取所有排行榜信息↗](https://yapi.yuewen.com/project/28/interface/api/60857) 的 **请求函数**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getAllRank`
 * @更新时间 `2021-01-14 10:26:15`
 */ const ajaxRankingGetAllRank = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxRankingGetAllRankRequestConfig, requestData), ...args);
};
ajaxRankingGetAllRank.requestConfig = ajaxRankingGetAllRankRequestConfig;
/**
 * 接口 [获取某一个排行↗](https://yapi.yuewen.com/project/28/interface/api/60859) 的 **请求配置**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getRanking`
 * @更新时间 `2021-01-14 10:24:05`
 */ const ajaxRankingGetRankingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_0,
    devUrl: devUrl_0_1_0_0,
    prodUrl: prodUrl_0_1_0_0,
    path: "/ajax/ranking/getRanking",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_0,
    paramNames: [],
    queryNames: [
        "rankId",
        "timeType",
        "novelType",
        "categoryType",
        "listType",
        "language",
        "pageIndex",
        "bookType",
        "sex",
        "bookStatus"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRankingGetRanking",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取某一个排行↗](https://yapi.yuewen.com/project/28/interface/api/60859) 的 **请求函数**
 *
 * @分类 [rank↗](https://yapi.yuewen.com/project/28/interface/api/cat_10830)
 * @请求头 `GET /ajax/ranking/getRanking`
 * @更新时间 `2021-01-14 10:24:05`
 */ const ajaxRankingGetRanking = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxRankingGetRankingRequestConfig, requestData), ...args);
};
ajaxRankingGetRanking.requestConfig = ajaxRankingGetRankingRequestConfig;
const mockUrl_0_1_0_1 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_1 = "https://oam.webnovel.com";
const prodUrl_0_1_0_1 = "https://m.webnovel.com";
const dataKey_0_1_0_1 = "data";
/**
 * 接口 [lastPage - 阅读末页(go)↗](https://yapi.yuewen.com/project/28/interface/api/76475) 的 **请求配置**
 *
 * @分类 [Chapter 章节相关接口↗](https://yapi.yuewen.com/project/28/interface/api/cat_11093)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2020-04-17 15:18:35`
 */ const goPcmReadingLastPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_1,
    devUrl: devUrl_0_1_0_1,
    prodUrl: prodUrl_0_1_0_1,
    path: "/go/pcm/reading/lastPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_1,
    paramNames: [],
    queryNames: [
        "itemId",
        "itemType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingLastPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [lastPage - 阅读末页(go)↗](https://yapi.yuewen.com/project/28/interface/api/76475) 的 **请求函数**
 *
 * @分类 [Chapter 章节相关接口↗](https://yapi.yuewen.com/project/28/interface/api/cat_11093)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2020-04-17 15:18:35`
 */ const goPcmReadingLastPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadingLastPageRequestConfig, requestData), ...args);
};
goPcmReadingLastPage.requestConfig = goPcmReadingLastPageRequestConfig;
const mockUrl_0_1_0_2 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_2 = "https://oam.webnovel.com";
const prodUrl_0_1_0_2 = "https://m.webnovel.com";
const dataKey_0_1_0_2 = "data";
/**
 * 接口 [Badge detail↗](https://yapi.yuewen.com/project/28/interface/api/23) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/badge/getBadgeDetail`
 * @更新时间 `2020-07-14 15:19:04`
 */ const ajaxBadgeGetBadgeDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/badge/getBadgeDetail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [
        "badgeId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBadgeGetBadgeDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Badge detail↗](https://yapi.yuewen.com/project/28/interface/api/23) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/badge/getBadgeDetail`
 * @更新时间 `2020-07-14 15:19:04`
 */ const ajaxBadgeGetBadgeDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBadgeGetBadgeDetailRequestConfig, requestData), ...args);
};
ajaxBadgeGetBadgeDetail.requestConfig = ajaxBadgeGetBadgeDetailRequestConfig;
/**
 * 接口 [My badges↗](https://yapi.yuewen.com/project/28/interface/api/30) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/Badge/getMyBadges`
 * @更新时间 `2018-12-26 16:51:21`
 */ const ajaxBadgeGetMyBadgesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/Badge/getMyBadges",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBadgeGetMyBadges",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [My badges↗](https://yapi.yuewen.com/project/28/interface/api/30) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/Badge/getMyBadges`
 * @更新时间 `2018-12-26 16:51:21`
 */ const ajaxBadgeGetMyBadges = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBadgeGetMyBadgesRequestConfig, requestData), ...args);
};
ajaxBadgeGetMyBadges.requestConfig = ajaxBadgeGetMyBadgesRequestConfig;
/**
 * 接口 [User level list↗](https://yapi.yuewen.com/project/28/interface/api/79) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/UserLevel/listAjax`
 * @更新时间 `2018-12-26 16:54:41`
 */ const ajaxUserLevelListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/UserLevel/listAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserLevelListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [User level list↗](https://yapi.yuewen.com/project/28/interface/api/79) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/UserLevel/listAjax`
 * @更新时间 `2018-12-26 16:54:41`
 */ const ajaxUserLevelListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxUserLevelListAjaxRequestConfig, requestData), ...args);
};
ajaxUserLevelListAjax.requestConfig = ajaxUserLevelListAjaxRequestConfig;
/**
 * 接口 [通知直出-Page（M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/128) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /notification/notificationListPage`
 * @更新时间 `2019-05-10 16:55:24`
 */ const notificationNotificationListPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/notification/notificationListPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "notificationNotificationListPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [通知直出-Page（M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/128) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /notification/notificationListPage`
 * @更新时间 `2019-05-10 16:55:24`
 */ const notificationNotificationListPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(notificationNotificationListPageRequestConfig, requestData), ...args);
};
notificationNotificationListPage.requestConfig = notificationNotificationListPageRequestConfig;
/**
 * 接口 [分页拉取通知-Ajax （M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/135) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/notification/notificationListAjax`
 * @更新时间 `2019-05-10 16:55:11`
 */ const ajaxNotificationNotificationListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/notification/notificationListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationNotificationListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [分页拉取通知-Ajax （M3.7.0废弃）↗](https://yapi.yuewen.com/project/28/interface/api/135) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/notification/notificationListAjax`
 * @更新时间 `2019-05-10 16:55:11`
 */ const ajaxNotificationNotificationListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxNotificationNotificationListAjaxRequestConfig, requestData), ...args);
};
ajaxNotificationNotificationListAjax.requestConfig = ajaxNotificationNotificationListAjaxRequestConfig;
/**
 * 接口 [领取SS(M3.7.0废弃)↗](https://yapi.yuewen.com/project/28/interface/api/386) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /notification/getSSAjax`
 * @更新时间 `2019-05-10 16:54:57`
 */ const notificationGetSsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/notification/getSSAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "notificationGetSsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [领取SS(M3.7.0废弃)↗](https://yapi.yuewen.com/project/28/interface/api/386) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /notification/getSSAjax`
 * @更新时间 `2019-05-10 16:54:57`
 */ const notificationGetSsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(notificationGetSsAjaxRequestConfig, requestData), ...args);
};
notificationGetSsAjax.requestConfig = notificationGetSsAjaxRequestConfig;
/**
 * 接口 [个人主页直出↗](https://yapi.yuewen.com/project/28/interface/api/440) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/profile/userPage`
 * @更新时间 `2021-03-16 10:13:22`
 */ const pageProfileUserPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/page/profile/userPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageProfileUserPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [个人主页直出↗](https://yapi.yuewen.com/project/28/interface/api/440) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/profile/userPage`
 * @更新时间 `2021-03-16 10:13:22`
 */ const pageProfileUserPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageProfileUserPageRequestConfig, requestData), ...args);
};
pageProfileUserPage.requestConfig = pageProfileUserPageRequestConfig;
/**
 * 接口 [消息list↗](https://yapi.yuewen.com/project/28/interface/api/3221) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/message/list`
 * @更新时间 `2018-12-26 16:51:28`
 */ const ajaxMessageListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/message/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxMessageList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [消息list↗](https://yapi.yuewen.com/project/28/interface/api/3221) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/message/list`
 * @更新时间 `2018-12-26 16:51:28`
 */ const ajaxMessageList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxMessageListRequestConfig, requestData), ...args);
};
ajaxMessageList.requestConfig = ajaxMessageListRequestConfig;
/**
 * 接口 [UserInfoAjax↗](https://yapi.yuewen.com/project/28/interface/api/3880) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/user/UserInfoAjax`
 * @更新时间 `2020-12-03 17:32:25`
 */ const ajaxUserUserInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/user/UserInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserUserInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [UserInfoAjax↗](https://yapi.yuewen.com/project/28/interface/api/3880) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/user/UserInfoAjax`
 * @更新时间 `2020-12-03 17:32:25`
 */ const ajaxUserUserInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxUserUserInfoAjaxRequestConfig, requestData), ...args);
};
ajaxUserUserInfoAjax.requestConfig = ajaxUserUserInfoAjaxRequestConfig;
/**
 * 接口 [user\/UserInfoReact↗](https://yapi.yuewen.com/project/28/interface/api/10161) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/user/UserInfoReact`
 * @更新时间 `2020-02-18 11:33:21`
 */ const pageUserUserInfoReactRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/page/user/UserInfoReact",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageUserUserInfoReact",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [user\/UserInfoReact↗](https://yapi.yuewen.com/project/28/interface/api/10161) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /page/user/UserInfoReact`
 * @更新时间 `2020-02-18 11:33:21`
 */ const pageUserUserInfoReact = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageUserUserInfoReactRequestConfig, requestData), ...args);
};
pageUserUserInfoReact.requestConfig = pageUserUserInfoReactRequestConfig;
/**
 * 接口 [个人主页↗](https://yapi.yuewen.com/project/28/interface/api/11584) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/profile/userPage`
 * @更新时间 `2018-12-26 16:55:42`
 */ const ajaxProfileUserPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/profile/userPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxProfileUserPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [个人主页↗](https://yapi.yuewen.com/project/28/interface/api/11584) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `GET /ajax/profile/userPage`
 * @更新时间 `2018-12-26 16:55:42`
 */ const ajaxProfileUserPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxProfileUserPageRequestConfig, requestData), ...args);
};
ajaxProfileUserPage.requestConfig = ajaxProfileUserPageRequestConfig;
/**
 * 接口 [获取上传cos密钥↗](https://yapi.yuewen.com/project/28/interface/api/118074) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /utils/get-cos-temp-key`
 * @更新时间 `2024-09-04 10:22:05`
 */ const utilsGetCosTempKeyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/utils/get-cos-temp-key",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "utilsGetCosTempKey",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取上传cos密钥↗](https://yapi.yuewen.com/project/28/interface/api/118074) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /utils/get-cos-temp-key`
 * @更新时间 `2024-09-04 10:22:05`
 */ const utilsGetCosTempKey = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(utilsGetCosTempKeyRequestConfig, requestData), ...args);
};
utilsGetCosTempKey.requestConfig = utilsGetCosTempKeyRequestConfig;
/**
 * 接口 [设置用户头像↗](https://yapi.yuewen.com/project/28/interface/api/177923) 的 **请求配置**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /ajax/user/setUserAvatarAjax`
 * @更新时间 `2020-12-04 14:53:14`
 */ const ajaxUserSetUserAvatarAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_2,
    devUrl: devUrl_0_1_0_2,
    prodUrl: prodUrl_0_1_0_2,
    path: "/ajax/user/setUserAvatarAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserSetUserAvatarAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [设置用户头像↗](https://yapi.yuewen.com/project/28/interface/api/177923) 的 **请求函数**
 *
 * @分类 [User↗](https://yapi.yuewen.com/project/28/interface/api/cat_1158)
 * @请求头 `POST /ajax/user/setUserAvatarAjax`
 * @更新时间 `2020-12-04 14:53:14`
 */ const ajaxUserSetUserAvatarAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxUserSetUserAvatarAjaxRequestConfig, requestData), ...args);
};
ajaxUserSetUserAvatarAjax.requestConfig = ajaxUserSetUserAvatarAjaxRequestConfig;
const mockUrl_0_1_0_3 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_3 = "https://oam.webnovel.com";
const prodUrl_0_1_0_3 = "https://m.webnovel.com";
const dataKey_0_1_0_3 = "data";
/**
 * 接口 [拉取设置页信息↗](https://yapi.yuewen.com/project/28/interface/api/501) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/infoAjax`
 * @更新时间 `2020-06-01 13:53:53`
 */ const ajaxSettingsInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/infoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取设置页信息↗](https://yapi.yuewen.com/project/28/interface/api/501) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/infoAjax`
 * @更新时间 `2020-06-01 13:53:53`
 */ const ajaxSettingsInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsInfoAjaxRequestConfig, requestData), ...args);
};
ajaxSettingsInfoAjax.requestConfig = ajaxSettingsInfoAjaxRequestConfig;
/**
 * 接口 [检测用户名↗](https://yapi.yuewen.com/project/28/interface/api/506) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/checkNameAjax`
 * @更新时间 `2024-08-09 15:41:53`
 */ const ajaxSettingsCheckNameAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/checkNameAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsCheckNameAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [检测用户名↗](https://yapi.yuewen.com/project/28/interface/api/506) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/checkNameAjax`
 * @更新时间 `2024-08-09 15:41:53`
 */ const ajaxSettingsCheckNameAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsCheckNameAjaxRequestConfig, requestData), ...args);
};
ajaxSettingsCheckNameAjax.requestConfig = ajaxSettingsCheckNameAjaxRequestConfig;
/**
 * 接口 [第一次添加邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4319) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/FirstAddEmail`
 * @更新时间 `2020-12-18 11:36:38`
 */ const ajaxSettingsFirstAddEmailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/FirstAddEmail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsFirstAddEmail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [第一次添加邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4319) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/FirstAddEmail`
 * @更新时间 `2020-12-18 11:36:38`
 */ const ajaxSettingsFirstAddEmail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsFirstAddEmailRequestConfig, requestData), ...args);
};
ajaxSettingsFirstAddEmail.requestConfig = ajaxSettingsFirstAddEmailRequestConfig;
/**
 * 接口 [给老邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4333) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/SendCaptchaOEmail`
 * @更新时间 `2018-06-26 16:54:54`
 */ const ajaxSettingsSendCaptchaOEmailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/SendCaptchaOEmail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsSendCaptchaOEmail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [给老邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4333) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/SendCaptchaOEmail`
 * @更新时间 `2018-06-26 16:54:54`
 */ const ajaxSettingsSendCaptchaOEmail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsSendCaptchaOEmailRequestConfig, requestData), ...args);
};
ajaxSettingsSendCaptchaOEmail.requestConfig = ajaxSettingsSendCaptchaOEmailRequestConfig;
/**
 * 接口 [验证邮箱的验证码↗](https://yapi.yuewen.com/project/28/interface/api/4354) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/VerifyCaptcha`
 * @更新时间 `2018-06-25 15:23:55`
 */ const ajaxSettingsVerifyCaptchaRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/VerifyCaptcha",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsVerifyCaptcha",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [验证邮箱的验证码↗](https://yapi.yuewen.com/project/28/interface/api/4354) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/VerifyCaptcha`
 * @更新时间 `2018-06-25 15:23:55`
 */ const ajaxSettingsVerifyCaptcha = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsVerifyCaptchaRequestConfig, requestData), ...args);
};
ajaxSettingsVerifyCaptcha.requestConfig = ajaxSettingsVerifyCaptchaRequestConfig;
/**
 * 接口 [给新邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4356) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/setting/SendCaptchaNEmail`
 * @更新时间 `2018-06-26 16:57:22`
 */ const ajaxSettingSendCaptchaNEmailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/setting/SendCaptchaNEmail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingSendCaptchaNEmail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [给新邮箱发送验证码↗](https://yapi.yuewen.com/project/28/interface/api/4356) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/setting/SendCaptchaNEmail`
 * @更新时间 `2018-06-26 16:57:22`
 */ const ajaxSettingSendCaptchaNEmail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingSendCaptchaNEmailRequestConfig, requestData), ...args);
};
ajaxSettingSendCaptchaNEmail.requestConfig = ajaxSettingSendCaptchaNEmailRequestConfig;
/**
 * 接口 [确认修改邮箱↗](https://yapi.yuewen.com/project/28/interface/api/4385) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/ModifyMail`
 * @更新时间 `2018-06-26 14:03:33`
 */ const ajaxSettingsModifyMailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/ModifyMail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsModifyMail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [确认修改邮箱↗](https://yapi.yuewen.com/project/28/interface/api/4385) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/ModifyMail`
 * @更新时间 `2018-06-26 14:03:33`
 */ const ajaxSettingsModifyMail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsModifyMailRequestConfig, requestData), ...args);
};
ajaxSettingsModifyMail.requestConfig = ajaxSettingsModifyMailRequestConfig;
/**
 * 接口 [保存用户基本信息↗](https://yapi.yuewen.com/project/28/interface/api/6524) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/modifyUserInfoAjax`
 * @更新时间 `2020-12-15 16:15:56`
 */ const ajaxSettingsModifyUserInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/modifyUserInfoAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsModifyUserInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [保存用户基本信息↗](https://yapi.yuewen.com/project/28/interface/api/6524) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `POST /ajax/settings/modifyUserInfoAjax`
 * @更新时间 `2020-12-15 16:15:56`
 */ const ajaxSettingsModifyUserInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsModifyUserInfoAjaxRequestConfig, requestData), ...args);
};
ajaxSettingsModifyUserInfoAjax.requestConfig = ajaxSettingsModifyUserInfoAjaxRequestConfig;
/**
 * 接口 [校验邮箱是否被用过↗](https://yapi.yuewen.com/project/28/interface/api/7102) 的 **请求配置**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/CheckEmailAjax`
 * @更新时间 `2018-07-09 14:38:45`
 */ const ajaxSettingsCheckEmailAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_3,
    devUrl: devUrl_0_1_0_3,
    prodUrl: prodUrl_0_1_0_3,
    path: "/ajax/settings/CheckEmailAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_3,
    paramNames: [],
    queryNames: [
        "email"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSettingsCheckEmailAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [校验邮箱是否被用过↗](https://yapi.yuewen.com/project/28/interface/api/7102) 的 **请求函数**
 *
 * @分类 [User - settings↗](https://yapi.yuewen.com/project/28/interface/api/cat_1179)
 * @请求头 `GET /ajax/settings/CheckEmailAjax`
 * @更新时间 `2018-07-09 14:38:45`
 */ const ajaxSettingsCheckEmailAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSettingsCheckEmailAjaxRequestConfig, requestData), ...args);
};
ajaxSettingsCheckEmailAjax.requestConfig = ajaxSettingsCheckEmailAjaxRequestConfig;
const mockUrl_0_1_0_4 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_4 = "https://oam.webnovel.com";
const prodUrl_0_1_0_4 = "https://m.webnovel.com";
const dataKey_0_1_0_4 = "data";
/**
 * 接口 [拉取章评列表-Page↗](https://yapi.yuewen.com/project/28/interface/api/114) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /chapterReview/index`
 * @更新时间 `2018-08-01 10:40:27`
 */ const chapterReviewIndexRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/chapterReview/index",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "orderType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "chapterReviewIndex",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取章评列表-Page↗](https://yapi.yuewen.com/project/28/interface/api/114) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /chapterReview/index`
 * @更新时间 `2018-08-01 10:40:27`
 */ const chapterReviewIndex = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(chapterReviewIndexRequestConfig, requestData), ...args);
};
chapterReviewIndex.requestConfig = chapterReviewIndexRequestConfig;
/**
 * 接口 [拉取章评列表-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/121) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /ajax/chapterReview/list`
 * @更新时间 `2020-07-01 16:44:44`
 */ const ajaxChapterReviewListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/ajax/chapterReview/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "pageIndex",
        "orderType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterReviewList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取章评列表-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/121) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /ajax/chapterReview/list`
 * @更新时间 `2020-07-01 16:44:44`
 */ const ajaxChapterReviewList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxChapterReviewListRequestConfig, requestData), ...args);
};
ajaxChapterReviewList.requestConfig = ajaxChapterReviewListRequestConfig;
/**
 * 接口 [添加章评↗](https://yapi.yuewen.com/project/28/interface/api/3482) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `POST /ajax/chapterReview/add`
 * @更新时间 `2018-05-09 10:23:22`
 */ const ajaxChapterReviewAddRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/ajax/chapterReview/add",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterReviewAdd",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加章评↗](https://yapi.yuewen.com/project/28/interface/api/3482) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `POST /ajax/chapterReview/add`
 * @更新时间 `2018-05-09 10:23:22`
 */ const ajaxChapterReviewAdd = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxChapterReviewAddRequestConfig, requestData), ...args);
};
ajaxChapterReviewAdd.requestConfig = ajaxChapterReviewAddRequestConfig;
/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/28/interface/api/119889) 的 **请求配置**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2020-08-03 13:03:43`
 */ const goPcmChapterReviewGetReviewListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_4,
    devUrl: devUrl_0_1_0_4,
    prodUrl: prodUrl_0_1_0_4,
    path: "/go/pcm/chapterReview/getReviewList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewGetReviewList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/28/interface/api/119889) 的 **请求函数**
 *
 * @分类 [comments↗](https://yapi.yuewen.com/project/28/interface/api/cat_123)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2020-08-03 13:03:43`
 */ const goPcmChapterReviewGetReviewList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterReviewGetReviewListRequestConfig, requestData), ...args);
};
goPcmChapterReviewGetReviewList.requestConfig = goPcmChapterReviewGetReviewListRequestConfig;
const mockUrl_0_1_0_5 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_5 = "https://oam.webnovel.com";
const prodUrl_0_1_0_5 = "https://m.webnovel.com";
const dataKey_0_1_0_5 = "data";
/**
 * 接口 [试读列表↗](https://yapi.yuewen.com/project/28/interface/api/68427) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2019-12-31 15:42:09`
 */ const goPcmExpectTrailerListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: "/go/pcm/expect/trailerList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectTrailerList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [试读列表↗](https://yapi.yuewen.com/project/28/interface/api/68427) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2019-12-31 15:42:09`
 */ const goPcmExpectTrailerList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmExpectTrailerListRequestConfig, requestData), ...args);
};
goPcmExpectTrailerList.requestConfig = goPcmExpectTrailerListRequestConfig;
/**
 * 接口 [ES列表↗](https://yapi.yuewen.com/project/28/interface/api/76443) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2020-04-17 13:28:32`
 */ const goPcmExpectEsListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_5,
    devUrl: devUrl_0_1_0_5,
    prodUrl: prodUrl_0_1_0_5,
    path: "/go/pcm/expect/esList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectEsList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ES列表↗](https://yapi.yuewen.com/project/28/interface/api/76443) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/28/interface/api/cat_12547)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2020-04-17 13:28:32`
 */ const goPcmExpectEsList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmExpectEsListRequestConfig, requestData), ...args);
};
goPcmExpectEsList.requestConfig = goPcmExpectEsListRequestConfig;
const mockUrl_0_1_0_6 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_6 = "https://oam.webnovel.com";
const prodUrl_0_1_0_6 = "https://m.webnovel.com";
const dataKey_0_1_0_6 = "data";
/**
 * 接口 [geInfo↗](https://yapi.yuewen.com/project/28/interface/api/69896) 的 **请求配置**
 *
 * @分类 [membership 会员卡↗](https://yapi.yuewen.com/project/28/interface/api/cat_12704)
 * @请求头 `GET /ajax/membership/getInfoAjax`
 * @更新时间 `2020-04-08 14:25:10`
 */ const ajaxMembershipGetInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_6,
    devUrl: devUrl_0_1_0_6,
    prodUrl: prodUrl_0_1_0_6,
    path: "/ajax/membership/getInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxMembershipGetInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [geInfo↗](https://yapi.yuewen.com/project/28/interface/api/69896) 的 **请求函数**
 *
 * @分类 [membership 会员卡↗](https://yapi.yuewen.com/project/28/interface/api/cat_12704)
 * @请求头 `GET /ajax/membership/getInfoAjax`
 * @更新时间 `2020-04-08 14:25:10`
 */ const ajaxMembershipGetInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxMembershipGetInfoAjaxRequestConfig, requestData), ...args);
};
ajaxMembershipGetInfoAjax.requestConfig = ajaxMembershipGetInfoAjaxRequestConfig;
const mockUrl_0_1_0_7 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_7 = "https://oam.webnovel.com";
const prodUrl_0_1_0_7 = "https://m.webnovel.com";
const dataKey_0_1_0_7 = "data";
/**
 * 接口 [智能推荐二级页↗](https://yapi.yuewen.com/project/28/interface/api/74884) 的 **请求配置**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /ajax/recommend/list`
 * @更新时间 `2020-04-02 14:07:41`
 */ const ajaxRecommendListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: "/ajax/recommend/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [
        "recommendType",
        "bookId",
        "pageIndex",
        "bookType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRecommendList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [智能推荐二级页↗](https://yapi.yuewen.com/project/28/interface/api/74884) 的 **请求函数**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /ajax/recommend/list`
 * @更新时间 `2020-04-02 14:07:41`
 */ const ajaxRecommendList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxRecommendListRequestConfig, requestData), ...args);
};
ajaxRecommendList.requestConfig = ajaxRecommendListRequestConfig;
/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/28/interface/api/76473) 的 **请求配置**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2020-09-01 15:32:39`
 */ const goPcmRecommendGetRecommendListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_7,
    devUrl: devUrl_0_1_0_7,
    prodUrl: prodUrl_0_1_0_7,
    path: "/go/pcm/recommend/getRecommendList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_7,
    paramNames: [],
    queryNames: [
        "type",
        "bookId",
        "pageIndex",
        "bookType",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendGetRecommendList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/28/interface/api/76473) 的 **请求函数**
 *
 * @分类 [Recommend-智能推荐↗](https://yapi.yuewen.com/project/28/interface/api/cat_13468)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2020-09-01 15:32:39`
 */ const goPcmRecommendGetRecommendList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRecommendGetRecommendListRequestConfig, requestData), ...args);
};
goPcmRecommendGetRecommendList.requestConfig = goPcmRecommendGetRecommendListRequestConfig;
const mockUrl_0_1_0_8 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_8 = "https://oam.webnovel.com";
const prodUrl_0_1_0_8 = "https://m.webnovel.com";
const dataKey_0_1_0_8 = "data";
/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/28/interface/api/105965) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2020-07-09 15:14:04`
 */ const goPcmSeoGetTagBookListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getTagBookList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [
        "tagId",
        "tagName",
        "type",
        "pageIndex",
        "order"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetTagBookList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/28/interface/api/105965) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2020-07-09 15:14:04`
 */ const goPcmSeoGetTagBookList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGetTagBookListRequestConfig, requestData), ...args);
};
goPcmSeoGetTagBookList.requestConfig = goPcmSeoGetTagBookListRequestConfig;
/**
 * 接口 [getTagList↗](https://yapi.yuewen.com/project/28/interface/api/105966) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagList`
 * @更新时间 `2020-07-08 19:37:23`
 */ const goPcmSeoGetTagListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getTagList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [
        "tagPrefix",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetTagList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getTagList↗](https://yapi.yuewen.com/project/28/interface/api/105966) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getTagList`
 * @更新时间 `2020-07-08 19:37:23`
 */ const goPcmSeoGetTagList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGetTagListRequestConfig, requestData), ...args);
};
goPcmSeoGetTagList.requestConfig = goPcmSeoGetTagListRequestConfig;
/**
 * 接口 [getLongLinkByShortLink↗](https://yapi.yuewen.com/project/28/interface/api/135297) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getLongLinkByShortLink`
 * @更新时间 `2020-09-10 16:08:10`
 */ const goPcmSeoGetLongLinkByShortLinkRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getLongLinkByShortLink",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [
        "shortLink"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetLongLinkByShortLink",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getLongLinkByShortLink↗](https://yapi.yuewen.com/project/28/interface/api/135297) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getLongLinkByShortLink`
 * @更新时间 `2020-09-10 16:08:10`
 */ const goPcmSeoGetLongLinkByShortLink = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGetLongLinkByShortLinkRequestConfig, requestData), ...args);
};
goPcmSeoGetLongLinkByShortLink.requestConfig = goPcmSeoGetLongLinkByShortLinkRequestConfig;
/**
 * 接口 [getRandomBookList↗](https://yapi.yuewen.com/project/28/interface/api/182723) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getRandomBookList`
 * @更新时间 `2021-01-11 11:26:28`
 */ const goPcmSeoGetRandomBookListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_8,
    devUrl: devUrl_0_1_0_8,
    prodUrl: prodUrl_0_1_0_8,
    path: "/go/pcm/seo/getRandomBookList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetRandomBookList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getRandomBookList↗](https://yapi.yuewen.com/project/28/interface/api/182723) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/28/interface/api/cat_16661)
 * @请求头 `GET /go/pcm/seo/getRandomBookList`
 * @更新时间 `2021-01-11 11:26:28`
 */ const goPcmSeoGetRandomBookList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGetRandomBookListRequestConfig, requestData), ...args);
};
goPcmSeoGetRandomBookList.requestConfig = goPcmSeoGetRandomBookListRequestConfig;
const mockUrl_0_1_0_9 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_9 = "https://oam.webnovel.com";
const prodUrl_0_1_0_9 = "https://m.webnovel.com";
const dataKey_0_1_0_9 = "data";
/**
 * 接口 [getApplyRecord-获取申请状态和内容↗](https://yapi.yuewen.com/project/28/interface/api/117303) 的 **请求配置**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `GET /go/pcm/moderator/getApplyRecord`
 * @更新时间 `2020-08-04 11:19:53`
 */ const goPcmModeratorGetApplyRecordRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: "/go/pcm/moderator/getApplyRecord",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmModeratorGetApplyRecord",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getApplyRecord-获取申请状态和内容↗](https://yapi.yuewen.com/project/28/interface/api/117303) 的 **请求函数**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `GET /go/pcm/moderator/getApplyRecord`
 * @更新时间 `2020-08-04 11:19:53`
 */ const goPcmModeratorGetApplyRecord = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmModeratorGetApplyRecordRequestConfig, requestData), ...args);
};
goPcmModeratorGetApplyRecord.requestConfig = goPcmModeratorGetApplyRecordRequestConfig;
/**
 * 接口 [applyModerator - 申请版主↗](https://yapi.yuewen.com/project/28/interface/api/117314) 的 **请求配置**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `POST /go/pcm/moderator/applyModerator `
 * @更新时间 `2020-08-04 11:20:26`
 */ const goPcmModeratorApplyModeratorRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_9,
    devUrl: devUrl_0_1_0_9,
    prodUrl: prodUrl_0_1_0_9,
    path: "/go/pcm/moderator/applyModerator ",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_9,
    paramNames: [],
    queryNames: [
        "bookId",
        "applyReason"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmModeratorApplyModerator",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [applyModerator - 申请版主↗](https://yapi.yuewen.com/project/28/interface/api/117314) 的 **请求函数**
 *
 * @分类 [Moderator-版主↗](https://yapi.yuewen.com/project/28/interface/api/cat_17553)
 * @请求头 `POST /go/pcm/moderator/applyModerator `
 * @更新时间 `2020-08-04 11:20:26`
 */ const goPcmModeratorApplyModerator = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmModeratorApplyModeratorRequestConfig, requestData), ...args);
};
goPcmModeratorApplyModerator.requestConfig = goPcmModeratorApplyModeratorRequestConfig;
const mockUrl_0_1_0_11 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_11 = "https://oam.webnovel.com";
const prodUrl_0_1_0_11 = "https://m.webnovel.com";
const dataKey_0_1_0_11 = "data";
/**
 * 接口 [ 评论emoji映射Map↗](https://yapi.yuewen.com/project/28/interface/api/118090) 的 **请求配置**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-08-05 13:56:40`
 */ const goPcmEmojiGetEmojiRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: "/go/pcm/emoji/getEmoji",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmEmojiGetEmoji",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ 评论emoji映射Map↗](https://yapi.yuewen.com/project/28/interface/api/118090) 的 **请求函数**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-08-05 13:56:40`
 */ const goPcmEmojiGetEmoji = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmEmojiGetEmojiRequestConfig, requestData), ...args);
};
goPcmEmojiGetEmoji.requestConfig = goPcmEmojiGetEmojiRequestConfig;
/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/28/interface/api/119878) 的 **请求配置**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-08-03 11:36:11`
 */ const goPcmBookReviewSetTopRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: "/go/pcm/bookReview/setTop",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewSetTop",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/28/interface/api/119878) 的 **请求函数**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-08-03 11:36:11`
 */ const goPcmBookReviewSetTop = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewSetTopRequestConfig, requestData), ...args);
};
goPcmBookReviewSetTop.requestConfig = goPcmBookReviewSetTopRequestConfig;
/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/28/interface/api/119886) 的 **请求配置**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-08-03 11:36:17`
 */ const goPcmBookReviewEssenceRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_11,
    devUrl: devUrl_0_1_0_11,
    prodUrl: prodUrl_0_1_0_11,
    path: "/go/pcm/bookReview/essence",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewEssence",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/28/interface/api/119886) 的 **请求函数**
 *
 * @分类 [bookReview 书评↗](https://yapi.yuewen.com/project/28/interface/api/cat_17761)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-08-03 11:36:17`
 */ const goPcmBookReviewEssence = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewEssenceRequestConfig, requestData), ...args);
};
goPcmBookReviewEssence.requestConfig = goPcmBookReviewEssenceRequestConfig;
const mockUrl_0_1_0_12 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_12 = "https://oam.webnovel.com";
const prodUrl_0_1_0_12 = "https://m.webnovel.com";
const dataKey_0_1_0_12 = "data";
/**
 * 接口 [获取用户主页（主客态）\/go\/pcm\/user\/get-home-page↗](https://yapi.yuewen.com/project/28/interface/api/132518) 的 **请求配置**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2020-09-01 14:39:28`
 */ const goPcmUserGetHomePageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: "/go/pcm/user/get-home-page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [
        "userId",
        "appId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetHomePage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户主页（主客态）\/go\/pcm\/user\/get-home-page↗](https://yapi.yuewen.com/project/28/interface/api/132518) 的 **请求函数**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2020-09-01 14:39:28`
 */ const goPcmUserGetHomePage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetHomePageRequestConfig, requestData), ...args);
};
goPcmUserGetHomePage.requestConfig = goPcmUserGetHomePageRequestConfig;
/**
 * 接口 [获取moments列表 \/go\/pcm\/user\/get-moment-list↗](https://yapi.yuewen.com/project/28/interface/api/132527) 的 **请求配置**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2024-08-23 16:00:21`
 */ const goPcmUserGetMomentListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_12,
    devUrl: devUrl_0_1_0_12,
    prodUrl: prodUrl_0_1_0_12,
    path: "/go/pcm/user/get-moment-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_12,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetMomentList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取moments列表 \/go\/pcm\/user\/get-moment-list↗](https://yapi.yuewen.com/project/28/interface/api/132527) 的 **请求函数**
 *
 * @分类 [个人主页【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_18526)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2024-08-23 16:00:21`
 */ const goPcmUserGetMomentList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetMomentListRequestConfig, requestData), ...args);
};
goPcmUserGetMomentList.requestConfig = goPcmUserGetMomentListRequestConfig;
const mockUrl_0_1_0_13 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_13 = "https://oam.webnovel.com";
const prodUrl_0_1_0_13 = "https://m.webnovel.com";
const dataKey_0_1_0_13 = "data";
/**
 * 接口 [get-content 获取阅读内容↗](https://yapi.yuewen.com/project/28/interface/api/166153) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21017)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2020-10-19 17:30:44`
 */ const goPcmChapterGetContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_13,
    devUrl: devUrl_0_1_0_13,
    prodUrl: prodUrl_0_1_0_13,
    path: "/go/pcm/chapter/getContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_13,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "withParagraphContent"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-content 获取阅读内容↗](https://yapi.yuewen.com/project/28/interface/api/166153) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21017)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2020-10-19 17:30:44`
 */ const goPcmChapterGetContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetContentRequestConfig, requestData), ...args);
};
goPcmChapterGetContent.requestConfig = goPcmChapterGetContentRequestConfig;
const mockUrl_0_1_0_14 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_14 = "https://oam.webnovel.com";
const prodUrl_0_1_0_14 = "https://m.webnovel.com";
const dataKey_0_1_0_14 = "data";
/**
 * 接口 [get-book-tag-list↗](https://yapi.yuewen.com/project/28/interface/api/166162) 的 **请求配置**
 *
 * @分类 [Tag 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21021)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2020-10-19 17:23:04`
 */ const goPcmTagGetBookTagListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_14,
    devUrl: devUrl_0_1_0_14,
    prodUrl: prodUrl_0_1_0_14,
    path: "/go/pcm/tag/get-book-tag-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_14,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagGetBookTagList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-book-tag-list↗](https://yapi.yuewen.com/project/28/interface/api/166162) 的 **请求函数**
 *
 * @分类 [Tag 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21021)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2020-10-19 17:23:04`
 */ const goPcmTagGetBookTagList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTagGetBookTagListRequestConfig, requestData), ...args);
};
goPcmTagGetBookTagList.requestConfig = goPcmTagGetBookTagListRequestConfig;
const mockUrl_0_1_0_15 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_15 = "https://oam.webnovel.com";
const prodUrl_0_1_0_15 = "https://m.webnovel.com";
const dataKey_0_1_0_15 = "data";
/**
 * 接口 [get-chapter-list 拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/166163) 的 **请求配置**
 *
 * @分类 [chapter 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21027)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2020-12-23 14:16:48`
 */ const goPcmChapterGetChapterListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_15,
    devUrl: devUrl_0_1_0_15,
    prodUrl: prodUrl_0_1_0_15,
    path: "/go/pcm/chapter/get-chapter-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_15,
    paramNames: [],
    queryNames: [
        "bookId",
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetChapterList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-chapter-list 拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/166163) 的 **请求函数**
 *
 * @分类 [chapter 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21027)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2020-12-23 14:16:48`
 */ const goPcmChapterGetChapterList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetChapterListRequestConfig, requestData), ...args);
};
goPcmChapterGetChapterList.requestConfig = goPcmChapterGetChapterListRequestConfig;
const mockUrl_0_1_0_16 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_16 = "https://oam.webnovel.com";
const prodUrl_0_1_0_16 = "https://m.webnovel.com";
const dataKey_0_1_0_16 = "data";
/**
 * 接口 [get-book-detail 详情页↗](https://yapi.yuewen.com/project/28/interface/api/166165) 的 **请求配置**
 *
 * @分类 [Book - detail 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21042)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-09-10 16:41:03`
 */ const goPcmBookGetBookDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_16,
    devUrl: devUrl_0_1_0_16,
    prodUrl: prodUrl_0_1_0_16,
    path: "/go/pcm/book/get-book-detail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_16,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-book-detail 详情页↗](https://yapi.yuewen.com/project/28/interface/api/166165) 的 **请求函数**
 *
 * @分类 [Book - detail 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21042)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-09-10 16:41:03`
 */ const goPcmBookGetBookDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBookDetailRequestConfig, requestData), ...args);
};
goPcmBookGetBookDetail.requestConfig = goPcmBookGetBookDetailRequestConfig;
const mockUrl_0_1_0_17 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_17 = "https://oam.webnovel.com";
const prodUrl_0_1_0_17 = "https://m.webnovel.com";
const dataKey_0_1_0_17 = "data";
/**
 * 接口 [get-gift-info根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/166173) 的 **请求配置**
 *
 * @分类 [gift 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21048)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2020-10-22 11:18:26`
 */ const goPcmGiftGetGiftInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_17,
    devUrl: devUrl_0_1_0_17,
    prodUrl: prodUrl_0_1_0_17,
    path: "/go/pcm/gift/get-gift-info",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_17,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftGetGiftInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-gift-info根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/166173) 的 **请求函数**
 *
 * @分类 [gift 【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21048)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2020-10-22 11:18:26`
 */ const goPcmGiftGetGiftInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGiftGetGiftInfoRequestConfig, requestData), ...args);
};
goPcmGiftGetGiftInfo.requestConfig = goPcmGiftGetGiftInfoRequestConfig;
const mockUrl_0_1_0_18 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_18 = "https://oam.webnovel.com";
const prodUrl_0_1_0_18 = "https://m.webnovel.com";
const dataKey_0_1_0_18 = "data";
/**
 * 接口 [get-power-info 推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/166180) 的 **请求配置**
 *
 * @分类 [stone【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21054)
 * @请求头 `GET /go/pcm/stone/get-power-info`
 * @更新时间 `2020-10-22 11:14:37`
 */ const goPcmStoneGetPowerInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_18,
    devUrl: devUrl_0_1_0_18,
    prodUrl: prodUrl_0_1_0_18,
    path: "/go/pcm/stone/get-power-info",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_18,
    paramNames: [],
    queryNames: [
        "bookId",
        "bookType",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmStoneGetPowerInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-power-info 推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/166180) 的 **请求函数**
 *
 * @分类 [stone【go】↗](https://yapi.yuewen.com/project/28/interface/api/cat_21054)
 * @请求头 `GET /go/pcm/stone/get-power-info`
 * @更新时间 `2020-10-22 11:14:37`
 */ const goPcmStoneGetPowerInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmStoneGetPowerInfoRequestConfig, requestData), ...args);
};
goPcmStoneGetPowerInfo.requestConfig = goPcmStoneGetPowerInfoRequestConfig;
const mockUrl_0_1_0_19 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_19 = "https://oam.webnovel.com";
const prodUrl_0_1_0_19 = "https://m.webnovel.com";
const dataKey_0_1_0_19 = "data";
/**
 * 接口 [history book list↗](https://yapi.yuewen.com/project/28/interface/api/177) 的 **请求配置**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ReadingHistoryAjax`
 * @更新时间 `2019-07-22 20:22:48`
 */ const ajaxReadingHistoryReadingHistoryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: "/ajax/ReadingHistory/ReadingHistoryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReadingHistoryReadingHistoryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [history book list↗](https://yapi.yuewen.com/project/28/interface/api/177) 的 **请求函数**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ReadingHistoryAjax`
 * @更新时间 `2019-07-22 20:22:48`
 */ const ajaxReadingHistoryReadingHistoryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReadingHistoryReadingHistoryAjaxRequestConfig, requestData), ...args);
};
ajaxReadingHistoryReadingHistoryAjax.requestConfig = ajaxReadingHistoryReadingHistoryAjaxRequestConfig;
/**
 * 接口 [删除所有历史记录↗](https://yapi.yuewen.com/project/28/interface/api/282) 的 **请求配置**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ClearReadingHistoryAjax`
 * @更新时间 `2018-03-01 14:35:55`
 */ const ajaxReadingHistoryClearReadingHistoryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: "/ajax/ReadingHistory/ClearReadingHistoryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReadingHistoryClearReadingHistoryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [删除所有历史记录↗](https://yapi.yuewen.com/project/28/interface/api/282) 的 **请求函数**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/ClearReadingHistoryAjax`
 * @更新时间 `2018-03-01 14:35:55`
 */ const ajaxReadingHistoryClearReadingHistoryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReadingHistoryClearReadingHistoryAjaxRequestConfig, requestData), ...args);
};
ajaxReadingHistoryClearReadingHistoryAjax.requestConfig = ajaxReadingHistoryClearReadingHistoryAjaxRequestConfig;
/**
 * 接口 [删除某本书的历史记录↗](https://yapi.yuewen.com/project/28/interface/api/3215) 的 **请求配置**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/DeleteReadingHistoryAjax`
 * @更新时间 `2018-05-07 19:26:52`
 */ const ajaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_19,
    devUrl: devUrl_0_1_0_19,
    prodUrl: prodUrl_0_1_0_19,
    path: "/ajax/ReadingHistory/DeleteReadingHistoryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_19,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReadingHistoryDeleteReadingHistoryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [删除某本书的历史记录↗](https://yapi.yuewen.com/project/28/interface/api/3215) 的 **请求函数**
 *
 * @分类 [History↗](https://yapi.yuewen.com/project/28/interface/api/cat_235)
 * @请求头 `GET /ajax/ReadingHistory/DeleteReadingHistoryAjax`
 * @更新时间 `2018-05-07 19:26:52`
 */ const ajaxReadingHistoryDeleteReadingHistoryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig, requestData), ...args);
};
ajaxReadingHistoryDeleteReadingHistoryAjax.requestConfig = ajaxReadingHistoryDeleteReadingHistoryAjaxRequestConfig;
const mockUrl_0_1_0_20 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_20 = "https://oam.webnovel.com";
const prodUrl_0_1_0_20 = "https://m.webnovel.com";
const dataKey_0_1_0_20 = "data";
/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/28/interface/api/12268) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /page/fans/getBookFansRanking`
 * @更新时间 `2019-05-05 14:13:07`
 */ const pageFansGetBookFansRankingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/page/fans/getBookFansRanking",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageFansGetBookFansRanking",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/28/interface/api/12268) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /page/fans/getBookFansRanking`
 * @更新时间 `2019-05-05 14:13:07`
 */ const pageFansGetBookFansRanking = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageFansGetBookFansRankingRequestConfig, requestData), ...args);
};
pageFansGetBookFansRanking.requestConfig = pageFansGetBookFansRankingRequestConfig;
/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/12275) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/fans/getBookFansRankingList`
 * @更新时间 `2019-05-05 14:13:36`
 */ const ajaxFansGetBookFansRankingListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/fans/getBookFansRankingList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxFansGetBookFansRankingList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/12275) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/fans/getBookFansRankingList`
 * @更新时间 `2019-05-05 14:13:36`
 */ const ajaxFansGetBookFansRankingList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxFansGetBookFansRankingListRequestConfig, requestData), ...args);
};
ajaxFansGetBookFansRankingList.requestConfig = ajaxFansGetBookFansRankingListRequestConfig;
/**
 * 接口 [赠送礼物↗](https://yapi.yuewen.com/project/28/interface/api/12539) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `POST /ajax/gift/donateGift`
 * @更新时间 `2018-08-13 14:58:57`
 */ const ajaxGiftDonateGiftRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/gift/donateGift",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxGiftDonateGift",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [赠送礼物↗](https://yapi.yuewen.com/project/28/interface/api/12539) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `POST /ajax/gift/donateGift`
 * @更新时间 `2018-08-13 14:58:57`
 */ const ajaxGiftDonateGift = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxGiftDonateGiftRequestConfig, requestData), ...args);
};
ajaxGiftDonateGift.requestConfig = ajaxGiftDonateGiftRequestConfig;
/**
 * 接口 [根据书籍获取礼物列表↗](https://yapi.yuewen.com/project/28/interface/api/12548) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getBookGiftList`
 * @更新时间 `2018-08-20 15:15:52`
 */ const ajaxGiftGetBookGiftListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/gift/getBookGiftList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [
        "bookId",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxGiftGetBookGiftList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [根据书籍获取礼物列表↗](https://yapi.yuewen.com/project/28/interface/api/12548) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getBookGiftList`
 * @更新时间 `2018-08-20 15:15:52`
 */ const ajaxGiftGetBookGiftList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxGiftGetBookGiftListRequestConfig, requestData), ...args);
};
ajaxGiftGetBookGiftList.requestConfig = ajaxGiftGetBookGiftListRequestConfig;
/**
 * 接口 [根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/12615) 的 **请求配置**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getGiftInfo`
 * @更新时间 `2019-05-05 14:14:36`
 */ const ajaxGiftGetGiftInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_20,
    devUrl: devUrl_0_1_0_20,
    prodUrl: prodUrl_0_1_0_20,
    path: "/ajax/gift/getGiftInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_20,
    paramNames: [],
    queryNames: [
        "bookId",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxGiftGetGiftInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [根据书籍获取礼物打赏信息↗](https://yapi.yuewen.com/project/28/interface/api/12615) 的 **请求函数**
 *
 * @分类 [Gift+Fans↗](https://yapi.yuewen.com/project/28/interface/api/cat_2499)
 * @请求头 `GET /ajax/gift/getGiftInfo`
 * @更新时间 `2019-05-05 14:14:36`
 */ const ajaxGiftGetGiftInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxGiftGetGiftInfoRequestConfig, requestData), ...args);
};
ajaxGiftGetGiftInfo.requestConfig = ajaxGiftGetGiftInfoRequestConfig;
const mockUrl_0_1_0_21 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_21 = "https://oam.webnovel.com";
const prodUrl_0_1_0_21 = "https://m.webnovel.com";
const dataKey_0_1_0_21 = "data";
/**
 * 接口 [\/ajax\/comic\/list-拉取漫画列表↗](https://yapi.yuewen.com/project/28/interface/api/13939) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/list`
 * @更新时间 `2020-01-29 00:04:43`
 */ const ajaxComicListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/comic\/list-拉取漫画列表↗](https://yapi.yuewen.com/project/28/interface/api/13939) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/list`
 * @更新时间 `2020-01-29 00:04:43`
 */ const ajaxComicList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicListRequestConfig, requestData), ...args);
};
ajaxComicList.requestConfig = ajaxComicListRequestConfig;
/**
 * 接口 [\/ajax\/comic\/getComicChapterListAjax↗](https://yapi.yuewen.com/project/28/interface/api/13947) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/GetComicChapterListAjax`
 * @更新时间 `2020-02-13 15:06:35`
 */ const ajaxComicGetComicChapterListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/GetComicChapterListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "comicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetComicChapterListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/comic\/getComicChapterListAjax↗](https://yapi.yuewen.com/project/28/interface/api/13947) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/GetComicChapterListAjax`
 * @更新时间 `2020-02-13 15:06:35`
 */ const ajaxComicGetComicChapterListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicGetComicChapterListAjaxRequestConfig, requestData), ...args);
};
ajaxComicGetComicChapterListAjax.requestConfig = ajaxComicGetComicChapterListAjaxRequestConfig;
/**
 * 接口 [【已迁移】\/ajax\/comic\/getContent↗](https://yapi.yuewen.com/project/28/interface/api/13948) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getContent`
 * @更新时间 `2020-10-23 15:02:56`
 */ const ajaxComicGetContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/getContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "width"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【已迁移】\/ajax\/comic\/getContent↗](https://yapi.yuewen.com/project/28/interface/api/13948) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getContent`
 * @更新时间 `2020-10-23 15:02:56`
 */ const ajaxComicGetContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicGetContentRequestConfig, requestData), ...args);
};
ajaxComicGetContent.requestConfig = ajaxComicGetContentRequestConfig;
/**
 * 接口 [\/ajax\/Comic\/UnlockChapter↗](https://yapi.yuewen.com/project/28/interface/api/13950) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter`
 * @更新时间 `2019-11-15 14:26:38`
 */ const ajaxComicUnlockChapterRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/Comic/UnlockChapter",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "price",
        "width",
        "unlockType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicUnlockChapter",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/Comic\/UnlockChapter↗](https://yapi.yuewen.com/project/28/interface/api/13950) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter`
 * @更新时间 `2019-11-15 14:26:38`
 */ const ajaxComicUnlockChapter = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicUnlockChapterRequestConfig, requestData), ...args);
};
ajaxComicUnlockChapter.requestConfig = ajaxComicUnlockChapterRequestConfig;
/**
 * 接口 [\/ajax\/comic\/ComicDetailPage - 漫画详情页↗](https://yapi.yuewen.com/project/28/interface/api/13951) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/ComicDetailPage`
 * @更新时间 `2020-06-30 15:11:10`
 */ const ajaxComicComicDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/ComicDetailPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "comicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicComicDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/comic\/ComicDetailPage - 漫画详情页↗](https://yapi.yuewen.com/project/28/interface/api/13951) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/ComicDetailPage`
 * @更新时间 `2020-06-30 15:11:10`
 */ const ajaxComicComicDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicComicDetailPageRequestConfig, requestData), ...args);
};
ajaxComicComicDetailPage.requestConfig = ajaxComicComicDetailPageRequestConfig;
/**
 * 接口 [\/ajax\/comic\/getLatestUpdates -漫画阅读末页最近更新漫画↗](https://yapi.yuewen.com/project/28/interface/api/14163) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getLatestUpdates`
 * @更新时间 `2019-09-05 17:17:32`
 */ const ajaxComicGetLatestUpdatesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/getLatestUpdates",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetLatestUpdates",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/comic\/getLatestUpdates -漫画阅读末页最近更新漫画↗](https://yapi.yuewen.com/project/28/interface/api/14163) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/getLatestUpdates`
 * @更新时间 `2019-09-05 17:17:32`
 */ const ajaxComicGetLatestUpdates = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicGetLatestUpdatesRequestConfig, requestData), ...args);
};
ajaxComicGetLatestUpdates.requestConfig = ajaxComicGetLatestUpdatesRequestConfig;
/**
 * 接口 [每日漫画列表\/comic\/updateList↗](https://yapi.yuewen.com/project/28/interface/api/20278) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/updateList`
 * @更新时间 `2018-12-10 11:44:20`
 */ const ajaxComicUpdateListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/comic/updateList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "logTime"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicUpdateList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [每日漫画列表\/comic\/updateList↗](https://yapi.yuewen.com/project/28/interface/api/20278) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/comic/updateList`
 * @更新时间 `2018-12-10 11:44:20`
 */ const ajaxComicUpdateList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicUpdateListRequestConfig, requestData), ...args);
};
ajaxComicUpdateList.requestConfig = ajaxComicUpdateListRequestConfig;
/**
 * 接口 [\/ajax\/Comic\/UnlockChapter_copy↗](https://yapi.yuewen.com/project/28/interface/api/64468) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter_1574142720938`
 * @更新时间 `2019-11-19 13:52:00`
 */ const ajaxComicUnlockChapter_1574142720938RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/ajax/Comic/UnlockChapter_1574142720938",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "price",
        "width",
        "unlockType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicUnlockChapter_1574142720938",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/Comic\/UnlockChapter_copy↗](https://yapi.yuewen.com/project/28/interface/api/64468) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /ajax/Comic/UnlockChapter_1574142720938`
 * @更新时间 `2019-11-19 13:52:00`
 */ const ajaxComicUnlockChapter_1574142720938 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicUnlockChapter_1574142720938RequestConfig, requestData), ...args);
};
ajaxComicUnlockChapter_1574142720938.requestConfig = ajaxComicUnlockChapter_1574142720938RequestConfig;
/**
 * 接口 [\/go\/pcm\/comic\/getContent(go)↗](https://yapi.yuewen.com/project/28/interface/api/166194) 的 **请求配置**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2020-12-01 20:11:50`
 */ const goPcmComicGetContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_21,
    devUrl: devUrl_0_1_0_21,
    prodUrl: prodUrl_0_1_0_21,
    path: "/go/pcm/comic/getContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_21,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "width"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/go\/pcm\/comic\/getContent(go)↗](https://yapi.yuewen.com/project/28/interface/api/166194) 的 **请求函数**
 *
 * @分类 [Comic - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_2690)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2020-12-01 20:11:50`
 */ const goPcmComicGetContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetContentRequestConfig, requestData), ...args);
};
goPcmComicGetContent.requestConfig = goPcmComicGetContentRequestConfig;
const mockUrl_0_1_0_22 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_22 = "https://oam.webnovel.com";
const prodUrl_0_1_0_22 = "https://m.webnovel.com";
const dataKey_0_1_0_22 = "data";
/**
 * 接口 [\/ajax\/vote\/list↗](https://yapi.yuewen.com/project/28/interface/api/14239) 的 **请求配置**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `GET /ajax/vote/list`
 * @更新时间 `2019-12-30 14:55:12`
 */ const ajaxVoteListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_22,
    devUrl: devUrl_0_1_0_22,
    prodUrl: prodUrl_0_1_0_22,
    path: "/ajax/vote/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_22,
    paramNames: [],
    queryNames: [
        "gender",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxVoteList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/vote\/list↗](https://yapi.yuewen.com/project/28/interface/api/14239) 的 **请求函数**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `GET /ajax/vote/list`
 * @更新时间 `2019-12-30 14:55:12`
 */ const ajaxVoteList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxVoteListRequestConfig, requestData), ...args);
};
ajaxVoteList.requestConfig = ajaxVoteListRequestConfig;
/**
 * 接口 [\/ajax\/vote\/like↗](https://yapi.yuewen.com/project/28/interface/api/14573) 的 **请求配置**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `POST /ajax/vote/like`
 * @更新时间 `2021-04-27 20:10:46`
 */ const ajaxVoteLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_22,
    devUrl: devUrl_0_1_0_22,
    prodUrl: prodUrl_0_1_0_22,
    path: "/ajax/vote/like",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxVoteLike",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/vote\/like↗](https://yapi.yuewen.com/project/28/interface/api/14573) 的 **请求函数**
 *
 * @分类 [EnergyStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_2769)
 * @请求头 `POST /ajax/vote/like`
 * @更新时间 `2021-04-27 20:10:46`
 */ const ajaxVoteLike = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxVoteLikeRequestConfig, requestData), ...args);
};
ajaxVoteLike.requestConfig = ajaxVoteLikeRequestConfig;
const mockUrl_0_1_0_23 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_23 = "https://oam.webnovel.com";
const prodUrl_0_1_0_23 = "https://m.webnovel.com";
const dataKey_0_1_0_23 = "data";
/**
 * 接口 [书评list↗](https://yapi.yuewen.com/project/28/interface/api/289) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewsAjax`
 * @更新时间 `2021-05-08 18:18:55`
 */ const ajaxReviewGetReviewsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/GetReviewsAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "bookId",
        "bookScore",
        "orderBy"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewGetReviewsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书评list↗](https://yapi.yuewen.com/project/28/interface/api/289) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewsAjax`
 * @更新时间 `2021-05-08 18:18:55`
 */ const ajaxReviewGetReviewsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewGetReviewsAjaxRequestConfig, requestData), ...args);
};
ajaxReviewGetReviewsAjax.requestConfig = ajaxReviewGetReviewsAjaxRequestConfig;
/**
 * 接口 [书评点赞↗](https://yapi.yuewen.com/project/28/interface/api/359) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewLikeAjax`
 * @更新时间 `2018-06-28 17:46:52`
 */ const ajaxReviewAddReviewLikeAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReviewLikeAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [
        "reviewId",
        "opType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewLikeAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书评点赞↗](https://yapi.yuewen.com/project/28/interface/api/359) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewLikeAjax`
 * @更新时间 `2018-06-28 17:46:52`
 */ const ajaxReviewAddReviewLikeAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewAddReviewLikeAjaxRequestConfig, requestData), ...args);
};
ajaxReviewAddReviewLikeAjax.requestConfig = ajaxReviewAddReviewLikeAjaxRequestConfig;
/**
 * 接口 [书评详情【废弃】↗](https://yapi.yuewen.com/project/28/interface/api/377) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewDetailAjax`
 * @更新时间 `2024-08-09 14:28:26`
 */ const ajaxReviewGetReviewDetailAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/GetReviewDetailAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [
        "bookId",
        "reviewId",
        "pageIndex",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewGetReviewDetailAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书评详情【废弃】↗](https://yapi.yuewen.com/project/28/interface/api/377) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/GetReviewDetailAjax`
 * @更新时间 `2024-08-09 14:28:26`
 */ const ajaxReviewGetReviewDetailAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewGetReviewDetailAjaxRequestConfig, requestData), ...args);
};
ajaxReviewGetReviewDetailAjax.requestConfig = ajaxReviewGetReviewDetailAjaxRequestConfig;
/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/28/interface/api/2089) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/DeleteReviewAjax`
 * @更新时间 `2018-04-13 11:34:12`
 */ const ajaxReviewDeleteReviewAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/DeleteReviewAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewDeleteReviewAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/28/interface/api/2089) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/DeleteReviewAjax`
 * @更新时间 `2018-04-13 11:34:12`
 */ const ajaxReviewDeleteReviewAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewDeleteReviewAjaxRequestConfig, requestData), ...args);
};
ajaxReviewDeleteReviewAjax.requestConfig = ajaxReviewDeleteReviewAjaxRequestConfig;
/**
 * 接口 [添加书评回复↗](https://yapi.yuewen.com/project/28/interface/api/2102) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewReplyAjax`
 * @更新时间 `2019-08-07 15:22:37`
 */ const ajaxReviewAddReviewReplyAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReviewReplyAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewReplyAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加书评回复↗](https://yapi.yuewen.com/project/28/interface/api/2102) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewReplyAjax`
 * @更新时间 `2019-08-07 15:22:37`
 */ const ajaxReviewAddReviewReplyAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewAddReviewReplyAjaxRequestConfig, requestData), ...args);
};
ajaxReviewAddReviewReplyAjax.requestConfig = ajaxReviewAddReviewReplyAjaxRequestConfig;
/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/28/interface/api/2852) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewAjax`
 * @更新时间 `2019-08-09 15:44:43`
 */ const ajaxReviewAddReviewAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReviewAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/28/interface/api/2852) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `POST /ajax/review/AddReviewAjax`
 * @更新时间 `2019-08-09 15:44:43`
 */ const ajaxReviewAddReviewAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewAddReviewAjaxRequestConfig, requestData), ...args);
};
ajaxReviewAddReviewAjax.requestConfig = ajaxReviewAddReviewAjaxRequestConfig;
/**
 * 接口 [添加书评页面↗](https://yapi.yuewen.com/project/28/interface/api/58705) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/AddReview`
 * @更新时间 `2021-04-28 16:18:04`
 */ const ajaxReviewAddReviewRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/ajax/review/AddReview",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReview",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加书评页面↗](https://yapi.yuewen.com/project/28/interface/api/58705) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /ajax/review/AddReview`
 * @更新时间 `2021-04-28 16:18:04`
 */ const ajaxReviewAddReview = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewAddReviewRequestConfig, requestData), ...args);
};
ajaxReviewAddReview.requestConfig = ajaxReviewAddReviewRequestConfig;
/**
 * 接口 [【go】书评详情↗](https://yapi.yuewen.com/project/28/interface/api/119922) 的 **请求配置**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /go/pcm/getReviewDetail`
 * @更新时间 `2020-08-03 20:07:45`
 */ const goPcmGetReviewDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_23,
    devUrl: devUrl_0_1_0_23,
    prodUrl: prodUrl_0_1_0_23,
    path: "/go/pcm/getReviewDetail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_23,
    paramNames: [],
    queryNames: [
        "bookId",
        "reviewId",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGetReviewDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【go】书评详情↗](https://yapi.yuewen.com/project/28/interface/api/119922) 的 **请求函数**
 *
 * @分类 [reviews↗](https://yapi.yuewen.com/project/28/interface/api/cat_283)
 * @请求头 `GET /go/pcm/getReviewDetail`
 * @更新时间 `2020-08-03 20:07:45`
 */ const goPcmGetReviewDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGetReviewDetailRequestConfig, requestData), ...args);
};
goPcmGetReviewDetail.requestConfig = goPcmGetReviewDetailRequestConfig;
const mockUrl_0_1_0_24 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_24 = "https://oam.webnovel.com";
const prodUrl_0_1_0_24 = "https://m.webnovel.com";
const dataKey_0_1_0_24 = "data";
/**
 * 接口 [拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/395) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getChapterListAjax`
 * @更新时间 `2020-04-21 17:58:17`
 */ const ajaxChapterGetChapterListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getChapterListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetChapterListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取章节列表↗](https://yapi.yuewen.com/project/28/interface/api/395) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getChapterListAjax`
 * @更新时间 `2020-04-21 17:58:17`
 */ const ajaxChapterGetChapterListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxChapterGetChapterListAjaxRequestConfig, requestData), ...args);
};
ajaxChapterGetChapterListAjax.requestConfig = ajaxChapterGetChapterListAjaxRequestConfig;
/**
 * 接口 [【废弃】获取阅读内容-Page↗](https://yapi.yuewen.com/project/28/interface/api/516) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /page/book/GetBookReadingPage`
 * @更新时间 `2019-02-13 15:10:57`
 */ const pageBookGetBookReadingPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/page/book/GetBookReadingPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageBookGetBookReadingPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【废弃】获取阅读内容-Page↗](https://yapi.yuewen.com/project/28/interface/api/516) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /page/book/GetBookReadingPage`
 * @更新时间 `2019-02-13 15:10:57`
 */ const pageBookGetBookReadingPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageBookGetBookReadingPageRequestConfig, requestData), ...args);
};
pageBookGetBookReadingPage.requestConfig = pageBookGetBookReadingPageRequestConfig;
/**
 * 接口 [获取阅读内容-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/531) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getContent`
 * @更新时间 `2020-10-19 15:23:34`
 */ const ajaxChapterGetContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "withParagraphContent",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取阅读内容-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/531) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getContent`
 * @更新时间 `2020-10-19 15:23:34`
 */ const ajaxChapterGetContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxChapterGetContentRequestConfig, requestData), ...args);
};
ajaxChapterGetContent.requestConfig = ajaxChapterGetContentRequestConfig;
/**
 * 接口 [获取最近更新列表↗](https://yapi.yuewen.com/project/28/interface/api/3161) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getLatestUpdates`
 * @更新时间 `2019-06-10 14:23:15`
 */ const ajaxChapterGetLatestUpdatesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getLatestUpdates",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetLatestUpdates",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取最近更新列表↗](https://yapi.yuewen.com/project/28/interface/api/3161) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getLatestUpdates`
 * @更新时间 `2019-06-10 14:23:15`
 */ const ajaxChapterGetLatestUpdates = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxChapterGetLatestUpdatesRequestConfig, requestData), ...args);
};
ajaxChapterGetLatestUpdates.requestConfig = ajaxChapterGetLatestUpdatesRequestConfig;
/**
 * 接口 [解锁收费章节↗](https://yapi.yuewen.com/project/28/interface/api/9302) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/SpiritStone/UseSSUnlockChapterAjax`
 * @更新时间 `2018-07-03 11:17:13`
 */ const ajaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/SpiritStone/UseSSUnlockChapterAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneUseSsUnlockChapterAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [解锁收费章节↗](https://yapi.yuewen.com/project/28/interface/api/9302) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/SpiritStone/UseSSUnlockChapterAjax`
 * @更新时间 `2018-07-03 11:17:13`
 */ const ajaxSpiritStoneUseSsUnlockChapterAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig, requestData), ...args);
};
ajaxSpiritStoneUseSsUnlockChapterAjax.requestConfig = ajaxSpiritStoneUseSsUnlockChapterAjaxRequestConfig;
/**
 * 接口 [获取弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19923) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/comic/getbullet`
 * @更新时间 `2018-11-07 17:21:34`
 */ const ajaxComicGetbulletRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/comic/getbullet",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "pageId",
        "orderType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicGetbullet",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19923) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/comic/getbullet`
 * @更新时间 `2018-11-07 17:21:34`
 */ const ajaxComicGetbullet = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicGetbulletRequestConfig, requestData), ...args);
};
ajaxComicGetbullet.requestConfig = ajaxComicGetbulletRequestConfig;
/**
 * 接口 [添加弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19925) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/comic/addbullet`
 * @更新时间 `2018-11-07 16:37:03`
 */ const ajaxComicAddbulletRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/comic/addbullet",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxComicAddbullet",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加弹幕↗](https://yapi.yuewen.com/project/28/interface/api/19925) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `POST /ajax/comic/addbullet`
 * @更新时间 `2018-11-07 16:37:03`
 */ const ajaxComicAddbullet = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxComicAddbulletRequestConfig, requestData), ...args);
};
ajaxComicAddbullet.requestConfig = ajaxComicAddbulletRequestConfig;
/**
 * 接口 [rss↗](https://yapi.yuewen.com/project/28/interface/api/29137) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/book/getRssMidPage`
 * @更新时间 `2019-02-13 15:16:59`
 */ const ajaxBookGetRssMidPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/book/getRssMidPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookGetRssMidPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [rss↗](https://yapi.yuewen.com/project/28/interface/api/29137) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/book/getRssMidPage`
 * @更新时间 `2019-02-13 15:16:59`
 */ const ajaxBookGetRssMidPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookGetRssMidPageRequestConfig, requestData), ...args);
};
ajaxBookGetRssMidPage.requestConfig = ajaxBookGetRssMidPageRequestConfig;
/**
 * 接口 [获取阅读内容- AMP↗](https://yapi.yuewen.com/project/28/interface/api/41694) 的 **请求配置**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getAmpContent`
 * @更新时间 `2020-07-31 13:23:20`
 */ const ajaxChapterGetAmpContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_24,
    devUrl: devUrl_0_1_0_24,
    prodUrl: prodUrl_0_1_0_24,
    path: "/ajax/chapter/getAmpContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_24,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterGetAmpContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取阅读内容- AMP↗](https://yapi.yuewen.com/project/28/interface/api/41694) 的 **请求函数**
 *
 * @分类 [Book+Comic ReadingPage↗](https://yapi.yuewen.com/project/28/interface/api/cat_298)
 * @请求头 `GET /ajax/chapter/getAmpContent`
 * @更新时间 `2020-07-31 13:23:20`
 */ const ajaxChapterGetAmpContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxChapterGetAmpContentRequestConfig, requestData), ...args);
};
ajaxChapterGetAmpContent.requestConfig = ajaxChapterGetAmpContentRequestConfig;
const mockUrl_0_1_0_25 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_25 = "https://oam.webnovel.com";
const prodUrl_0_1_0_25 = "https://m.webnovel.com";
const dataKey_0_1_0_25 = "data";
/**
 * 接口 [详情页直出↗](https://yapi.yuewen.com/project/28/interface/api/491) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /page/book/GetBookDetailPage`
 * @更新时间 `2020-07-02 11:38:15`
 */ const pageBookGetBookDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/page/book/GetBookDetailPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageBookGetBookDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [详情页直出↗](https://yapi.yuewen.com/project/28/interface/api/491) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /page/book/GetBookDetailPage`
 * @更新时间 `2020-07-02 11:38:15`
 */ const pageBookGetBookDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageBookGetBookDetailPageRequestConfig, requestData), ...args);
};
pageBookGetBookDetailPage.requestConfig = pageBookGetBookDetailPageRequestConfig;
/**
 * 接口 [详情页页面数据（ajax）↗](https://yapi.yuewen.com/project/28/interface/api/4305) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetBookDetailPage`
 * @更新时间 `2020-08-14 11:07:09`
 */ const ajaxBookGetBookDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/book/GetBookDetailPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookGetBookDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [详情页页面数据（ajax）↗](https://yapi.yuewen.com/project/28/interface/api/4305) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetBookDetailPage`
 * @更新时间 `2020-08-14 11:07:09`
 */ const ajaxBookGetBookDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookGetBookDetailPageRequestConfig, requestData), ...args);
};
ajaxBookGetBookDetailPage.requestConfig = ajaxBookGetBookDetailPageRequestConfig;
/**
 * 接口 [you also like↗](https://yapi.yuewen.com/project/28/interface/api/4307) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetRelatedBooksAjax`
 * @更新时间 `2021-05-08 18:29:18`
 */ const ajaxBookGetRelatedBooksAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/book/GetRelatedBooksAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [
        "bookId",
        "categoryId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookGetRelatedBooksAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [you also like↗](https://yapi.yuewen.com/project/28/interface/api/4307) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/book/GetRelatedBooksAjax`
 * @更新时间 `2021-05-08 18:29:18`
 */ const ajaxBookGetRelatedBooksAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookGetRelatedBooksAjaxRequestConfig, requestData), ...args);
};
ajaxBookGetRelatedBooksAjax.requestConfig = ajaxBookGetRelatedBooksAjaxRequestConfig;
/**
 * 接口 [推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/4309) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/stone/powerInfoAjax`
 * @更新时间 `2019-09-29 11:20:07`
 */ const ajaxStonePowerInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/stone/powerInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStonePowerInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [推荐票榜单信息↗](https://yapi.yuewen.com/project/28/interface/api/4309) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /ajax/stone/powerInfoAjax`
 * @更新时间 `2019-09-29 11:20:07`
 */ const ajaxStonePowerInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxStonePowerInfoAjaxRequestConfig, requestData), ...args);
};
ajaxStonePowerInfoAjax.requestConfig = ajaxStonePowerInfoAjaxRequestConfig;
/**
 * 接口 [投推荐票↗](https://yapi.yuewen.com/project/28/interface/api/4310) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/stone/powerVoteAjax`
 * @更新时间 `2019-11-29 13:54:58`
 */ const ajaxStonePowerVoteAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/stone/powerVoteAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStonePowerVoteAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [投推荐票↗](https://yapi.yuewen.com/project/28/interface/api/4310) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/stone/powerVoteAjax`
 * @更新时间 `2019-11-29 13:54:58`
 */ const ajaxStonePowerVoteAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxStonePowerVoteAjaxRequestConfig, requestData), ...args);
};
ajaxStonePowerVoteAjax.requestConfig = ajaxStonePowerVoteAjaxRequestConfig;
/**
 * 接口 [添加到书架addLibraryItemsAjax↗](https://yapi.yuewen.com/project/28/interface/api/14464) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/library/addLibraryItemsAjax`
 * @更新时间 `2018-09-06 19:05:51`
 */ const ajaxLibraryAddLibraryItemsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/ajax/library/addLibraryItemsAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibraryAddLibraryItemsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加到书架addLibraryItemsAjax↗](https://yapi.yuewen.com/project/28/interface/api/14464) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /ajax/library/addLibraryItemsAjax`
 * @更新时间 `2018-09-06 19:05:51`
 */ const ajaxLibraryAddLibraryItemsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLibraryAddLibraryItemsAjaxRequestConfig, requestData), ...args);
};
ajaxLibraryAddLibraryItemsAjax.requestConfig = ajaxLibraryAddLibraryItemsAjaxRequestConfig;
/**
 * 接口 [\/go\/pcm\/book\/getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/28/interface/api/165074) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-10-27 16:31:36`
 */ const goPcmBookGetBatchSubscribeGradeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/go/pcm/book/getBatchSubscribeGrade",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBatchSubscribeGrade",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/go\/pcm\/book\/getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/28/interface/api/165074) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-10-27 16:31:36`
 */ const goPcmBookGetBatchSubscribeGrade = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBatchSubscribeGradeRequestConfig, requestData), ...args);
};
goPcmBookGetBatchSubscribeGrade.requestConfig = goPcmBookGetBatchSubscribeGradeRequestConfig;
/**
 * 接口 [\/go\/pcm\/book\/unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/28/interface/api/165084) 的 **请求配置**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-10-27 17:58:11`
 */ const goPcmBookUnlockBatchChaptersRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_25,
    devUrl: devUrl_0_1_0_25,
    prodUrl: prodUrl_0_1_0_25,
    path: "/go/pcm/book/unlockBatchChapters",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_25,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookUnlockBatchChapters",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/go\/pcm\/book\/unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/28/interface/api/165084) 的 **请求函数**
 *
 * @分类 [Book - detail↗](https://yapi.yuewen.com/project/28/interface/api/cat_305)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-10-27 17:58:11`
 */ const goPcmBookUnlockBatchChapters = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookUnlockBatchChaptersRequestConfig, requestData), ...args);
};
goPcmBookUnlockBatchChapters.requestConfig = goPcmBookUnlockBatchChaptersRequestConfig;
const mockUrl_0_1_0_26 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_26 = "https://oam.webnovel.com";
const prodUrl_0_1_0_26 = "https://m.webnovel.com";
const dataKey_0_1_0_26 = "data";
/**
 * 接口 [Power Ranking↗](https://yapi.yuewen.com/project/28/interface/api/37) 的 **请求配置**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/stone/powerListAjax`
 * @更新时间 `2018-11-15 21:32:48`
 */ const ajaxStonePowerListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: "/ajax/stone/powerListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: [
        "bookType",
        "timestamp"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStonePowerListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Power Ranking↗](https://yapi.yuewen.com/project/28/interface/api/37) 的 **请求函数**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/stone/powerListAjax`
 * @更新时间 `2018-11-15 21:32:48`
 */ const ajaxStonePowerListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxStonePowerListAjaxRequestConfig, requestData), ...args);
};
ajaxStonePowerListAjax.requestConfig = ajaxStonePowerListAjaxRequestConfig;
/**
 * 接口 [ranking\/getlist↗](https://yapi.yuewen.com/project/28/interface/api/17457) 的 **请求配置**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/ranking/getlist`
 * @更新时间 `2018-11-16 10:31:59`
 */ const ajaxRankingGetlistRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_26,
    devUrl: devUrl_0_1_0_26,
    prodUrl: prodUrl_0_1_0_26,
    path: "/ajax/ranking/getlist",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_26,
    paramNames: [],
    queryNames: [
        "type",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxRankingGetlist",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ranking\/getlist↗](https://yapi.yuewen.com/project/28/interface/api/17457) 的 **请求函数**
 *
 * @分类 [PowerStone↗](https://yapi.yuewen.com/project/28/interface/api/cat_3095)
 * @请求头 `GET /ajax/ranking/getlist`
 * @更新时间 `2018-11-16 10:31:59`
 */ const ajaxRankingGetlist = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxRankingGetlistRequestConfig, requestData), ...args);
};
ajaxRankingGetlist.requestConfig = ajaxRankingGetlistRequestConfig;
const mockUrl_0_1_0_27 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_27 = "https://oam.webnovel.com";
const prodUrl_0_1_0_27 = "https://m.webnovel.com";
const dataKey_0_1_0_27 = "data";
/**
 * 接口 [关键字搜索-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/536) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/searchAjax`
 * @更新时间 `2019-07-23 21:27:43`
 */ const ajaxSearchSearchAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_27,
    devUrl: devUrl_0_1_0_27,
    prodUrl: prodUrl_0_1_0_27,
    path: "/ajax/search/searchAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_27,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "keywords",
        "type"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSearchSearchAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [关键字搜索-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/536) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/searchAjax`
 * @更新时间 `2019-07-23 21:27:43`
 */ const ajaxSearchSearchAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSearchSearchAjaxRequestConfig, requestData), ...args);
};
ajaxSearchSearchAjax.requestConfig = ajaxSearchSearchAjaxRequestConfig;
/**
 * 接口 [关键字联想↗](https://yapi.yuewen.com/project/28/interface/api/6241) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/auto`
 * @更新时间 `2019-07-23 21:24:11`
 */ const ajaxSearchAutoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_27,
    devUrl: devUrl_0_1_0_27,
    prodUrl: prodUrl_0_1_0_27,
    path: "/ajax/search/auto",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_27,
    paramNames: [],
    queryNames: [
        "keyword"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSearchAuto",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [关键字联想↗](https://yapi.yuewen.com/project/28/interface/api/6241) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/auto`
 * @更新时间 `2019-07-23 21:24:11`
 */ const ajaxSearchAuto = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSearchAutoRequestConfig, requestData), ...args);
};
ajaxSearchAuto.requestConfig = ajaxSearchAutoRequestConfig;
/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/28/interface/api/17466) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/getHotSearch`
 * @更新时间 `2018-10-15 15:28:00`
 */ const ajaxSearchGetHotSearchRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_27,
    devUrl: devUrl_0_1_0_27,
    prodUrl: prodUrl_0_1_0_27,
    path: "/ajax/search/getHotSearch",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_27,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSearchGetHotSearch",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/28/interface/api/17466) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/28/interface/api/cat_330)
 * @请求头 `GET /ajax/search/getHotSearch`
 * @更新时间 `2018-10-15 15:28:00`
 */ const ajaxSearchGetHotSearch = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSearchGetHotSearchRequestConfig, requestData), ...args);
};
ajaxSearchGetHotSearch.requestConfig = ajaxSearchGetHotSearchRequestConfig;
const mockUrl_0_1_0_28 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_28 = "https://oam.webnovel.com";
const prodUrl_0_1_0_28 = "https://m.webnovel.com";
const dataKey_0_1_0_28 = "data";
/**
 * 接口 [书架运营位↗](https://yapi.yuewen.com/project/28/interface/api/25543) 的 **请求配置**
 *
 * @分类 [广告和推荐位↗](https://yapi.yuewen.com/project/28/interface/api/cat_4012)
 * @请求头 `GET /ajax/ad/bookShelf`
 * @更新时间 `2019-02-13 10:37:10`
 */ const ajaxAdBookShelfRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_28,
    devUrl: devUrl_0_1_0_28,
    prodUrl: prodUrl_0_1_0_28,
    path: "/ajax/ad/bookShelf",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxAdBookShelf",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书架运营位↗](https://yapi.yuewen.com/project/28/interface/api/25543) 的 **请求函数**
 *
 * @分类 [广告和推荐位↗](https://yapi.yuewen.com/project/28/interface/api/cat_4012)
 * @请求头 `GET /ajax/ad/bookShelf`
 * @更新时间 `2019-02-13 10:37:10`
 */ const ajaxAdBookShelf = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxAdBookShelfRequestConfig, requestData), ...args);
};
ajaxAdBookShelf.requestConfig = ajaxAdBookShelfRequestConfig;
const mockUrl_0_1_0_29 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_29 = "https://oam.webnovel.com";
const prodUrl_0_1_0_29 = "https://m.webnovel.com";
const dataKey_0_1_0_29 = "data";
/**
 * 接口 [v2↗](https://yapi.yuewen.com/project/28/interface/api/952) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV2Page`
 * @更新时间 `2024-08-09 14:23:39`
 */ const ajaxBookstoreIndexV2PageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/indexV2Page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreIndexV2Page",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [v2↗](https://yapi.yuewen.com/project/28/interface/api/952) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV2Page`
 * @更新时间 `2024-08-09 14:23:39`
 */ const ajaxBookstoreIndexV2Page = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookstoreIndexV2PageRequestConfig, requestData), ...args);
};
ajaxBookstoreIndexV2Page.requestConfig = ajaxBookstoreIndexV2PageRequestConfig;
/**
 * 接口 [拉取更新信息↗](https://yapi.yuewen.com/project/28/interface/api/2001) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/getUpdateNums`
 * @更新时间 `2018-12-26 16:56:09`
 */ const ajaxBookstoreGetUpdateNumsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/getUpdateNums",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreGetUpdateNums",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取更新信息↗](https://yapi.yuewen.com/project/28/interface/api/2001) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/getUpdateNums`
 * @更新时间 `2018-12-26 16:56:09`
 */ const ajaxBookstoreGetUpdateNums = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookstoreGetUpdateNumsRequestConfig, requestData), ...args);
};
ajaxBookstoreGetUpdateNums.requestConfig = ajaxBookstoreGetUpdateNumsRequestConfig;
/**
 * 接口 [用户徽章↗](https://yapi.yuewen.com/project/28/interface/api/2006) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/UserBadge`
 * @更新时间 `2018-12-26 16:56:12`
 */ const ajaxBookstoreUserBadgeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/UserBadge",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreUserBadge",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [用户徽章↗](https://yapi.yuewen.com/project/28/interface/api/2006) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/UserBadge`
 * @更新时间 `2018-12-26 16:56:12`
 */ const ajaxBookstoreUserBadge = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookstoreUserBadgeRequestConfig, requestData), ...args);
};
ajaxBookstoreUserBadge.requestConfig = ajaxBookstoreUserBadgeRequestConfig;
/**
 * 接口 [\/ajax\/bookstore\/topic↗](https://yapi.yuewen.com/project/28/interface/api/17430) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/topic`
 * @更新时间 `2018-10-08 14:32:27`
 */ const ajaxBookstoreTopicRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/topic",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [
        "id"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreTopic",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/bookstore\/topic↗](https://yapi.yuewen.com/project/28/interface/api/17430) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/topic`
 * @更新时间 `2018-10-08 14:32:27`
 */ const ajaxBookstoreTopic = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookstoreTopicRequestConfig, requestData), ...args);
};
ajaxBookstoreTopic.requestConfig = ajaxBookstoreTopicRequestConfig;
/**
 * 接口 [v3↗](https://yapi.yuewen.com/project/28/interface/api/17636) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV3page`
 * @更新时间 `2019-04-23 17:23:59`
 */ const ajaxBookstoreIndexV3pageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/ajax/bookstore/indexV3page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxBookstoreIndexV3page",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [v3↗](https://yapi.yuewen.com/project/28/interface/api/17636) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /ajax/bookstore/indexV3page`
 * @更新时间 `2019-04-23 17:23:59`
 */ const ajaxBookstoreIndexV3page = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxBookstoreIndexV3pageRequestConfig, requestData), ...args);
};
ajaxBookstoreIndexV3page.requestConfig = ajaxBookstoreIndexV3pageRequestConfig;
/**
 * 接口 [\/msiteservice\/bookcity\/index↗](https://yapi.yuewen.com/project/28/interface/api/39708) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/index`
 * @更新时间 `2024-08-09 15:28:19`
 */ const msiteserviceBookcityIndexRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/msiteservice/bookcity/index",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [
        "country",
        "sex",
        "pageId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "msiteserviceBookcityIndex",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/msiteservice\/bookcity\/index↗](https://yapi.yuewen.com/project/28/interface/api/39708) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/index`
 * @更新时间 `2024-08-09 15:28:19`
 */ const msiteserviceBookcityIndex = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(msiteserviceBookcityIndexRequestConfig, requestData), ...args);
};
msiteserviceBookcityIndex.requestConfig = msiteserviceBookcityIndexRequestConfig;
/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage↗](https://yapi.yuewen.com/project/28/interface/api/39856) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage`
 * @更新时间 `2024-08-09 15:28:27`
 */ const msiteserviceBookcityCountrylanguageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/msiteservice/bookcity/countrylanguage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "msiteserviceBookcityCountrylanguage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage↗](https://yapi.yuewen.com/project/28/interface/api/39856) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage`
 * @更新时间 `2024-08-09 15:28:27`
 */ const msiteserviceBookcityCountrylanguage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(msiteserviceBookcityCountrylanguageRequestConfig, requestData), ...args);
};
msiteserviceBookcityCountrylanguage.requestConfig = msiteserviceBookcityCountrylanguageRequestConfig;
/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage_copy↗](https://yapi.yuewen.com/project/28/interface/api/40113) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage_1551923127181`
 * @更新时间 `2019-03-07 09:45:27`
 */ const msiteserviceBookcityCountrylanguage_1551923127181RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/msiteservice/bookcity/countrylanguage_1551923127181",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "msiteserviceBookcityCountrylanguage_1551923127181",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/msiteservice\/bookcity\/countrylanguage_copy↗](https://yapi.yuewen.com/project/28/interface/api/40113) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /msiteservice/bookcity/countrylanguage_1551923127181`
 * @更新时间 `2019-03-07 09:45:27`
 */ const msiteserviceBookcityCountrylanguage_1551923127181 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(msiteserviceBookcityCountrylanguage_1551923127181RequestConfig, requestData), ...args);
};
msiteserviceBookcityCountrylanguage_1551923127181.requestConfig = msiteserviceBookcityCountrylanguage_1551923127181RequestConfig;
/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/28/interface/api/166290) 的 **请求配置**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2020-10-23 11:57:13`
 */ const goPcmUserGetFirstChargeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_29,
    devUrl: devUrl_0_1_0_29,
    prodUrl: prodUrl_0_1_0_29,
    path: "/go/pcm/user/get-first-charge",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_29,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetFirstCharge",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/28/interface/api/166290) 的 **请求函数**
 *
 * @分类 [首页home↗](https://yapi.yuewen.com/project/28/interface/api/cat_409)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2020-10-23 11:57:13`
 */ const goPcmUserGetFirstCharge = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetFirstChargeRequestConfig, requestData), ...args);
};
goPcmUserGetFirstCharge.requestConfig = goPcmUserGetFirstChargeRequestConfig;
const mockUrl_0_1_0_30 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_30 = "https://oam.webnovel.com";
const prodUrl_0_1_0_30 = "https://m.webnovel.com";
const dataKey_0_1_0_30 = "data";
/**
 * 接口 [登录回调↗](https://yapi.yuewen.com/project/28/interface/api/969) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/redirect`
 * @更新时间 `2019-01-08 15:05:27`
 */ const ajaxLoginRedirectRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/login/redirect",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [
        "guid",
        "ticket"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLoginRedirect",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [登录回调↗](https://yapi.yuewen.com/project/28/interface/api/969) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/redirect`
 * @更新时间 `2019-01-08 15:05:27`
 */ const ajaxLoginRedirect = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLoginRedirectRequestConfig, requestData), ...args);
};
ajaxLoginRedirect.requestConfig = ajaxLoginRedirectRequestConfig;
/**
 * 接口 [获取登录者第三方信息↗](https://yapi.yuewen.com/project/28/interface/api/974) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/getThirdPartyInfo`
 * @更新时间 `2019-01-08 15:08:11`
 */ const ajaxLoginGetThirdPartyInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/login/getThirdPartyInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLoginGetThirdPartyInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取登录者第三方信息↗](https://yapi.yuewen.com/project/28/interface/api/974) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/getThirdPartyInfo`
 * @更新时间 `2019-01-08 15:08:11`
 */ const ajaxLoginGetThirdPartyInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLoginGetThirdPartyInfoRequestConfig, requestData), ...args);
};
ajaxLoginGetThirdPartyInfo.requestConfig = ajaxLoginGetThirdPartyInfoRequestConfig;
/**
 * 接口 [激活第三方登录用户↗](https://yapi.yuewen.com/project/28/interface/api/980) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/login/checkAndActivate`
 * @更新时间 `2019-01-08 15:10:26`
 */ const ajaxLoginCheckAndActivateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/login/checkAndActivate",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [
        "userName",
        "avatar",
        "loginType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLoginCheckAndActivate",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [激活第三方登录用户↗](https://yapi.yuewen.com/project/28/interface/api/980) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/login/checkAndActivate`
 * @更新时间 `2019-01-08 15:10:26`
 */ const ajaxLoginCheckAndActivate = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLoginCheckAndActivateRequestConfig, requestData), ...args);
};
ajaxLoginCheckAndActivate.requestConfig = ajaxLoginCheckAndActivateRequestConfig;
/**
 * 接口 [设置偏好 saveTags↗](https://yapi.yuewen.com/project/28/interface/api/26760) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/activity/saveTags`
 * @更新时间 `2019-01-08 15:11:50`
 */ const ajaxActivitySaveTagsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/activity/saveTags",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxActivitySaveTags",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [设置偏好 saveTags↗](https://yapi.yuewen.com/project/28/interface/api/26760) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `POST /ajax/activity/saveTags`
 * @更新时间 `2019-01-08 15:11:50`
 */ const ajaxActivitySaveTags = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxActivitySaveTagsRequestConfig, requestData), ...args);
};
ajaxActivitySaveTags.requestConfig = ajaxActivitySaveTagsRequestConfig;
/**
 * 接口 [新登录接口（m3.7.0）↗](https://yapi.yuewen.com/project/28/interface/api/51517) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/login`
 * @更新时间 `2019-05-16 12:16:46`
 */ const ajaxLoginLoginRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/ajax/login/login",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [
        "guid",
        "ticket",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLoginLogin",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [新登录接口（m3.7.0）↗](https://yapi.yuewen.com/project/28/interface/api/51517) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /ajax/login/login`
 * @更新时间 `2019-05-16 12:16:46`
 */ const ajaxLoginLogin = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLoginLoginRequestConfig, requestData), ...args);
};
ajaxLoginLogin.requestConfig = ajaxLoginLoginRequestConfig;
/**
 * 接口 [从客户端登录接口↗](https://yapi.yuewen.com/project/28/interface/api/116050) 的 **请求配置**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /go/pcm/login/fromApp`
 * @更新时间 `2020-07-14 20:53:20`
 */ const goPcmLoginFromAppRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_30,
    devUrl: devUrl_0_1_0_30,
    prodUrl: prodUrl_0_1_0_30,
    path: "/go/pcm/login/fromApp",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_30,
    paramNames: [],
    queryNames: [
        "guid",
        "ticket",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginFromApp",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [从客户端登录接口↗](https://yapi.yuewen.com/project/28/interface/api/116050) 的 **请求函数**
 *
 * @分类 [User - login↗](https://yapi.yuewen.com/project/28/interface/api/cat_416)
 * @请求头 `GET /go/pcm/login/fromApp`
 * @更新时间 `2020-07-14 20:53:20`
 */ const goPcmLoginFromApp = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLoginFromAppRequestConfig, requestData), ...args);
};
goPcmLoginFromApp.requestConfig = goPcmLoginFromAppRequestConfig;
const mockUrl_0_1_0_31 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_31 = "https://oam.webnovel.com";
const prodUrl_0_1_0_31 = "https://m.webnovel.com";
const dataKey_0_1_0_31 = "data";
/**
 * 接口 [举报书籍或者用户↗](https://yapi.yuewen.com/project/28/interface/api/1075) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/report/reportUserOrBook`
 * @更新时间 `2018-03-27 10:17:32`
 */ const ajaxReportReportUserOrBookRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/ajax/report/reportUserOrBook",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReportReportUserOrBook",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [举报书籍或者用户↗](https://yapi.yuewen.com/project/28/interface/api/1075) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/report/reportUserOrBook`
 * @更新时间 `2018-03-27 10:17:32`
 */ const ajaxReportReportUserOrBook = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReportReportUserOrBookRequestConfig, requestData), ...args);
};
ajaxReportReportUserOrBook.requestConfig = ajaxReportReportUserOrBookRequestConfig;
/**
 * 接口 [举报留言↗](https://yapi.yuewen.com/project/28/interface/api/3115) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/review/AddReviewReportAjax`
 * @更新时间 `2018-04-23 16:26:24`
 */ const ajaxReviewAddReviewReportAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/ajax/review/AddReviewReportAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxReviewAddReviewReportAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [举报留言↗](https://yapi.yuewen.com/project/28/interface/api/3115) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/review/AddReviewReportAjax`
 * @更新时间 `2018-04-23 16:26:24`
 */ const ajaxReviewAddReviewReportAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxReviewAddReviewReportAjaxRequestConfig, requestData), ...args);
};
ajaxReviewAddReviewReportAjax.requestConfig = ajaxReviewAddReviewReportAjaxRequestConfig;
/**
 * 接口 [举报章节留言↗](https://yapi.yuewen.com/project/28/interface/api/3122) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/chapterReview/report`
 * @更新时间 `2018-04-23 16:31:06`
 */ const ajaxChapterReviewReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/ajax/chapterReview/report",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxChapterReviewReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [举报章节留言↗](https://yapi.yuewen.com/project/28/interface/api/3122) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /ajax/chapterReview/report`
 * @更新时间 `2018-04-23 16:31:06`
 */ const ajaxChapterReviewReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxChapterReviewReportRequestConfig, requestData), ...args);
};
ajaxChapterReviewReport.requestConfig = ajaxChapterReviewReportRequestConfig;
/**
 * 接口 [举报评论 （书 章 段）↗](https://yapi.yuewen.com/project/28/interface/api/118271) 的 **请求配置**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /go/pcm/bookReviw/report`
 * @更新时间 `2020-08-03 11:35:14`
 */ const goPcmBookReviwReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_31,
    devUrl: devUrl_0_1_0_31,
    prodUrl: prodUrl_0_1_0_31,
    path: "/go/pcm/bookReviw/report",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviwReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [举报评论 （书 章 段）↗](https://yapi.yuewen.com/project/28/interface/api/118271) 的 **请求函数**
 *
 * @分类 [举报↗](https://yapi.yuewen.com/project/28/interface/api/cat_434)
 * @请求头 `POST /go/pcm/bookReviw/report`
 * @更新时间 `2020-08-03 11:35:14`
 */ const goPcmBookReviwReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviwReportRequestConfig, requestData), ...args);
};
goPcmBookReviwReport.requestConfig = goPcmBookReviwReportRequestConfig;
const mockUrl_0_1_0_32 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_32 = "https://oam.webnovel.com";
const prodUrl_0_1_0_32 = "https://m.webnovel.com";
const dataKey_0_1_0_32 = "data";
/**
 * 接口 [Power and energy bills↗](https://yapi.yuewen.com/project/28/interface/api/44) 的 **请求配置**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/stoneDetailAjax`
 * @更新时间 `2019-09-16 18:47:08`
 */ const ajaxStoneStoneDetailAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_32,
    devUrl: devUrl_0_1_0_32,
    prodUrl: prodUrl_0_1_0_32,
    path: "/ajax/stone/stoneDetailAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_32,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "type"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStoneStoneDetailAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Power and energy bills↗](https://yapi.yuewen.com/project/28/interface/api/44) 的 **请求函数**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/stoneDetailAjax`
 * @更新时间 `2019-09-16 18:47:08`
 */ const ajaxStoneStoneDetailAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxStoneStoneDetailAjaxRequestConfig, requestData), ...args);
};
ajaxStoneStoneDetailAjax.requestConfig = ajaxStoneStoneDetailAjaxRequestConfig;
/**
 * 接口 [page\/stone\/getPowerStoneRankingByBookId↗](https://yapi.yuewen.com/project/28/interface/api/12353) 的 **请求配置**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /page/stone/getPowerStoneRankingByBookId?bookId`
 * @更新时间 `2018-08-10 10:52:21`
 */ const pageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_32,
    devUrl: devUrl_0_1_0_32,
    prodUrl: prodUrl_0_1_0_32,
    path: "/page/stone/getPowerStoneRankingByBookId?bookId",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_32,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageStoneGetPowerStoneRankingByBookIdBookId",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [page\/stone\/getPowerStoneRankingByBookId↗](https://yapi.yuewen.com/project/28/interface/api/12353) 的 **请求函数**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /page/stone/getPowerStoneRankingByBookId?bookId`
 * @更新时间 `2018-08-10 10:52:21`
 */ const pageStoneGetPowerStoneRankingByBookIdBookId = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig, requestData), ...args);
};
pageStoneGetPowerStoneRankingByBookIdBookId.requestConfig = pageStoneGetPowerStoneRankingByBookIdBookIdRequestConfig;
/**
 * 接口 [ajax\/stone\/getPowerStoneRankingByBookIdList↗](https://yapi.yuewen.com/project/28/interface/api/12374) 的 **请求配置**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2019-05-05 14:23:23`
 */ const ajaxStoneGetPowerStoneRankingByBookIdListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_32,
    devUrl: devUrl_0_1_0_32,
    prodUrl: prodUrl_0_1_0_32,
    path: "/ajax/stone/getPowerStoneRankingByBookIdList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_32,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxStoneGetPowerStoneRankingByBookIdList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ajax\/stone\/getPowerStoneRankingByBookIdList↗](https://yapi.yuewen.com/project/28/interface/api/12374) 的 **请求函数**
 *
 * @分类 [Stone↗](https://yapi.yuewen.com/project/28/interface/api/cat_51)
 * @请求头 `GET /ajax/stone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2019-05-05 14:23:23`
 */ const ajaxStoneGetPowerStoneRankingByBookIdList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxStoneGetPowerStoneRankingByBookIdListRequestConfig, requestData), ...args);
};
ajaxStoneGetPowerStoneRankingByBookIdList.requestConfig = ajaxStoneGetPowerStoneRankingByBookIdListRequestConfig;
const mockUrl_0_1_0_33 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_33 = "https://oam.webnovel.com";
const prodUrl_0_1_0_33 = "https://m.webnovel.com";
const dataKey_0_1_0_33 = "data";
/**
 * 接口 [拉取ss流水-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/58) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getSSHistoryAjax`
 * @更新时间 `2020-10-26 16:47:37`
 */ const ajaxSpiritStoneGetSsHistoryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getSSHistoryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "transType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetSsHistoryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取ss流水-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/58) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getSSHistoryAjax`
 * @更新时间 `2020-10-26 16:47:37`
 */ const ajaxSpiritStoneGetSsHistoryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneGetSsHistoryAjaxRequestConfig, requestData), ...args);
};
ajaxSpiritStoneGetSsHistoryAjax.requestConfig = ajaxSpiritStoneGetSsHistoryAjaxRequestConfig;
/**
 * 接口 [invite friend↗](https://yapi.yuewen.com/project/28/interface/api/93) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getInviteFriendPage`
 * @更新时间 `2019-11-12 10:25:49`
 */ const ajaxSpiritStoneGetInviteFriendPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getInviteFriendPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetInviteFriendPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [invite friend↗](https://yapi.yuewen.com/project/28/interface/api/93) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getInviteFriendPage`
 * @更新时间 `2019-11-12 10:25:49`
 */ const ajaxSpiritStoneGetInviteFriendPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneGetInviteFriendPageRequestConfig, requestData), ...args);
};
ajaxSpiritStoneGetInviteFriendPage.requestConfig = ajaxSpiritStoneGetInviteFriendPageRequestConfig;
/**
 * 接口 [获取充值公告↗](https://yapi.yuewen.com/project/28/interface/api/556) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getAnnoucement`
 * @更新时间 `2018-03-30 15:05:11`
 */ const ajaxSpiritStoneGetAnnoucementRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getAnnoucement",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetAnnoucement",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取充值公告↗](https://yapi.yuewen.com/project/28/interface/api/556) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getAnnoucement`
 * @更新时间 `2018-03-30 15:05:11`
 */ const ajaxSpiritStoneGetAnnoucement = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneGetAnnoucementRequestConfig, requestData), ...args);
};
ajaxSpiritStoneGetAnnoucement.requestConfig = ajaxSpiritStoneGetAnnoucementRequestConfig;
/**
 * 接口 [check in↗](https://yapi.yuewen.com/project/28/interface/api/3881) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/SpiritStone/checkInAjax`
 * @更新时间 `2019-11-22 10:33:57`
 */ const ajaxSpiritStoneCheckInAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/checkInAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneCheckInAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [check in↗](https://yapi.yuewen.com/project/28/interface/api/3881) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/SpiritStone/checkInAjax`
 * @更新时间 `2019-11-22 10:33:57`
 */ const ajaxSpiritStoneCheckInAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneCheckInAjaxRequestConfig, requestData), ...args);
};
ajaxSpiritStoneCheckInAjax.requestConfig = ajaxSpiritStoneCheckInAjaxRequestConfig;
/**
 * 接口 [拉取ss流水-Page↗](https://yapi.yuewen.com/project/28/interface/api/7495) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/spiritStone/getSSHistoryPage`
 * @更新时间 `2019-11-18 16:10:12`
 */ const ajaxSpiritStoneGetSsHistoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/spiritStone/getSSHistoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetSsHistoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取ss流水-Page↗](https://yapi.yuewen.com/project/28/interface/api/7495) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/spiritStone/getSSHistoryPage`
 * @更新时间 `2019-11-18 16:10:12`
 */ const ajaxSpiritStoneGetSsHistoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneGetSsHistoryPageRequestConfig, requestData), ...args);
};
ajaxSpiritStoneGetSsHistoryPage.requestConfig = ajaxSpiritStoneGetSsHistoryPageRequestConfig;
/**
 * 接口 [page\/SpiritStone\/getSSHistoryPage↗](https://yapi.yuewen.com/project/28/interface/api/13946) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /page/SpiritStone/getSSHistoryPage`
 * @更新时间 `2020-10-19 15:05:17`
 */ const pageSpiritStoneGetSsHistoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/page/SpiritStone/getSSHistoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageSpiritStoneGetSsHistoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [page\/SpiritStone\/getSSHistoryPage↗](https://yapi.yuewen.com/project/28/interface/api/13946) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /page/SpiritStone/getSSHistoryPage`
 * @更新时间 `2020-10-19 15:05:17`
 */ const pageSpiritStoneGetSsHistoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageSpiritStoneGetSsHistoryPageRequestConfig, requestData), ...args);
};
pageSpiritStoneGetSsHistoryPage.requestConfig = pageSpiritStoneGetSsHistoryPageRequestConfig;
/**
 * 接口 [spiritStone\/useSSUnlockChapterAjax↗](https://yapi.yuewen.com/project/28/interface/api/64344) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/spiritStone/useSSUnlockChapterAjax`
 * @更新时间 `2020-10-16 16:16:21`
 */ const ajaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/spiritStone/useSSUnlockChapterAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneUseSsUnlockChapterAjax2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [spiritStone\/useSSUnlockChapterAjax↗](https://yapi.yuewen.com/project/28/interface/api/64344) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `POST /ajax/spiritStone/useSSUnlockChapterAjax`
 * @更新时间 `2020-10-16 16:16:21`
 */ const ajaxSpiritStoneUseSsUnlockChapterAjax2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig, requestData), ...args);
};
ajaxSpiritStoneUseSsUnlockChapterAjax2.requestConfig = ajaxSpiritStoneUseSsUnlockChapterAjax2RequestConfig;
/**
 * 接口 [【已弃用】getGearInfo 获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/69881) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getGearInfo`
 * @更新时间 `2020-10-16 16:13:04`
 */ const ajaxSpiritStoneGetGearInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/ajax/SpiritStone/getGearInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxSpiritStoneGetGearInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【已弃用】getGearInfo 获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/69881) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /ajax/SpiritStone/getGearInfo`
 * @更新时间 `2020-10-16 16:13:04`
 */ const ajaxSpiritStoneGetGearInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxSpiritStoneGetGearInfoRequestConfig, requestData), ...args);
};
ajaxSpiritStoneGetGearInfo.requestConfig = ajaxSpiritStoneGetGearInfoRequestConfig;
/**
 * 接口 [【新】获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/105833) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2020-07-17 11:04:02`
 */ const goPcmRechargeGetGearInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/go/pcm/recharge/getGearInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRechargeGetGearInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【新】获取充值档位↗](https://yapi.yuewen.com/project/28/interface/api/105833) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2020-07-17 11:04:02`
 */ const goPcmRechargeGetGearInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRechargeGetGearInfoRequestConfig, requestData), ...args);
};
goPcmRechargeGetGearInfo.requestConfig = goPcmRechargeGetGearInfoRequestConfig;
/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go)↗](https://yapi.yuewen.com/project/28/interface/api/166228) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-10-26 16:00:48`
 */ const goPcmSpiritStoneGetSsHistoryRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_33,
    devUrl: devUrl_0_1_0_33,
    prodUrl: prodUrl_0_1_0_33,
    path: "/go/pcm/spiritStone/getSSHistory",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_33,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "transType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetSsHistory",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go)↗](https://yapi.yuewen.com/project/28/interface/api/166228) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/28/interface/api/cat_59)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-10-26 16:00:48`
 */ const goPcmSpiritStoneGetSsHistory = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSpiritStoneGetSsHistoryRequestConfig, requestData), ...args);
};
goPcmSpiritStoneGetSsHistory.requestConfig = goPcmSpiritStoneGetSsHistoryRequestConfig;
const mockUrl_0_1_0_34 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_34 = "https://oam.webnovel.com";
const prodUrl_0_1_0_34 = "https://m.webnovel.com";
const dataKey_0_1_0_34 = "data";
/**
 * 接口 [Booklist - Category↗](https://yapi.yuewen.com/project/28/interface/api/65) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/categoryPage`
 * @更新时间 `2019-11-12 11:35:00`
 */ const ajaxCategoryCategoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/ajax/category/categoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [
        "categoryType",
        "categoryId",
        "bookType",
        "bookStatus",
        "orderBy",
        "pageIndex",
        "title",
        "pageSize",
        "gender",
        "chapterNum",
        "language",
        "price"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCategoryCategoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Booklist - Category↗](https://yapi.yuewen.com/project/28/interface/api/65) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/categoryPage`
 * @更新时间 `2019-11-12 11:35:00`
 */ const ajaxCategoryCategoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxCategoryCategoryPageRequestConfig, requestData), ...args);
};
ajaxCategoryCategoryPage.requestConfig = ajaxCategoryCategoryPageRequestConfig;
/**
 * 接口 [获取所有分类-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/481) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getAllAjax`
 * @更新时间 `2018-03-14 15:12:44`
 */ const ajaxCategoryGetAllAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/ajax/category/getAllAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCategoryGetAllAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取所有分类-Ajax↗](https://yapi.yuewen.com/project/28/interface/api/481) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getAllAjax`
 * @更新时间 `2018-03-14 15:12:44`
 */ const ajaxCategoryGetAllAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxCategoryGetAllAjaxRequestConfig, requestData), ...args);
};
ajaxCategoryGetAllAjax.requestConfig = ajaxCategoryGetAllAjaxRequestConfig;
/**
 * 接口 [获取所有分类-Page↗](https://yapi.yuewen.com/project/28/interface/api/511) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/getAllPage`
 * @更新时间 `2024-08-09 14:26:29`
 */ const pageCategoryGetAllPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/page/category/getAllPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageCategoryGetAllPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取所有分类-Page↗](https://yapi.yuewen.com/project/28/interface/api/511) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/getAllPage`
 * @更新时间 `2024-08-09 14:26:29`
 */ const pageCategoryGetAllPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageCategoryGetAllPageRequestConfig, requestData), ...args);
};
pageCategoryGetAllPage.requestConfig = pageCategoryGetAllPageRequestConfig;
/**
 * 接口 [列表页 直出接口↗](https://yapi.yuewen.com/project/28/interface/api/6458) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/bookListPage`
 * @更新时间 `2018-05-23 15:12:05`
 */ const pageCategoryBookListPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/page/category/bookListPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageCategoryBookListPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [列表页 直出接口↗](https://yapi.yuewen.com/project/28/interface/api/6458) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /page/category/bookListPage`
 * @更新时间 `2018-05-23 15:12:05`
 */ const pageCategoryBookListPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageCategoryBookListPageRequestConfig, requestData), ...args);
};
pageCategoryBookListPage.requestConfig = pageCategoryBookListPageRequestConfig;
/**
 * 接口 [getCategories - 根据一级分类获取二级分类↗](https://yapi.yuewen.com/project/28/interface/api/60711) 的 **请求配置**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getCategories`
 * @更新时间 `2019-09-16 21:36:47`
 */ const ajaxCategoryGetCategoriesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_34,
    devUrl: devUrl_0_1_0_34,
    prodUrl: prodUrl_0_1_0_34,
    path: "/ajax/category/getCategories",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_34,
    paramNames: [],
    queryNames: [
        "categoryType",
        "gender"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCategoryGetCategories",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getCategories - 根据一级分类获取二级分类↗](https://yapi.yuewen.com/project/28/interface/api/60711) 的 **请求函数**
 *
 * @分类 [Category↗](https://yapi.yuewen.com/project/28/interface/api/cat_67)
 * @请求头 `GET /ajax/category/getCategories`
 * @更新时间 `2019-09-16 21:36:47`
 */ const ajaxCategoryGetCategories = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxCategoryGetCategoriesRequestConfig, requestData), ...args);
};
ajaxCategoryGetCategories.requestConfig = ajaxCategoryGetCategoriesRequestConfig;
const mockUrl_0_1_0_35 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_35 = "https://oam.webnovel.com";
const prodUrl_0_1_0_35 = "https://m.webnovel.com";
const dataKey_0_1_0_35 = "data";
/**
 * 接口 [Booklist - Tag ↗](https://yapi.yuewen.com/project/28/interface/api/72) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookListAjax`
 * @更新时间 `2020-07-08 19:34:53`
 */ const ajaxTagBookListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/tag/bookListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [
        "tagName",
        "type",
        "pageIndex",
        "order"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTagBookListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Booklist - Tag ↗](https://yapi.yuewen.com/project/28/interface/api/72) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookListAjax`
 * @更新时间 `2020-07-08 19:34:53`
 */ const ajaxTagBookListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxTagBookListAjaxRequestConfig, requestData), ...args);
};
ajaxTagBookListAjax.requestConfig = ajaxTagBookListAjaxRequestConfig;
/**
 * 接口 [获取tag信息 废弃，迁移到根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/4331) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/GetBookTagsAjax`
 * @更新时间 `2019-09-19 15:57:37`
 */ const ajaxUserTagGetBookTagsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/UserTag/GetBookTagsAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserTagGetBookTagsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取tag信息 废弃，迁移到根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/4331) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/GetBookTagsAjax`
 * @更新时间 `2019-09-19 15:57:37`
 */ const ajaxUserTagGetBookTagsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxUserTagGetBookTagsAjaxRequestConfig, requestData), ...args);
};
ajaxUserTagGetBookTagsAjax.requestConfig = ajaxUserTagGetBookTagsAjaxRequestConfig;
/**
 * 接口 [获取用户tag↗](https://yapi.yuewen.com/project/28/interface/api/4456) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/EditUserTagPage`
 * @更新时间 `2018-05-16 22:55:44`
 */ const ajaxUserTagEditUserTagPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/UserTag/EditUserTagPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserTagEditUserTagPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户tag↗](https://yapi.yuewen.com/project/28/interface/api/4456) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/UserTag/EditUserTagPage`
 * @更新时间 `2018-05-16 22:55:44`
 */ const ajaxUserTagEditUserTagPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxUserTagEditUserTagPageRequestConfig, requestData), ...args);
};
ajaxUserTagEditUserTagPage.requestConfig = ajaxUserTagEditUserTagPageRequestConfig;
/**
 * 接口 [编辑tag↗](https://yapi.yuewen.com/project/28/interface/api/4808) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/UserTag/AddDeleteUserTagsAjax`
 * @更新时间 `2018-05-17 13:52:10`
 */ const ajaxUserTagAddDeleteUserTagsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/UserTag/AddDeleteUserTagsAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxUserTagAddDeleteUserTagsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [编辑tag↗](https://yapi.yuewen.com/project/28/interface/api/4808) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/UserTag/AddDeleteUserTagsAjax`
 * @更新时间 `2018-05-17 13:52:10`
 */ const ajaxUserTagAddDeleteUserTagsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxUserTagAddDeleteUserTagsAjaxRequestConfig, requestData), ...args);
};
ajaxUserTagAddDeleteUserTagsAjax.requestConfig = ajaxUserTagAddDeleteUserTagsAjaxRequestConfig;
/**
 * 接口 [根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/60864) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookTagList`
 * @更新时间 `2019-09-19 17:50:50`
 */ const ajaxTagBookTagListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/tag/bookTagList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [
        "bookId",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTagBookTagList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [根据bookId拉取标签列表↗](https://yapi.yuewen.com/project/28/interface/api/60864) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `GET /ajax/tag/bookTagList`
 * @更新时间 `2019-09-19 17:50:50`
 */ const ajaxTagBookTagList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxTagBookTagListRequestConfig, requestData), ...args);
};
ajaxTagBookTagList.requestConfig = ajaxTagBookTagListRequestConfig;
/**
 * 接口 [点赞标签↗](https://yapi.yuewen.com/project/28/interface/api/60869) 的 **请求配置**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/tag/support`
 * @更新时间 `2019-09-19 15:44:25`
 */ const ajaxTagSupportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_35,
    devUrl: devUrl_0_1_0_35,
    prodUrl: prodUrl_0_1_0_35,
    path: "/ajax/tag/support",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_35,
    paramNames: [],
    queryNames: [
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTagSupport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [点赞标签↗](https://yapi.yuewen.com/project/28/interface/api/60869) 的 **请求函数**
 *
 * @分类 [Tag↗](https://yapi.yuewen.com/project/28/interface/api/cat_75)
 * @请求头 `POST /ajax/tag/support`
 * @更新时间 `2019-09-19 15:44:25`
 */ const ajaxTagSupport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxTagSupportRequestConfig, requestData), ...args);
};
ajaxTagSupport.requestConfig = ajaxTagSupportRequestConfig;
const mockUrl_0_1_0_36 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_36 = "https://oam.webnovel.com";
const prodUrl_0_1_0_36 = "https://m.webnovel.com";
const dataKey_0_1_0_36 = "data";
/**
 * 接口 [GetMessages 消息列表↗](https://yapi.yuewen.com/project/28/interface/api/51217) 的 **请求配置**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /ajax/message/GetMessagesAjax`
 * @更新时间 `2019-05-13 19:51:47`
 */ const ajaxMessageGetMessagesAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_36,
    devUrl: devUrl_0_1_0_36,
    prodUrl: prodUrl_0_1_0_36,
    path: "/ajax/message/GetMessagesAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_36,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxMessageGetMessagesAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [GetMessages 消息列表↗](https://yapi.yuewen.com/project/28/interface/api/51217) 的 **请求函数**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /ajax/message/GetMessagesAjax`
 * @更新时间 `2019-05-13 19:51:47`
 */ const ajaxMessageGetMessagesAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxMessageGetMessagesAjaxRequestConfig, requestData), ...args);
};
ajaxMessageGetMessagesAjax.requestConfig = ajaxMessageGetMessagesAjaxRequestConfig;
/**
 * 接口 [Following↗](https://yapi.yuewen.com/project/28/interface/api/81734) 的 **请求配置**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2024-08-09 14:27:50`
 */ const goPcmMessageGetFollowingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_36,
    devUrl: devUrl_0_1_0_36,
    prodUrl: prodUrl_0_1_0_36,
    path: "/go/pcm/message/getFollowing",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_36,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetFollowing",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Following↗](https://yapi.yuewen.com/project/28/interface/api/81734) 的 **请求函数**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/28/interface/api/cat_7567)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2024-08-09 14:27:50`
 */ const goPcmMessageGetFollowing = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMessageGetFollowingRequestConfig, requestData), ...args);
};
goPcmMessageGetFollowing.requestConfig = goPcmMessageGetFollowingRequestConfig;
const mockUrl_0_1_0_37 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_37 = "https://oam.webnovel.com";
const prodUrl_0_1_0_37 = "https://m.webnovel.com";
const dataKey_0_1_0_37 = "data";
/**
 * 接口 [listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/51220) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/listAjax`
 * @更新时间 `2019-08-12 15:13:33`
 */ const ajaxNotificationListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/ajax/notification/listAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/51220) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/listAjax`
 * @更新时间 `2019-08-12 15:13:33`
 */ const ajaxNotificationListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxNotificationListAjaxRequestConfig, requestData), ...args);
};
ajaxNotificationListAjax.requestConfig = ajaxNotificationListAjaxRequestConfig;
/**
 * 接口 [systemListAjax 系统通知列表↗](https://yapi.yuewen.com/project/28/interface/api/51223) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/systemListAjax`
 * @更新时间 `2019-05-13 19:56:30`
 */ const ajaxNotificationSystemListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/ajax/notification/systemListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationSystemListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [systemListAjax 系统通知列表↗](https://yapi.yuewen.com/project/28/interface/api/51223) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/systemListAjax`
 * @更新时间 `2019-05-13 19:56:30`
 */ const ajaxNotificationSystemListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxNotificationSystemListAjaxRequestConfig, requestData), ...args);
};
ajaxNotificationSystemListAjax.requestConfig = ajaxNotificationSystemListAjaxRequestConfig;
/**
 * 接口 [status 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/28/interface/api/51228) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/status`
 * @更新时间 `2021-01-15 21:44:11`
 */ const ajaxNotificationStatusRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/ajax/notification/status",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxNotificationStatus",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [status 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/28/interface/api/51228) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /ajax/notification/status`
 * @更新时间 `2021-01-15 21:44:11`
 */ const ajaxNotificationStatus = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxNotificationStatusRequestConfig, requestData), ...args);
};
ajaxNotificationStatus.requestConfig = ajaxNotificationStatusRequestConfig;
/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/118365) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-07-29 10:45:56`
 */ const goPcmNotificationListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_37,
    devUrl: devUrl_0_1_0_37,
    prodUrl: prodUrl_0_1_0_37,
    path: "/go/pcm/notification/listAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_37,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/28/interface/api/118365) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/28/interface/api/cat_7574)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-07-29 10:45:56`
 */ const goPcmNotificationListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmNotificationListAjaxRequestConfig, requestData), ...args);
};
goPcmNotificationListAjax.requestConfig = goPcmNotificationListAjaxRequestConfig;
const mockUrl_0_1_0_38 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_38 = "https://oam.webnovel.com";
const prodUrl_0_1_0_38 = "https://m.webnovel.com";
const dataKey_0_1_0_38 = "data";
/**
 * 接口 [获取所有tag↗](https://yapi.yuewen.com/project/28/interface/api/2137) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /page/activity/GetTags`
 * @更新时间 `2018-04-16 11:04:36`
 */ const pageActivityGetTagsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/page/activity/GetTags",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageActivityGetTags",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取所有tag↗](https://yapi.yuewen.com/project/28/interface/api/2137) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /page/activity/GetTags`
 * @更新时间 `2018-04-16 11:04:36`
 */ const pageActivityGetTags = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageActivityGetTagsRequestConfig, requestData), ...args);
};
pageActivityGetTags.requestConfig = pageActivityGetTagsRequestConfig;
/**
 * 接口 [保存tag↗](https://yapi.yuewen.com/project/28/interface/api/2194) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/activity/SaveTags`
 * @更新时间 `2018-04-16 12:43:18`
 */ const ajaxActivitySaveTags2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/activity/SaveTags",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxActivitySaveTags2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [保存tag↗](https://yapi.yuewen.com/project/28/interface/api/2194) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/activity/SaveTags`
 * @更新时间 `2018-04-16 12:43:18`
 */ const ajaxActivitySaveTags2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxActivitySaveTags2RequestConfig, requestData), ...args);
};
ajaxActivitySaveTags2.requestConfig = ajaxActivitySaveTags2RequestConfig;
/**
 * 接口 [\/ajax\/activity\/getTags↗](https://yapi.yuewen.com/project/28/interface/api/9220) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/activity/getTags`
 * @更新时间 `2018-12-24 11:15:30`
 */ const ajaxActivityGetTagsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/activity/getTags",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxActivityGetTags",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/activity\/getTags↗](https://yapi.yuewen.com/project/28/interface/api/9220) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/activity/getTags`
 * @更新时间 `2018-12-24 11:15:30`
 */ const ajaxActivityGetTags = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxActivityGetTagsRequestConfig, requestData), ...args);
};
ajaxActivityGetTags.requestConfig = ajaxActivityGetTagsRequestConfig;
/**
 * 接口 [\/ajax\/task\/taskList↗](https://yapi.yuewen.com/project/28/interface/api/25314) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/task/taskList`
 * @更新时间 `2019-11-22 10:30:23`
 */ const ajaxTaskTaskListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/task/taskList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [
        "taskType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTaskTaskList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/task\/taskList↗](https://yapi.yuewen.com/project/28/interface/api/25314) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `GET /ajax/task/taskList`
 * @更新时间 `2019-11-22 10:30:23`
 */ const ajaxTaskTaskList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxTaskTaskListRequestConfig, requestData), ...args);
};
ajaxTaskTaskList.requestConfig = ajaxTaskTaskListRequestConfig;
/**
 * 接口 [\/ajax\/task\/claimTaskReward↗](https://yapi.yuewen.com/project/28/interface/api/25481) 的 **请求配置**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/task/claimTaskReward`
 * @更新时间 `2019-11-14 14:33:02`
 */ const ajaxTaskClaimTaskRewardRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_38,
    devUrl: devUrl_0_1_0_38,
    prodUrl: prodUrl_0_1_0_38,
    path: "/ajax/task/claimTaskReward",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxTaskClaimTaskReward",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/task\/claimTaskReward↗](https://yapi.yuewen.com/project/28/interface/api/25481) 的 **请求函数**
 *
 * @分类 [任务相关↗](https://yapi.yuewen.com/project/28/interface/api/cat_894)
 * @请求头 `POST /ajax/task/claimTaskReward`
 * @更新时间 `2019-11-14 14:33:02`
 */ const ajaxTaskClaimTaskReward = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxTaskClaimTaskRewardRequestConfig, requestData), ...args);
};
ajaxTaskClaimTaskReward.requestConfig = ajaxTaskClaimTaskRewardRequestConfig;
const mockUrl_0_1_0_39 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_39 = "https://oam.webnovel.com";
const prodUrl_0_1_0_39 = "https://m.webnovel.com";
const dataKey_0_1_0_39 = "data";
/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/28/interface/api/2326) 的 **请求配置**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /ajax/cdkey/needCaptcha`
 * @更新时间 `2018-06-29 15:10:39`
 */ const ajaxCdkeyNeedCaptchaRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_39,
    devUrl: devUrl_0_1_0_39,
    prodUrl: prodUrl_0_1_0_39,
    path: "/ajax/cdkey/needCaptcha",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCdkeyNeedCaptcha",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/28/interface/api/2326) 的 **请求函数**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /ajax/cdkey/needCaptcha`
 * @更新时间 `2018-06-29 15:10:39`
 */ const ajaxCdkeyNeedCaptcha = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxCdkeyNeedCaptchaRequestConfig, requestData), ...args);
};
ajaxCdkeyNeedCaptcha.requestConfig = ajaxCdkeyNeedCaptchaRequestConfig;
/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/28/interface/api/2333) 的 **请求配置**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `POST /ajax/cdkey/redeem`
 * @更新时间 `2024-08-09 14:49:35`
 */ const ajaxCdkeyRedeemRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_39,
    devUrl: devUrl_0_1_0_39,
    prodUrl: prodUrl_0_1_0_39,
    path: "/ajax/cdkey/redeem",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxCdkeyRedeem",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/28/interface/api/2333) 的 **请求函数**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `POST /ajax/cdkey/redeem`
 * @更新时间 `2024-08-09 14:49:35`
 */ const ajaxCdkeyRedeem = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxCdkeyRedeemRequestConfig, requestData), ...args);
};
ajaxCdkeyRedeem.requestConfig = ajaxCdkeyRedeemRequestConfig;
/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/28/interface/api/6320) 的 **请求配置**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /page/Cdkey/UserStatus`
 * @更新时间 `2018-06-29 14:53:57`
 */ const pageCdkeyUserStatusRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_39,
    devUrl: devUrl_0_1_0_39,
    prodUrl: prodUrl_0_1_0_39,
    path: "/page/Cdkey/UserStatus",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_39,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageCdkeyUserStatus",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/28/interface/api/6320) 的 **请求函数**
 *
 * @分类 [礼品兑换↗](https://yapi.yuewen.com/project/28/interface/api/cat_904)
 * @请求头 `GET /page/Cdkey/UserStatus`
 * @更新时间 `2018-06-29 14:53:57`
 */ const pageCdkeyUserStatus = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageCdkeyUserStatusRequestConfig, requestData), ...args);
};
pageCdkeyUserStatus.requestConfig = pageCdkeyUserStatusRequestConfig;
const mockUrl_0_1_0_40 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_40 = "https://oam.webnovel.com";
const prodUrl_0_1_0_40 = "https://m.webnovel.com";
const dataKey_0_1_0_40 = "data";
/**
 * 接口 [Library Ajax↗](https://yapi.yuewen.com/project/28/interface/api/86) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /ajax/Library/LibraryAjax`
 * @更新时间 `2019-07-22 19:34:50`
 */ const ajaxLibraryLibraryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/ajax/Library/LibraryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: [
        "orderBy",
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibraryLibraryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Library Ajax↗](https://yapi.yuewen.com/project/28/interface/api/86) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /ajax/Library/LibraryAjax`
 * @更新时间 `2019-07-22 19:34:50`
 */ const ajaxLibraryLibraryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLibraryLibraryAjaxRequestConfig, requestData), ...args);
};
ajaxLibraryLibraryAjax.requestConfig = ajaxLibraryLibraryAjaxRequestConfig;
/**
 * 接口 [从书架移除书籍↗](https://yapi.yuewen.com/project/28/interface/api/156) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/DeleteLibraryItemsAjax`
 * @更新时间 `2018-09-03 21:22:15`
 */ const ajaxLibraryDeleteLibraryItemsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/ajax/Library/DeleteLibraryItemsAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibraryDeleteLibraryItemsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [从书架移除书籍↗](https://yapi.yuewen.com/project/28/interface/api/156) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/DeleteLibraryItemsAjax`
 * @更新时间 `2018-09-03 21:22:15`
 */ const ajaxLibraryDeleteLibraryItemsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLibraryDeleteLibraryItemsAjaxRequestConfig, requestData), ...args);
};
ajaxLibraryDeleteLibraryItemsAjax.requestConfig = ajaxLibraryDeleteLibraryItemsAjaxRequestConfig;
/**
 * 接口 [书架直出↗](https://yapi.yuewen.com/project/28/interface/api/8197) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /page/Library/LibraryPage`
 * @更新时间 `2018-08-31 16:08:49`
 */ const pageLibraryLibraryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/page/Library/LibraryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "pageLibraryLibraryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书架直出↗](https://yapi.yuewen.com/project/28/interface/api/8197) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `GET /page/Library/LibraryPage`
 * @更新时间 `2018-08-31 16:08:49`
 */ const pageLibraryLibraryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(pageLibraryLibraryPageRequestConfig, requestData), ...args);
};
pageLibraryLibraryPage.requestConfig = pageLibraryLibraryPageRequestConfig;
/**
 * 接口 [排序设置↗](https://yapi.yuewen.com/project/28/interface/api/8206) 的 **请求配置**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/SetUserPreferenceAjax`
 * @更新时间 `2018-06-19 14:32:22`
 */ const ajaxLibrarySetUserPreferenceAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_40,
    devUrl: devUrl_0_1_0_40,
    prodUrl: prodUrl_0_1_0_40,
    path: "/ajax/Library/SetUserPreferenceAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_40,
    paramNames: [],
    queryNames: [
        "orderBy"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxLibrarySetUserPreferenceAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [排序设置↗](https://yapi.yuewen.com/project/28/interface/api/8206) 的 **请求函数**
 *
 * @分类 [Library↗](https://yapi.yuewen.com/project/28/interface/api/cat_91)
 * @请求头 `POST /ajax/Library/SetUserPreferenceAjax`
 * @更新时间 `2018-06-19 14:32:22`
 */ const ajaxLibrarySetUserPreferenceAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxLibrarySetUserPreferenceAjaxRequestConfig, requestData), ...args);
};
ajaxLibrarySetUserPreferenceAjax.requestConfig = ajaxLibrarySetUserPreferenceAjaxRequestConfig;
const mockUrl_0_1_0_41 = "https://yapi.yuewen.com/mock/28";
const devUrl_0_1_0_41 = "https://oam.webnovel.com";
const prodUrl_0_1_0_41 = "https://m.webnovel.com";
const dataKey_0_1_0_41 = "data";
/**
 * 接口 [\/ajax\/publishBook\/getBookDetailPage↗](https://yapi.yuewen.com/project/28/interface/api/57449) 的 **请求配置**
 *
 * @分类 [出版书↗](https://yapi.yuewen.com/project/28/interface/api/cat_9718)
 * @请求头 `GET /ajax/publishBook/getBookDetailPage`
 * @更新时间 `2020-09-08 15:42:53`
 */ const ajaxPublishBookGetBookDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_1_0_41,
    devUrl: devUrl_0_1_0_41,
    prodUrl: prodUrl_0_1_0_41,
    path: "/ajax/publishBook/getBookDetailPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_1_0_41,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "ajaxPublishBookGetBookDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/ajax\/publishBook\/getBookDetailPage↗](https://yapi.yuewen.com/project/28/interface/api/57449) 的 **请求函数**
 *
 * @分类 [出版书↗](https://yapi.yuewen.com/project/28/interface/api/cat_9718)
 * @请求头 `GET /ajax/publishBook/getBookDetailPage`
 * @更新时间 `2020-09-08 15:42:53`
 */ const ajaxPublishBookGetBookDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(ajaxPublishBookGetBookDetailPageRequestConfig, requestData), ...args);
};
ajaxPublishBookGetBookDetailPage.requestConfig = ajaxPublishBookGetBookDetailPageRequestConfig;
const mockUrl_0_0_0_0 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_0 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_0 = "https://www.webnovel.com";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [FP 列表↗](https://yapi.yuewen.com/project/2309/interface/api/175451) 的 **请求配置**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-my-list`
 * @更新时间 `2020-12-02 19:34:48`
 */ const goPcmFastpassGetMyListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/go/pcm/fastpass/get-my-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFastpassGetMyList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [FP 列表↗](https://yapi.yuewen.com/project/2309/interface/api/175451) 的 **请求函数**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-my-list`
 * @更新时间 `2020-12-02 19:34:48`
 */ const goPcmFastpassGetMyList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmFastpassGetMyListRequestConfig, requestData), ...args);
};
goPcmFastpassGetMyList.requestConfig = goPcmFastpassGetMyListRequestConfig;
/**
 * 接口 [流水↗](https://yapi.yuewen.com/project/2309/interface/api/244290) 的 **请求配置**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-log-list`
 * @更新时间 `2022-08-18 11:26:25`
 */ const goPcmFastpassGetLogListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/go/pcm/fastpass/get-log-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "type"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFastpassGetLogList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [流水↗](https://yapi.yuewen.com/project/2309/interface/api/244290) 的 **请求函数**
 *
 * @分类 [FastPass↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22820)
 * @请求头 `GET /go/pcm/fastpass/get-log-list`
 * @更新时间 `2022-08-18 11:26:25`
 */ const goPcmFastpassGetLogList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmFastpassGetLogListRequestConfig, requestData), ...args);
};
goPcmFastpassGetLogList.requestConfig = goPcmFastpassGetLogListRequestConfig;
const mockUrl_0_0_0_1 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_1 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_1 = "https://www.webnovel.com";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 [获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/175491) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2023-02-28 15:32:53`
 */ const goPcmChapterGetContent2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [
        "chapterId",
        "bookId",
        "encryptType",
        "font"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContent2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/175491) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContent`
 * @更新时间 `2023-02-28 15:32:53`
 */ const goPcmChapterGetContent2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetContent2RequestConfig, requestData), ...args);
};
goPcmChapterGetContent2.requestConfig = goPcmChapterGetContent2RequestConfig;
/**
 * 接口 [阅读页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/175496) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentPage`
 * @更新时间 `2023-02-28 15:33:17`
 */ const goPcmChapterGetContentPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getContentPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [
        "chapterId",
        "bookId",
        "encryptType",
        "font"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContentPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [阅读页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/175496) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentPage`
 * @更新时间 `2023-02-28 15:33:17`
 */ const goPcmChapterGetContentPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetContentPageRequestConfig, requestData), ...args);
};
goPcmChapterGetContentPage.requestConfig = goPcmChapterGetContentPageRequestConfig;
/**
 * 接口 [chapter\/get-chapter-list 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195528) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2024-10-16 14:45:26`
 */ const goPcmChapterGetChapterList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/get-chapter-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [
        "bookId",
        "pageIndex",
        "pageSize",
        "encryptType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetChapterList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [chapter\/get-chapter-list 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195528) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/get-chapter-list`
 * @更新时间 `2024-10-16 14:45:26`
 */ const goPcmChapterGetChapterList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetChapterList2RequestConfig, requestData), ...args);
};
goPcmChapterGetChapterList2.requestConfig = goPcmChapterGetChapterList2RequestConfig;
/**
 * 接口 [getAmpContent - 获取 amp 章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195682) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContent`
 * @更新时间 `2022-09-06 17:27:25`
 */ const goPcmChapterGetAmpContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getAmpContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetAmpContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getAmpContent - 获取 amp 章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195682) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContent`
 * @更新时间 `2022-09-06 17:27:25`
 */ const goPcmChapterGetAmpContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetAmpContentRequestConfig, requestData), ...args);
};
goPcmChapterGetAmpContent.requestConfig = goPcmChapterGetAmpContentRequestConfig;
/**
 * 接口 [getChapterContentToken - 获取广告章节解锁 token↗](https://yapi.yuewen.com/project/2309/interface/api/195691) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getChapterContentToken`
 * @更新时间 `2021-01-27 20:47:06`
 */ const goPcmChapterGetChapterContentTokenRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getChapterContentToken",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetChapterContentToken",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getChapterContentToken - 获取广告章节解锁 token↗](https://yapi.yuewen.com/project/2309/interface/api/195691) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getChapterContentToken`
 * @更新时间 `2021-01-27 20:47:06`
 */ const goPcmChapterGetChapterContentToken = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetChapterContentTokenRequestConfig, requestData), ...args);
};
goPcmChapterGetChapterContentToken.requestConfig = goPcmChapterGetChapterContentTokenRequestConfig;
/**
 * 接口 [getContentByToken - 根据 token 获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195700) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentByToken`
 * @更新时间 `2021-01-27 21:05:26`
 */ const goPcmChapterGetContentByTokenRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getContentByToken",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [
        "token",
        "bookId",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetContentByToken",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getContentByToken - 根据 token 获取章节内容↗](https://yapi.yuewen.com/project/2309/interface/api/195700) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getContentByToken`
 * @更新时间 `2021-01-27 21:05:26`
 */ const goPcmChapterGetContentByToken = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetContentByTokenRequestConfig, requestData), ...args);
};
goPcmChapterGetContentByToken.requestConfig = goPcmChapterGetContentByTokenRequestConfig;
/**
 * 接口 [getLastestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195712) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getLatestUpdates`
 * @更新时间 `2021-01-27 21:33:45`
 */ const goPcmChapterGetLatestUpdatesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getLatestUpdates",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetLatestUpdates",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getLastestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195712) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getLatestUpdates`
 * @更新时间 `2021-01-27 21:33:45`
 */ const goPcmChapterGetLatestUpdates = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetLatestUpdatesRequestConfig, requestData), ...args);
};
goPcmChapterGetLatestUpdates.requestConfig = goPcmChapterGetLatestUpdatesRequestConfig;
/**
 * 接口 [getAmpContentPage - 获取 amp 章节内容page↗](https://yapi.yuewen.com/project/2309/interface/api/213486) 的 **请求配置**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContentPage`
 * @更新时间 `2021-05-14 10:35:33`
 */ const goPcmChapterGetAmpContentPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_1,
    devUrl: devUrl_0_0_0_1,
    prodUrl: prodUrl_0_0_0_1,
    path: "/go/pcm/chapter/getAmpContentPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_1,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterGetAmpContentPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getAmpContentPage - 获取 amp 章节内容page↗](https://yapi.yuewen.com/project/2309/interface/api/213486) 的 **请求函数**
 *
 * @分类 [Chapter - 章节↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22828)
 * @请求头 `GET /go/pcm/chapter/getAmpContentPage`
 * @更新时间 `2021-05-14 10:35:33`
 */ const goPcmChapterGetAmpContentPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterGetAmpContentPageRequestConfig, requestData), ...args);
};
goPcmChapterGetAmpContentPage.requestConfig = goPcmChapterGetAmpContentPageRequestConfig;
const mockUrl_0_0_0_2 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_2 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_2 = "https://www.webnovel.com";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 [support - tag点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175498) 的 **请求配置**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `POST /go/pcm/tag/support`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmTagSupportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: "/go/pcm/tag/support",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagSupport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [support - tag点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175498) 的 **请求函数**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `POST /go/pcm/tag/support`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmTagSupport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTagSupportRequestConfig, requestData), ...args);
};
goPcmTagSupport.requestConfig = goPcmTagSupportRequestConfig;
/**
 * 接口 [书标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/207324) 的 **请求配置**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2022-08-09 20:10:04`
 */ const goPcmTagGetBookTagList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: "/go/pcm/tag/get-book-tag-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagGetBookTagList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/207324) 的 **请求函数**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-book-tag-list`
 * @更新时间 `2022-08-09 20:10:04`
 */ const goPcmTagGetBookTagList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTagGetBookTagList2RequestConfig, requestData), ...args);
};
goPcmTagGetBookTagList2.requestConfig = goPcmTagGetBookTagList2RequestConfig;
/**
 * 接口 [标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/244300) 的 **请求配置**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-tag-list`
 * @更新时间 `2022-08-10 15:08:10`
 */ const goPcmTagGetTagListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_2,
    devUrl: devUrl_0_0_0_2,
    prodUrl: prodUrl_0_0_0_2,
    path: "/go/pcm/tag/get-tag-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_2,
    paramNames: [],
    queryNames: [
        "orderBy",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTagGetTagList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [标签列表↗](https://yapi.yuewen.com/project/2309/interface/api/244300) 的 **请求函数**
 *
 * @分类 [tag-标签↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22837)
 * @请求头 `GET /go/pcm/tag/get-tag-list`
 * @更新时间 `2022-08-10 15:08:10`
 */ const goPcmTagGetTagList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTagGetTagListRequestConfig, requestData), ...args);
};
goPcmTagGetTagList.requestConfig = goPcmTagGetTagListRequestConfig;
const mockUrl_0_0_0_3 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_3 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_3 = "https://www.webnovel.com";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 [coins 历史记录直出↗](https://yapi.yuewen.com/project/2309/interface/api/175506) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistoryPage`
 * @更新时间 `2020-12-02 19:40:19`
 */ const goPcmSpiritStoneGetSsHistoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getSSHistoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.raw */.b.raw,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "transType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetSsHistoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [coins 历史记录直出↗](https://yapi.yuewen.com/project/2309/interface/api/175506) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistoryPage`
 * @更新时间 `2020-12-02 19:40:19`
 */ const goPcmSpiritStoneGetSsHistoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSpiritStoneGetSsHistoryPageRequestConfig, requestData), ...args);
};
goPcmSpiritStoneGetSsHistoryPage.requestConfig = goPcmSpiritStoneGetSsHistoryPageRequestConfig;
/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go）↗](https://yapi.yuewen.com/project/2309/interface/api/175511) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmSpiritStoneGetSsHistory2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getSSHistory",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "transType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetSsHistory2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [\/go\/pcm\/spiritStone\/getSSHistory（go）↗](https://yapi.yuewen.com/project/2309/interface/api/175511) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getSSHistory`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmSpiritStoneGetSsHistory2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSpiritStoneGetSsHistory2RequestConfig, requestData), ...args);
};
goPcmSpiritStoneGetSsHistory2.requestConfig = goPcmSpiritStoneGetSsHistory2RequestConfig;
/**
 * 接口 [签到↗](https://yapi.yuewen.com/project/2309/interface/api/175521) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `POST /go/pcm/spiritStone/checkIn`
 * @更新时间 `2021-01-13 15:18:44`
 */ const goPcmSpiritStoneCheckInRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/checkIn",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneCheckIn",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [签到↗](https://yapi.yuewen.com/project/2309/interface/api/175521) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `POST /go/pcm/spiritStone/checkIn`
 * @更新时间 `2021-01-13 15:18:44`
 */ const goPcmSpiritStoneCheckIn = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSpiritStoneCheckInRequestConfig, requestData), ...args);
};
goPcmSpiritStoneCheckIn.requestConfig = goPcmSpiritStoneCheckInRequestConfig;
/**
 * 接口 [邀请好友页(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/175526) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getInviteFriendPage`
 * @更新时间 `2021-01-13 15:19:33`
 */ const goPcmSpiritStoneGetInviteFriendPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getInviteFriendPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetInviteFriendPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [邀请好友页(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/175526) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getInviteFriendPage`
 * @更新时间 `2021-01-13 15:19:33`
 */ const goPcmSpiritStoneGetInviteFriendPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSpiritStoneGetInviteFriendPageRequestConfig, requestData), ...args);
};
goPcmSpiritStoneGetInviteFriendPage.requestConfig = goPcmSpiritStoneGetInviteFriendPageRequestConfig;
/**
 * 接口 [查询充赠免费文案↗](https://yapi.yuewen.com/project/2309/interface/api/207105) 的 **请求配置**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getAnnouncement`
 * @更新时间 `2021-04-29 09:59:30`
 */ const goPcmSpiritStoneGetAnnouncementRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_3,
    devUrl: devUrl_0_0_0_3,
    prodUrl: prodUrl_0_0_0_3,
    path: "/go/pcm/spiritStone/getAnnouncement",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_3,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSpiritStoneGetAnnouncement",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [查询充赠免费文案↗](https://yapi.yuewen.com/project/2309/interface/api/207105) 的 **请求函数**
 *
 * @分类 [SpiritStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22841)
 * @请求头 `GET /go/pcm/spiritStone/getAnnouncement`
 * @更新时间 `2021-04-29 09:59:30`
 */ const goPcmSpiritStoneGetAnnouncement = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSpiritStoneGetAnnouncementRequestConfig, requestData), ...args);
};
goPcmSpiritStoneGetAnnouncement.requestConfig = goPcmSpiritStoneGetAnnouncementRequestConfig;
const mockUrl_0_0_0_4 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_4 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_4 = "https://www.webnovel.com";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 [get-moment-list 获取moments列表↗](https://yapi.yuewen.com/project/2309/interface/api/175528) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmUserGetMomentList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-moment-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [
        "userId",
        "appId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetMomentList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-moment-list 获取moments列表↗](https://yapi.yuewen.com/project/2309/interface/api/175528) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-moment-list`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmUserGetMomentList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetMomentList2RequestConfig, requestData), ...args);
};
goPcmUserGetMomentList2.requestConfig = goPcmUserGetMomentList2RequestConfig;
/**
 * 接口 [get-获取作家主页-485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175536) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-author-page`
 * @更新时间 `2021-06-23 14:34:15`
 */ const goPcmUserGetAuthorPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-author-page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [
        "userId",
        "appId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetAuthorPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-获取作家主页-485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175536) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-author-page`
 * @更新时间 `2021-06-23 14:34:15`
 */ const goPcmUserGetAuthorPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetAuthorPageRequestConfig, requestData), ...args);
};
goPcmUserGetAuthorPage.requestConfig = goPcmUserGetAuthorPageRequestConfig;
/**
 * 接口 [like - 个人主页点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175541) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/like`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmUserLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/like",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserLike",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [like - 个人主页点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175541) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/like`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmUserLike = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserLikeRequestConfig, requestData), ...args);
};
goPcmUserLike.requestConfig = goPcmUserLikeRequestConfig;
/**
 * 接口 [set-background-image设置背景图↗](https://yapi.yuewen.com/project/2309/interface/api/175543) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/set-background-image`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmUserSetBackgroundImageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/set-background-image",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [
        "userId",
        "appId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSetBackgroundImage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [set-background-image设置背景图↗](https://yapi.yuewen.com/project/2309/interface/api/175543) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/set-background-image`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmUserSetBackgroundImage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserSetBackgroundImageRequestConfig, requestData), ...args);
};
goPcmUserSetBackgroundImage.requestConfig = goPcmUserSetBackgroundImageRequestConfig;
/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/2309/interface/api/175551) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2021-04-01 14:07:36`
 */ const goPcmUserGetFirstCharge2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-first-charge",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetFirstCharge2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户首充奖励详情↗](https://yapi.yuewen.com/project/2309/interface/api/175551) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-first-charge`
 * @更新时间 `2021-04-01 14:07:36`
 */ const goPcmUserGetFirstCharge2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetFirstCharge2RequestConfig, requestData), ...args);
};
goPcmUserGetFirstCharge2.requestConfig = goPcmUserGetFirstCharge2RequestConfig;
/**
 * 接口 [获取用户主页（主客态）485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175556) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2021-06-23 14:58:29`
 */ const goPcmUserGetHomePage2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-home-page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [
        "userId",
        "appId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetHomePage2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户主页（主客态）485新增↗](https://yapi.yuewen.com/project/2309/interface/api/175556) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-home-page`
 * @更新时间 `2021-06-23 14:58:29`
 */ const goPcmUserGetHomePage2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetHomePage2RequestConfig, requestData), ...args);
};
goPcmUserGetHomePage2.requestConfig = goPcmUserGetHomePage2RequestConfig;
/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/177867) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoAjax`
 * @更新时间 `2021-06-03 10:12:40`
 */ const goPcmUserUserInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/userInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserUserInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/177867) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoAjax`
 * @更新时间 `2021-06-03 10:12:40`
 */ const goPcmUserUserInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserUserInfoAjaxRequestConfig, requestData), ...args);
};
goPcmUserUserInfoAjax.requestConfig = goPcmUserUserInfoAjaxRequestConfig;
/**
 * 接口 [设置用户头像【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178321) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserAvatar`
 * @更新时间 `2020-12-14 20:06:39`
 */ const goPcmUserSetUserAvatarRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/setUserAvatar",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSetUserAvatar",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [设置用户头像【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178321) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserAvatar`
 * @更新时间 `2020-12-14 20:06:39`
 */ const goPcmUserSetUserAvatar = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserSetUserAvatarRequestConfig, requestData), ...args);
};
goPcmUserSetUserAvatar.requestConfig = goPcmUserSetUserAvatarRequestConfig;
/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178529) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoReact`
 * @更新时间 `2020-12-14 20:06:34`
 */ const goPcmUserUserInfoReactRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/userInfoReact",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserUserInfoReact",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户信息【M】↗](https://yapi.yuewen.com/project/2309/interface/api/178529) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/userInfoReact`
 * @更新时间 `2020-12-14 20:06:34`
 */ const goPcmUserUserInfoReact = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserUserInfoReactRequestConfig, requestData), ...args);
};
goPcmUserUserInfoReact.requestConfig = goPcmUserUserInfoReactRequestConfig;
/**
 * 接口 [校验邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179048) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserEmail`
 * @更新时间 `2020-12-22 13:54:27`
 */ const goPcmUserCheckUserEmailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/checkUserEmail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserCheckUserEmail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [校验邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179048) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserEmail`
 * @更新时间 `2020-12-22 13:54:27`
 */ const goPcmUserCheckUserEmail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserCheckUserEmailRequestConfig, requestData), ...args);
};
goPcmUserCheckUserEmail.requestConfig = goPcmUserCheckUserEmailRequestConfig;
/**
 * 接口 [检测用户名【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179053) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserName`
 * @更新时间 `2020-12-09 21:36:07`
 */ const goPcmUserCheckUserNameRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/checkUserName",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.none */.Py.none,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserCheckUserName",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [检测用户名【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179053) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/checkUserName`
 * @更新时间 `2020-12-09 21:36:07`
 */ const goPcmUserCheckUserName = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserCheckUserNameRequestConfig, requestData), ...args);
};
goPcmUserCheckUserName.requestConfig = goPcmUserCheckUserNameRequestConfig;
/**
 * 接口 [绑定邮箱发送验证码【PC&&M】↗](https://yapi.yuewen.com/project/2309/interface/api/179063) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/FirstAddEmail`
 * @更新时间 `2020-12-14 20:04:56`
 */ const goPcmUserFirstAddEmailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/FirstAddEmail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserFirstAddEmail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [绑定邮箱发送验证码【PC&&M】↗](https://yapi.yuewen.com/project/2309/interface/api/179063) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/FirstAddEmail`
 * @更新时间 `2020-12-14 20:04:56`
 */ const goPcmUserFirstAddEmail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserFirstAddEmailRequestConfig, requestData), ...args);
};
goPcmUserFirstAddEmail.requestConfig = goPcmUserFirstAddEmailRequestConfig;
/**
 * 接口 [用户等级页,需要登陆态【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179243) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getPage`
 * @更新时间 `2020-12-14 20:05:14`
 */ const goPcmUserGetPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [用户等级页,需要登陆态【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179243) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getPage`
 * @更新时间 `2020-12-14 20:05:14`
 */ const goPcmUserGetPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetPageRequestConfig, requestData), ...args);
};
goPcmUserGetPage.requestConfig = goPcmUserGetPageRequestConfig;
/**
 * 接口 [获取用户设置页面数据【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179267) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserSettings`
 * @更新时间 `2020-12-22 16:58:21`
 */ const goPcmUserGetUserSettingsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getUserSettings",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetUserSettings",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户设置页面数据【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179267) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserSettings`
 * @更新时间 `2020-12-22 16:58:21`
 */ const goPcmUserGetUserSettings = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetUserSettingsRequestConfig, requestData), ...args);
};
goPcmUserGetUserSettings.requestConfig = goPcmUserGetUserSettingsRequestConfig;
/**
 * 接口 [确认修改邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179437) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/modifyEmail`
 * @更新时间 `2020-12-23 10:57:19`
 */ const goPcmUserModifyEmailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/modifyEmail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserModifyEmail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [确认修改邮箱【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179437) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/modifyEmail`
 * @更新时间 `2020-12-23 10:57:19`
 */ const goPcmUserModifyEmail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserModifyEmailRequestConfig, requestData), ...args);
};
goPcmUserModifyEmail.requestConfig = goPcmUserModifyEmailRequestConfig;
/**
 * 接口 [给新老邮箱发送验证码【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179518) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/sendCaptchaToEmail`
 * @更新时间 `2020-12-22 20:46:08`
 */ const goPcmUserSendCaptchaToEmailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/sendCaptchaToEmail",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSendCaptchaToEmail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [给新老邮箱发送验证码【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179518) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/sendCaptchaToEmail`
 * @更新时间 `2020-12-22 20:46:08`
 */ const goPcmUserSendCaptchaToEmail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserSendCaptchaToEmailRequestConfig, requestData), ...args);
};
goPcmUserSendCaptchaToEmail.requestConfig = goPcmUserSendCaptchaToEmailRequestConfig;
/**
 * 接口 [更改个人设置【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179529) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserSettings`
 * @更新时间 `2020-12-23 11:11:15`
 */ const goPcmUserSetUserSettingsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/setUserSettings",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserSetUserSettings",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [更改个人设置【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179529) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/setUserSettings`
 * @更新时间 `2020-12-23 11:11:15`
 */ const goPcmUserSetUserSettings = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserSetUserSettingsRequestConfig, requestData), ...args);
};
goPcmUserSetUserSettings.requestConfig = goPcmUserSetUserSettingsRequestConfig;
/**
 * 接口 [上传用户头像【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179550) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/go/pcm/user/uploadTmpAvatar`
 * @更新时间 `2020-12-14 20:09:59`
 */ const goPcmGoPcmUserUploadTmpAvatarRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/go/pcm/user/uploadTmpAvatar",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGoPcmUserUploadTmpAvatar",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [上传用户头像【PC】↗](https://yapi.yuewen.com/project/2309/interface/api/179550) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/go/pcm/user/uploadTmpAvatar`
 * @更新时间 `2020-12-14 20:09:59`
 */ const goPcmGoPcmUserUploadTmpAvatar = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGoPcmUserUploadTmpAvatarRequestConfig, requestData), ...args);
};
goPcmGoPcmUserUploadTmpAvatar.requestConfig = goPcmGoPcmUserUploadTmpAvatarRequestConfig;
/**
 * 接口 [验证邮箱验证码↗](https://yapi.yuewen.com/project/2309/interface/api/179568) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/verifyCaptcha`
 * @更新时间 `2020-12-15 10:59:11`
 */ const goPcmUserVerifyCaptchaRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/verifyCaptcha",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.none */.Py.none,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserVerifyCaptcha",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [验证邮箱验证码↗](https://yapi.yuewen.com/project/2309/interface/api/179568) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/verifyCaptcha`
 * @更新时间 `2020-12-15 10:59:11`
 */ const goPcmUserVerifyCaptcha = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserVerifyCaptchaRequestConfig, requestData), ...args);
};
goPcmUserVerifyCaptcha.requestConfig = goPcmUserVerifyCaptchaRequestConfig;
/**
 * 接口 [获取用户设置页面数据【M】↗](https://yapi.yuewen.com/project/2309/interface/api/179582) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserMSettings`
 * @更新时间 `2020-12-23 11:13:18`
 */ const goPcmUserGetUserMSettingsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getUserMSettings",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetUserMSettings",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户设置页面数据【M】↗](https://yapi.yuewen.com/project/2309/interface/api/179582) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserMSettings`
 * @更新时间 `2020-12-23 11:13:18`
 */ const goPcmUserGetUserMSettings = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetUserMSettingsRequestConfig, requestData), ...args);
};
goPcmUserGetUserMSettings.requestConfig = goPcmUserGetUserMSettingsRequestConfig;
/**
 * 接口 [举报↗](https://yapi.yuewen.com/project/2309/interface/api/197461) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/reportUserOrBook`
 * @更新时间 `2021-02-04 14:56:15`
 */ const goPcmUserReportUserOrBookRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/reportUserOrBook",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserReportUserOrBook",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [举报↗](https://yapi.yuewen.com/project/2309/interface/api/197461) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `POST /go/pcm/user/reportUserOrBook`
 * @更新时间 `2021-02-04 14:56:15`
 */ const goPcmUserReportUserOrBook = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserReportUserOrBookRequestConfig, requestData), ...args);
};
goPcmUserReportUserOrBook.requestConfig = goPcmUserReportUserOrBookRequestConfig;
/**
 * 接口 [拉取用户等级数据↗](https://yapi.yuewen.com/project/2309/interface/api/197928) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserLevel`
 * @更新时间 `2021-02-22 17:08:52`
 */ const goPcmUserGetUserLevelRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getUserLevel",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetUserLevel",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取用户等级数据↗](https://yapi.yuewen.com/project/2309/interface/api/197928) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getUserLevel`
 * @更新时间 `2021-02-22 17:08:52`
 */ const goPcmUserGetUserLevel = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetUserLevelRequestConfig, requestData), ...args);
};
goPcmUserGetUserLevel.requestConfig = goPcmUserGetUserLevelRequestConfig;
/**
 * 接口 [个人主页直出页面↗](https://yapi.yuewen.com/project/2309/interface/api/197945) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getProfileInfo`
 * @更新时间 `2021-02-23 13:42:31`
 */ const goPcmUserGetProfileInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getProfileInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [
        "guid",
        "appId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetProfileInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [个人主页直出页面↗](https://yapi.yuewen.com/project/2309/interface/api/197945) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getProfileInfo`
 * @更新时间 `2021-02-23 13:42:31`
 */ const goPcmUserGetProfileInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetProfileInfoRequestConfig, requestData), ...args);
};
goPcmUserGetProfileInfo.requestConfig = goPcmUserGetProfileInfoRequestConfig;
/**
 * 接口 [现金流水↗](https://yapi.yuewen.com/project/2309/interface/api/244296) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-cash-flow`
 * @更新时间 `2022-08-19 13:59:14`
 */ const goPcmUserGetCashFlowRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/get-cash-flow",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetCashFlow",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [现金流水↗](https://yapi.yuewen.com/project/2309/interface/api/244296) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/get-cash-flow`
 * @更新时间 `2022-08-19 13:59:14`
 */ const goPcmUserGetCashFlow = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetCashFlowRequestConfig, requestData), ...args);
};
goPcmUserGetCashFlow.requestConfig = goPcmUserGetCashFlowRequestConfig;
/**
 * 接口 [注销账户↗](https://yapi.yuewen.com/project/2309/interface/api/275729) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/cancelUser`
 * @更新时间 `2023-11-29 16:08:07`
 */ const goPcmUserCancelUserRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/cancelUser",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [
        "verifyCode"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserCancelUser",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [注销账户↗](https://yapi.yuewen.com/project/2309/interface/api/275729) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/cancelUser`
 * @更新时间 `2023-11-29 16:08:07`
 */ const goPcmUserCancelUser = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserCancelUserRequestConfig, requestData), ...args);
};
goPcmUserCancelUser.requestConfig = goPcmUserCancelUserRequestConfig;
/**
 * 接口 [获取注销账号条件判断↗](https://yapi.yuewen.com/project/2309/interface/api/275735) 的 **请求配置**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getCancelUserData`
 * @更新时间 `2023-11-13 14:34:26`
 */ const goPcmUserGetCancelUserDataRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_4,
    devUrl: devUrl_0_0_0_4,
    prodUrl: prodUrl_0_0_0_4,
    path: "/go/pcm/user/getCancelUserData",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_4,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUserGetCancelUserData",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取注销账号条件判断↗](https://yapi.yuewen.com/project/2309/interface/api/275735) 的 **请求函数**
 *
 * @分类 [user - 用户主页↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22845)
 * @请求头 `GET /go/pcm/user/getCancelUserData`
 * @更新时间 `2023-11-13 14:34:26`
 */ const goPcmUserGetCancelUserData = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUserGetCancelUserDataRequestConfig, requestData), ...args);
};
goPcmUserGetCancelUserData.requestConfig = goPcmUserGetCancelUserDataRequestConfig;
const mockUrl_0_0_0_5 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_5 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_5 = "https://www.webnovel.com";
const dataKey_0_0_0_5 = "data";
/**
 * 接口 [评论emoji映射Map↗](https://yapi.yuewen.com/project/2309/interface/api/175558) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmEmojiGetEmoji2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/emoji/getEmoji",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmEmojiGetEmoji2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [评论emoji映射Map↗](https://yapi.yuewen.com/project/2309/interface/api/175558) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/emoji/getEmoji`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmEmojiGetEmoji2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmEmojiGetEmoji2RequestConfig, requestData), ...args);
};
goPcmEmojiGetEmoji2.requestConfig = goPcmEmojiGetEmoji2RequestConfig;
/**
 * 接口 [举报评论（书 章 段）↗](https://yapi.yuewen.com/project/2309/interface/api/175566) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/report`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmBookReviewReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/report",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [举报评论（书 章 段）↗](https://yapi.yuewen.com/project/2309/interface/api/175566) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/report`
 * @更新时间 `2020-12-02 19:36:36`
 */ const goPcmBookReviewReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewReportRequestConfig, requestData), ...args);
};
goPcmBookReviewReport.requestConfig = goPcmBookReviewReportRequestConfig;
/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/2309/interface/api/175571) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/add`
 * @更新时间 `2022-06-23 16:13:07`
 */ const goPcmBookReviewAddRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/add",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewAdd",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加书评↗](https://yapi.yuewen.com/project/2309/interface/api/175571) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/add`
 * @更新时间 `2022-06-23 16:13:07`
 */ const goPcmBookReviewAdd = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewAddRequestConfig, requestData), ...args);
};
goPcmBookReviewAdd.requestConfig = goPcmBookReviewAddRequestConfig;
/**
 * 接口 [书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/175573) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/get-reviews`
 * @更新时间 `2021-10-25 11:29:53`
 */ const goPcmBookReviewGetReviewsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/get-reviews",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "bookId",
        "needSummary",
        "orderBy",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewGetReviews",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/175573) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/get-reviews`
 * @更新时间 `2021-10-25 11:29:53`
 */ const goPcmBookReviewGetReviews = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewGetReviewsRequestConfig, requestData), ...args);
};
goPcmBookReviewGetReviews.requestConfig = goPcmBookReviewGetReviewsRequestConfig;
/**
 * 接口 [书评详情↗](https://yapi.yuewen.com/project/2309/interface/api/175581) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/detail`
 * @更新时间 `2021-10-25 11:29:25`
 */ const goPcmBookReviewDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/detail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [
        "bookId",
        "reviewId",
        "pageIndex",
        "replyId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书评详情↗](https://yapi.yuewen.com/project/2309/interface/api/175581) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/detail`
 * @更新时间 `2021-10-25 11:29:25`
 */ const goPcmBookReviewDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewDetailRequestConfig, requestData), ...args);
};
goPcmBookReviewDetail.requestConfig = goPcmBookReviewDetailRequestConfig;
/**
 * 接口 [点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175586) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/like`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/like",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewLike",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175586) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/like`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewLike = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewLikeRequestConfig, requestData), ...args);
};
goPcmBookReviewLike.requestConfig = goPcmBookReviewLikeRequestConfig;
/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/2309/interface/api/175588) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewEssence2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/essence",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewEssence2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [加精↗](https://yapi.yuewen.com/project/2309/interface/api/175588) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/essence`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewEssence2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewEssence2RequestConfig, requestData), ...args);
};
goPcmBookReviewEssence2.requestConfig = goPcmBookReviewEssence2RequestConfig;
/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/2309/interface/api/175596) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/remove`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewRemoveRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/remove",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewRemove",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [删除书评↗](https://yapi.yuewen.com/project/2309/interface/api/175596) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/remove`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewRemove = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewRemoveRequestConfig, requestData), ...args);
};
goPcmBookReviewRemove.requestConfig = goPcmBookReviewRemoveRequestConfig;
/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/2309/interface/api/175601) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewSetTop2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/setTop",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewSetTop2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [置顶↗](https://yapi.yuewen.com/project/2309/interface/api/175601) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/setTop`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewSetTop2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewSetTop2RequestConfig, requestData), ...args);
};
goPcmBookReviewSetTop2.requestConfig = goPcmBookReviewSetTop2RequestConfig;
/**
 * 接口 [添加回复↗](https://yapi.yuewen.com/project/2309/interface/api/175603) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/addReply`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewAddReplyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/addReply",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewAddReply",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [添加回复↗](https://yapi.yuewen.com/project/2309/interface/api/175603) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `POST /go/pcm/bookReview/addReply`
 * @更新时间 `2020-12-02 19:36:37`
 */ const goPcmBookReviewAddReply = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewAddReplyRequestConfig, requestData), ...args);
};
goPcmBookReviewAddReply.requestConfig = goPcmBookReviewAddReplyRequestConfig;
/**
 * 接口 [CR 书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/253380) 的 **请求配置**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/matrix/get-reviews`
 * @更新时间 `2022-12-20 10:46:36`
 */ const goPcmBookReviewMatrixGetReviewsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_5,
    devUrl: devUrl_0_0_0_5,
    prodUrl: prodUrl_0_0_0_5,
    path: "/go/pcm/bookReview/matrix/get-reviews",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_5,
    paramNames: [],
    queryNames: [
        "bookId",
        "sortType",
        "pageIndex",
        "contentFilter",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookReviewMatrixGetReviews",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [CR 书评列表↗](https://yapi.yuewen.com/project/2309/interface/api/253380) 的 **请求函数**
 *
 * @分类 [bookReview-书评↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22854)
 * @请求头 `GET /go/pcm/bookReview/matrix/get-reviews`
 * @更新时间 `2022-12-20 10:46:36`
 */ const goPcmBookReviewMatrixGetReviews = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookReviewMatrixGetReviewsRequestConfig, requestData), ...args);
};
goPcmBookReviewMatrixGetReviews.requestConfig = goPcmBookReviewMatrixGetReviewsRequestConfig;
const mockUrl_0_0_0_6 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_6 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_6 = "https://www.webnovel.com";
const dataKey_0_0_0_6 = "data";
/**
 * 接口 [搜索下拉加载(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175761) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/result`
 * @更新时间 `2020-12-02 19:36:38`
 */ const goPcmSearchResultRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/result",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "keywords",
        "type"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchResult",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [搜索下拉加载(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175761) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/result`
 * @更新时间 `2020-12-02 19:36:38`
 */ const goPcmSearchResult = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSearchResultRequestConfig, requestData), ...args);
};
goPcmSearchResult.requestConfig = goPcmSearchResultRequestConfig;
/**
 * 接口 [搜索页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175776) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/resultPage`
 * @更新时间 `2022-03-01 17:18:30`
 */ const goPcmSearchResultPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/resultPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "keywords",
        "type"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchResultPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [搜索页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/175776) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/resultPage`
 * @更新时间 `2022-03-01 17:18:30`
 */ const goPcmSearchResultPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSearchResultPageRequestConfig, requestData), ...args);
};
goPcmSearchResultPage.requestConfig = goPcmSearchResultPageRequestConfig;
/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/2309/interface/api/191345) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/getHotSearch`
 * @更新时间 `2021-01-13 15:22:49`
 */ const goPcmSearchGetHotSearchRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/getHotSearch",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchGetHotSearch",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取热门搜索↗](https://yapi.yuewen.com/project/2309/interface/api/191345) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/getHotSearch`
 * @更新时间 `2021-01-13 15:22:49`
 */ const goPcmSearchGetHotSearch = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSearchGetHotSearchRequestConfig, requestData), ...args);
};
goPcmSearchGetHotSearch.requestConfig = goPcmSearchGetHotSearchRequestConfig;
/**
 * 接口 [获取搜索联想↗](https://yapi.yuewen.com/project/2309/interface/api/191352) 的 **请求配置**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/autoComplete`
 * @更新时间 `2021-01-21 11:03:30`
 */ const goPcmSearchAutoCompleteRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_6,
    devUrl: devUrl_0_0_0_6,
    prodUrl: prodUrl_0_0_0_6,
    path: "/go/pcm/search/autoComplete",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_6,
    paramNames: [],
    queryNames: [
        "keywords"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSearchAutoComplete",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取搜索联想↗](https://yapi.yuewen.com/project/2309/interface/api/191352) 的 **请求函数**
 *
 * @分类 [Search↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22892)
 * @请求头 `GET /go/pcm/search/autoComplete`
 * @更新时间 `2021-01-21 11:03:30`
 */ const goPcmSearchAutoComplete = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSearchAutoCompleteRequestConfig, requestData), ...args);
};
goPcmSearchAutoComplete.requestConfig = goPcmSearchAutoCompleteRequestConfig;
const mockUrl_0_0_0_7 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_7 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_7 = "https://www.webnovel.com";
const dataKey_0_0_0_7 = "data";
/**
 * 接口 [【go】删除↗](https://yapi.yuewen.com/project/2309/interface/api/175918) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/deleteReview`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewDeleteReviewRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/deleteReview",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewDeleteReview",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【go】删除↗](https://yapi.yuewen.com/project/2309/interface/api/175918) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/deleteReview`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewDeleteReview = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterReviewDeleteReviewRequestConfig, requestData), ...args);
};
goPcmChapterReviewDeleteReview.requestConfig = goPcmChapterReviewDeleteReviewRequestConfig;
/**
 * 接口 [【go】点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175926) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/likeReview`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewLikeReviewRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/likeReview",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [
        "reviewId",
        "opType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewLikeReview",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【go】点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175926) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/likeReview`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewLikeReview = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterReviewLikeReviewRequestConfig, requestData), ...args);
};
goPcmChapterReviewLikeReview.requestConfig = goPcmChapterReviewLikeReviewRequestConfig;
/**
 * 接口 [【go】获取回复贴↗](https://yapi.yuewen.com/project/2309/interface/api/175931) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewGetReviewReplysRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/getReviewReplys",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "reviewId",
        "lastReviewId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewGetReviewReplys",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【go】获取回复贴↗](https://yapi.yuewen.com/project/2309/interface/api/175931) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewGetReviewReplys = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterReviewGetReviewReplysRequestConfig, requestData), ...args);
};
goPcmChapterReviewGetReviewReplys.requestConfig = goPcmChapterReviewGetReviewReplysRequestConfig;
/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/2309/interface/api/175933) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2022-10-18 18:49:51`
 */ const goPcmChapterReviewGetReviewList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/getReviewList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "pageIndex",
        "orderType",
        "replyId",
        "lastReviewId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewGetReviewList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【go】获取章评↗](https://yapi.yuewen.com/project/2309/interface/api/175933) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `GET /go/pcm/chapterReview/getReviewList`
 * @更新时间 `2022-10-18 18:49:51`
 */ const goPcmChapterReviewGetReviewList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterReviewGetReviewList2RequestConfig, requestData), ...args);
};
goPcmChapterReviewGetReviewList2.requestConfig = goPcmChapterReviewGetReviewList2RequestConfig;
/**
 * 接口 [【go】新增章评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175941) 的 **请求配置**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/addReview`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewAddReviewRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_7,
    devUrl: devUrl_0_0_0_7,
    prodUrl: prodUrl_0_0_0_7,
    path: "/go/pcm/chapterReview/addReview",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_7,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmChapterReviewAddReview",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【go】新增章评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175941) 的 **请求函数**
 *
 * @分类 [ChapterReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22922)
 * @请求头 `POST /go/pcm/chapterReview/addReview`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmChapterReviewAddReview = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmChapterReviewAddReviewRequestConfig, requestData), ...args);
};
goPcmChapterReviewAddReview.requestConfig = goPcmChapterReviewAddReviewRequestConfig;
const mockUrl_0_0_0_8 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_8 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_8 = "https://www.webnovel.com";
const dataKey_0_0_0_8 = "data";
/**
 * 接口 [新增段评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175971) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/add`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewAddRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/add",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewAdd",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [新增段评或回复↗](https://yapi.yuewen.com/project/2309/interface/api/175971) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/add`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewAdd = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewAddRequestConfig, requestData), ...args);
};
goPcmParagraphReviewAdd.requestConfig = goPcmParagraphReviewAddRequestConfig;
/**
 * 接口 [获取各段评论数接口↗](https://yapi.yuewen.com/project/2309/interface/api/175976) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewNum`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReiewNumRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReiewNum",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReiewNum",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取各段评论数接口↗](https://yapi.yuewen.com/project/2309/interface/api/175976) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewNum`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReiewNum = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewGetReiewNumRequestConfig, requestData), ...args);
};
goPcmParagraphReviewGetReiewNum.requestConfig = goPcmParagraphReviewGetReiewNumRequestConfig;
/**
 * 接口 [获取段评主贴列表↗](https://yapi.yuewen.com/project/2309/interface/api/175978) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewList`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReiewListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReiewList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [
        "chapterId",
        "paragraphId",
        "lastTime"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReiewList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取段评主贴列表↗](https://yapi.yuewen.com/project/2309/interface/api/175978) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReiewList`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReiewList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewGetReiewListRequestConfig, requestData), ...args);
};
goPcmParagraphReviewGetReiewList.requestConfig = goPcmParagraphReviewGetReiewListRequestConfig;
/**
 * 接口 [获取段评主贴回复列表↗](https://yapi.yuewen.com/project/2309/interface/api/175986) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReieweReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReieweReplysRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReieweReplys",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [
        "chapterId",
        "paragraphId",
        "reviewId",
        "lastTime"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReieweReplys",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取段评主贴回复列表↗](https://yapi.yuewen.com/project/2309/interface/api/175986) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReieweReplys`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReieweReplys = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewGetReieweReplysRequestConfig, requestData), ...args);
};
goPcmParagraphReviewGetReieweReplys.requestConfig = goPcmParagraphReviewGetReieweReplysRequestConfig;
/**
 * 接口 [段评点赞\/取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175991) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/like`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/like",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewLike",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [段评点赞\/取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/175991) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/like`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewLike = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewLikeRequestConfig, requestData), ...args);
};
goPcmParagraphReviewLike.requestConfig = goPcmParagraphReviewLikeRequestConfig;
/**
 * 接口 [段评举报↗](https://yapi.yuewen.com/project/2309/interface/api/175993) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/report`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/report",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [段评举报↗](https://yapi.yuewen.com/project/2309/interface/api/175993) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/report`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewReportRequestConfig, requestData), ...args);
};
goPcmParagraphReviewReport.requestConfig = goPcmParagraphReviewReportRequestConfig;
/**
 * 接口 [段评删除↗](https://yapi.yuewen.com/project/2309/interface/api/176001) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/delete`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewDeleteRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/delete",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewDelete",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [段评删除↗](https://yapi.yuewen.com/project/2309/interface/api/176001) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `POST /go/pcm/paragraphReview/delete`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewDelete = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewDeleteRequestConfig, requestData), ...args);
};
goPcmParagraphReviewDelete.requestConfig = goPcmParagraphReviewDeleteRequestConfig;
/**
 * 接口 [段评列表消息跳转接口↗](https://yapi.yuewen.com/project/2309/interface/api/176006) 的 **请求配置**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReviewDetail`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReviewDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_8,
    devUrl: devUrl_0_0_0_8,
    prodUrl: prodUrl_0_0_0_8,
    path: "/go/pcm/paragraphReview/getReviewDetail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_8,
    paramNames: [],
    queryNames: [
        "chapterId",
        "paragraphId",
        "lastTime",
        "replyId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmParagraphReviewGetReviewDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [段评列表消息跳转接口↗](https://yapi.yuewen.com/project/2309/interface/api/176006) 的 **请求函数**
 *
 * @分类 [ParagraphReview↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22926)
 * @请求头 `GET /go/pcm/paragraphReview/getReviewDetail`
 * @更新时间 `2020-12-02 19:36:40`
 */ const goPcmParagraphReviewGetReviewDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmParagraphReviewGetReviewDetailRequestConfig, requestData), ...args);
};
goPcmParagraphReviewGetReviewDetail.requestConfig = goPcmParagraphReviewGetReviewDetailRequestConfig;
const mockUrl_0_0_0_9 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_9 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_9 = "https://www.webnovel.com";
const dataKey_0_0_0_9 = "data";
/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/2309/interface/api/176038) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmNotificationListAjax2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/listAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationListAjax2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【新】listAjax 通知ajax↗](https://yapi.yuewen.com/project/2309/interface/api/176038) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listAjax`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmNotificationListAjax2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmNotificationListAjax2RequestConfig, requestData), ...args);
};
goPcmNotificationListAjax2.requestConfig = goPcmNotificationListAjax2RequestConfig;
/**
 * 接口 [【新】listPage 通知直出页↗](https://yapi.yuewen.com/project/2309/interface/api/176046) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listPage`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmNotificationListPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/listPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationListPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【新】listPage 通知直出页↗](https://yapi.yuewen.com/project/2309/interface/api/176046) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/listPage`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmNotificationListPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmNotificationListPageRequestConfig, requestData), ...args);
};
goPcmNotificationListPage.requestConfig = goPcmNotificationListPageRequestConfig;
/**
 * 接口 [systemList - 系统通知列表↗](https://yapi.yuewen.com/project/2309/interface/api/195895) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/systemList`
 * @更新时间 `2021-01-28 15:18:11`
 */ const goPcmNotificationSystemListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/systemList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationSystemList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [systemList - 系统通知列表↗](https://yapi.yuewen.com/project/2309/interface/api/195895) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/systemList`
 * @更新时间 `2021-01-28 15:18:11`
 */ const goPcmNotificationSystemList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmNotificationSystemListRequestConfig, requestData), ...args);
};
goPcmNotificationSystemList.requestConfig = goPcmNotificationSystemListRequestConfig;
/**
 * 接口 [status - 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/2309/interface/api/195900) 的 **请求配置**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/status`
 * @更新时间 `2021-01-28 15:25:38`
 */ const goPcmNotificationStatusRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_9,
    devUrl: devUrl_0_0_0_9,
    prodUrl: prodUrl_0_0_0_9,
    path: "/go/pcm/notification/status",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_9,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmNotificationStatus",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [status - 获取通知、系统通知、消息状态↗](https://yapi.yuewen.com/project/2309/interface/api/195900) 的 **请求函数**
 *
 * @分类 [Notification↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22943)
 * @请求头 `GET /go/pcm/notification/status`
 * @更新时间 `2021-01-28 15:25:38`
 */ const goPcmNotificationStatus = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmNotificationStatusRequestConfig, requestData), ...args);
};
goPcmNotificationStatus.requestConfig = goPcmNotificationStatusRequestConfig;
const mockUrl_0_0_0_10 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_10 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_10 = "https://www.webnovel.com";
const dataKey_0_0_0_10 = "data";
/**
 * 接口 [jump↗](https://yapi.yuewen.com/project/2309/interface/api/176111) 的 **请求配置**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/jump`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmShortUrlJumpRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_10,
    devUrl: devUrl_0_0_0_10,
    prodUrl: prodUrl_0_0_0_10,
    path: "/go/pcm/shortUrl/jump",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_10,
    paramNames: [],
    queryNames: [
        "shortUrl"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmShortUrlJump",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [jump↗](https://yapi.yuewen.com/project/2309/interface/api/176111) 的 **请求函数**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/jump`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmShortUrlJump = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmShortUrlJumpRequestConfig, requestData), ...args);
};
goPcmShortUrlJump.requestConfig = goPcmShortUrlJumpRequestConfig;
/**
 * 接口 [生成短链↗](https://yapi.yuewen.com/project/2309/interface/api/176113) 的 **请求配置**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/generate`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmShortUrlGenerateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_10,
    devUrl: devUrl_0_0_0_10,
    prodUrl: prodUrl_0_0_0_10,
    path: "/go/pcm/shortUrl/generate",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_10,
    paramNames: [],
    queryNames: [
        "longUrl",
        "from"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmShortUrlGenerate",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [生成短链↗](https://yapi.yuewen.com/project/2309/interface/api/176113) 的 **请求函数**
 *
 * @分类 [短链接↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22956)
 * @请求头 `GET /go/pcm/shortUrl/generate`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmShortUrlGenerate = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmShortUrlGenerateRequestConfig, requestData), ...args);
};
goPcmShortUrlGenerate.requestConfig = goPcmShortUrlGenerateRequestConfig;
const mockUrl_0_0_0_11 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_11 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_11 = "https://www.webnovel.com";
const dataKey_0_0_0_11 = "data";
/**
 * 接口 [去除激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176143) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/deactivate`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmValidatorDeactivateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/deactivate",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: [
        "validator",
        "guid"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorDeactivate",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [去除激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176143) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/deactivate`
 * @更新时间 `2020-12-02 19:36:41`
 */ const goPcmValidatorDeactivate = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmValidatorDeactivateRequestConfig, requestData), ...args);
};
goPcmValidatorDeactivate.requestConfig = goPcmValidatorDeactivateRequestConfig;
/**
 * 接口 [激活用户与邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176156) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `POST /go/pcm/validator/activate`
 * @更新时间 `2020-12-02 19:36:42`
 */ const goPcmValidatorActivateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/activate",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorActivate",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [激活用户与邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176156) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `POST /go/pcm/validator/activate`
 * @更新时间 `2020-12-02 19:36:42`
 */ const goPcmValidatorActivate = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmValidatorActivateRequestConfig, requestData), ...args);
};
goPcmValidatorActivate.requestConfig = goPcmValidatorActivateRequestConfig;
/**
 * 接口 [生成邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176158) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/generate`
 * @更新时间 `2020-12-02 19:36:42`
 */ const goPcmValidatorGenerateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/generate",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: [
        "authKey",
        "num"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorGenerate",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [生成邀请码↗](https://yapi.yuewen.com/project/2309/interface/api/176158) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/generate`
 * @更新时间 `2020-12-02 19:36:42`
 */ const goPcmValidatorGenerate = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmValidatorGenerateRequestConfig, requestData), ...args);
};
goPcmValidatorGenerate.requestConfig = goPcmValidatorGenerateRequestConfig;
/**
 * 接口 [获取用户邀请码激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176173) 的 **请求配置**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/queryActivate`
 * @更新时间 `2020-12-02 19:36:42`
 */ const goPcmValidatorQueryActivateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_11,
    devUrl: devUrl_0_0_0_11,
    prodUrl: prodUrl_0_0_0_11,
    path: "/go/pcm/validator/queryActivate",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_11,
    paramNames: [],
    queryNames: [
        "guid"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmValidatorQueryActivate",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户邀请码激活状态↗](https://yapi.yuewen.com/project/2309/interface/api/176173) 的 **请求函数**
 *
 * @分类 [邀请码相关↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22964)
 * @请求头 `GET /go/pcm/validator/queryActivate`
 * @更新时间 `2020-12-02 19:36:42`
 */ const goPcmValidatorQueryActivate = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmValidatorQueryActivateRequestConfig, requestData), ...args);
};
goPcmValidatorQueryActivate.requestConfig = goPcmValidatorQueryActivateRequestConfig;
const mockUrl_0_0_0_12 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_12 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_12 = "https://www.webnovel.com";
const dataKey_0_0_0_12 = "data";
/**
 * 接口 [获取作品消息列表 470新增↗](https://yapi.yuewen.com/project/2309/interface/api/176323) 的 **请求配置**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22998)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2020-12-02 19:36:43`
 */ const goPcmMessageGetFollowing2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_12,
    devUrl: devUrl_0_0_0_12,
    prodUrl: prodUrl_0_0_0_12,
    path: "/go/pcm/message/getFollowing",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_12,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetFollowing2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取作品消息列表 470新增↗](https://yapi.yuewen.com/project/2309/interface/api/176323) 的 **请求函数**
 *
 * @分类 [Message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_22998)
 * @请求头 `GET /go/pcm/message/getFollowing`
 * @更新时间 `2020-12-02 19:36:43`
 */ const goPcmMessageGetFollowing2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMessageGetFollowing2RequestConfig, requestData), ...args);
};
goPcmMessageGetFollowing2.requestConfig = goPcmMessageGetFollowing2RequestConfig;
const mockUrl_0_0_0_13 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_13 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_13 = "https://www.webnovel.com";
const dataKey_0_0_0_13 = "data";
/**
 * 接口 [getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/2309/interface/api/176376) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-12-03 16:35:34`
 */ const goPcmBookGetBatchSubscribeGrade2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBatchSubscribeGrade",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBatchSubscribeGrade2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getBatchSubscribeGrade 获取批量订阅档位信息↗](https://yapi.yuewen.com/project/2309/interface/api/176376) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBatchSubscribeGrade`
 * @更新时间 `2020-12-03 16:35:34`
 */ const goPcmBookGetBatchSubscribeGrade2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBatchSubscribeGrade2RequestConfig, requestData), ...args);
};
goPcmBookGetBatchSubscribeGrade2.requestConfig = goPcmBookGetBatchSubscribeGrade2RequestConfig;
/**
 * 接口 [unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/2309/interface/api/176381) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-12-03 16:35:41`
 */ const goPcmBookUnlockBatchChapters2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/unlockBatchChapters",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookUnlockBatchChapters2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [unlockBatchChapters 批量解锁↗](https://yapi.yuewen.com/project/2309/interface/api/176381) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockBatchChapters`
 * @更新时间 `2020-12-03 16:35:41`
 */ const goPcmBookUnlockBatchChapters2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookUnlockBatchChapters2RequestConfig, requestData), ...args);
};
goPcmBookUnlockBatchChapters2.requestConfig = goPcmBookUnlockBatchChapters2RequestConfig;
/**
 * 接口 [unlockChpater-解锁章节 ↗](https://yapi.yuewen.com/project/2309/interface/api/177828) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockChapter`
 * @更新时间 `2022-03-31 21:22:55`
 */ const goPcmBookUnlockChapterRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/unlockChapter",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookUnlockChapter",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [unlockChpater-解锁章节 ↗](https://yapi.yuewen.com/project/2309/interface/api/177828) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/unlockChapter`
 * @更新时间 `2022-03-31 21:22:55`
 */ const goPcmBookUnlockChapter = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookUnlockChapterRequestConfig, requestData), ...args);
};
goPcmBookUnlockChapter.requestConfig = goPcmBookUnlockChapterRequestConfig;
/**
 * 接口 [setReadingSettings 设置字体颜色等↗](https://yapi.yuewen.com/project/2309/interface/api/191358) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/setReadingSettings`
 * @更新时间 `2021-02-25 14:46:32`
 */ const goPcmBookSetReadingSettingsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/setReadingSettings",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookSetReadingSettings",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [setReadingSettings 设置字体颜色等↗](https://yapi.yuewen.com/project/2309/interface/api/191358) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/setReadingSettings`
 * @更新时间 `2021-02-25 14:46:32`
 */ const goPcmBookSetReadingSettings = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookSetReadingSettingsRequestConfig, requestData), ...args);
};
goPcmBookSetReadingSettings.requestConfig = goPcmBookSetReadingSettingsRequestConfig;
/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/191677) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookDetailPage`
 * @更新时间 `2024-10-21 14:50:43`
 */ const goPcmBookGetBookDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookDetailPage",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/191677) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookDetailPage`
 * @更新时间 `2024-10-21 14:50:43`
 */ const goPcmBookGetBookDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBookDetailPageRequestConfig, requestData), ...args);
};
goPcmBookGetBookDetailPage.requestConfig = goPcmBookGetBookDetailPageRequestConfig;
/**
 * 接口 [getBookLandingPage 小说落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191811) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookLandingPage`
 * @更新时间 `2024-08-22 19:05:56`
 */ const goPcmBookGetBookLandingPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookLandingPage",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapters",
        "from"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookLandingPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getBookLandingPage 小说落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191811) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookLandingPage`
 * @更新时间 `2024-08-22 19:05:56`
 */ const goPcmBookGetBookLandingPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBookLandingPageRequestConfig, requestData), ...args);
};
goPcmBookGetBookLandingPage.requestConfig = goPcmBookGetBookLandingPageRequestConfig;
/**
 * 接口 [getComicLandingPage 漫画落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191925) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getComicLandingPage`
 * @更新时间 `2023-01-12 18:52:10`
 */ const goPcmBookGetComicLandingPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getComicLandingPage",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapters",
        "from"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetComicLandingPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getComicLandingPage 漫画落地页↗](https://yapi.yuewen.com/project/2309/interface/api/191925) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getComicLandingPage`
 * @更新时间 `2023-01-12 18:52:10`
 */ const goPcmBookGetComicLandingPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetComicLandingPageRequestConfig, requestData), ...args);
};
goPcmBookGetComicLandingPage.requestConfig = goPcmBookGetComicLandingPageRequestConfig;
/**
 * 接口 [getBookRssPage rss页面直出↗](https://yapi.yuewen.com/project/2309/interface/api/192858) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookRssPage`
 * @更新时间 `2021-02-25 16:41:57`
 */ const goPcmBookGetBookRssPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookRssPage",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookRssPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getBookRssPage rss页面直出↗](https://yapi.yuewen.com/project/2309/interface/api/192858) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `POST /go/pcm/book/getBookRssPage`
 * @更新时间 `2021-02-25 16:41:57`
 */ const goPcmBookGetBookRssPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBookRssPageRequestConfig, requestData), ...args);
};
goPcmBookGetBookRssPage.requestConfig = goPcmBookGetBookRssPageRequestConfig;
/**
 * 接口 [get-book-detail↗](https://yapi.yuewen.com/project/2309/interface/api/199996) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-04-28 19:56:57`
 */ const goPcmBookGetBookDetail2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/get-book-detail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetail2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-book-detail↗](https://yapi.yuewen.com/project/2309/interface/api/199996) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/get-book-detail`
 * @更新时间 `2024-04-28 19:56:57`
 */ const goPcmBookGetBookDetail2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBookDetail2RequestConfig, requestData), ...args);
};
goPcmBookGetBookDetail2.requestConfig = goPcmBookGetBookDetail2RequestConfig;
/**
 * 接口 [GetRelatedBooksAjax 拉取相关作品推荐↗](https://yapi.yuewen.com/project/2309/interface/api/207345) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getRelatedBooksAjax`
 * @更新时间 `2021-05-10 14:01:34`
 */ const goPcmBookGetRelatedBooksAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getRelatedBooksAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetRelatedBooksAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [GetRelatedBooksAjax 拉取相关作品推荐↗](https://yapi.yuewen.com/project/2309/interface/api/207345) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getRelatedBooksAjax`
 * @更新时间 `2021-05-10 14:01:34`
 */ const goPcmBookGetRelatedBooksAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetRelatedBooksAjaxRequestConfig, requestData), ...args);
};
goPcmBookGetRelatedBooksAjax.requestConfig = goPcmBookGetRelatedBooksAjaxRequestConfig;
/**
 * 接口 [【del】getOffLineBook 获取下线书信息↗](https://yapi.yuewen.com/project/2309/interface/api/257131) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getOffLineBook`
 * @更新时间 `2023-03-16 15:29:17`
 */ const goPcmBookGetOffLineBookRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getOffLineBook",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetOffLineBook",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【del】getOffLineBook 获取下线书信息↗](https://yapi.yuewen.com/project/2309/interface/api/257131) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getOffLineBook`
 * @更新时间 `2023-03-16 15:29:17`
 */ const goPcmBookGetOffLineBook = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetOffLineBookRequestConfig, requestData), ...args);
};
goPcmBookGetOffLineBook.requestConfig = goPcmBookGetOffLineBookRequestConfig;
/**
 * 接口 [getShortplayLandingPage 短剧落地页↗](https://yapi.yuewen.com/project/2309/interface/api/279415) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getShortplayLandingPage`
 * @更新时间 `2024-07-15 18:01:51`
 */ const goPcmBookGetShortplayLandingPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getShortplayLandingPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "playId",
        "from",
        "chapters"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetShortplayLandingPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getShortplayLandingPage 短剧落地页↗](https://yapi.yuewen.com/project/2309/interface/api/279415) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getShortplayLandingPage`
 * @更新时间 `2024-07-15 18:01:51`
 */ const goPcmBookGetShortplayLandingPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetShortplayLandingPageRequestConfig, requestData), ...args);
};
goPcmBookGetShortplayLandingPage.requestConfig = goPcmBookGetShortplayLandingPageRequestConfig;
/**
 * 接口 [getAudioBookLandingPage 有声书落地页↗](https://yapi.yuewen.com/project/2309/interface/api/289341) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getAudioBookLandingPage`
 * @更新时间 `2024-10-10 16:02:46`
 */ const goPcmBookGetAudioBookLandingPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getAudioBookLandingPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "audioBookId",
        "chapters",
        "from"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetAudioBookLandingPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getAudioBookLandingPage 有声书落地页↗](https://yapi.yuewen.com/project/2309/interface/api/289341) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getAudioBookLandingPage`
 * @更新时间 `2024-10-10 16:02:46`
 */ const goPcmBookGetAudioBookLandingPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetAudioBookLandingPageRequestConfig, requestData), ...args);
};
goPcmBookGetAudioBookLandingPage.requestConfig = goPcmBookGetAudioBookLandingPageRequestConfig;
/**
 * 接口 [get-book-detail_copy↗](https://yapi.yuewen.com/project/2309/interface/api/292304) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBookDetailPagePc`
 * @更新时间 `2024-09-09 20:10:57`
 */ const goPcmBookGetBookDetailPagePcRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getBookDetailPagePc",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetBookDetailPagePc",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-book-detail_copy↗](https://yapi.yuewen.com/project/2309/interface/api/292304) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getBookDetailPagePc`
 * @更新时间 `2024-09-09 20:10:57`
 */ const goPcmBookGetBookDetailPagePc = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetBookDetailPagePcRequestConfig, requestData), ...args);
};
goPcmBookGetBookDetailPagePc.requestConfig = goPcmBookGetBookDetailPagePcRequestConfig;
/**
 * 接口 [getSearchLandingPage 搜索通用落地页↗](https://yapi.yuewen.com/project/2309/interface/api/295734) 的 **请求配置**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getSearchLandingPage`
 * @更新时间 `2024-11-08 14:25:27`
 */ const goPcmBookGetSearchLandingPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_13,
    devUrl: devUrl_0_0_0_13,
    prodUrl: prodUrl_0_0_0_13,
    path: "/go/pcm/book/getSearchLandingPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_13,
    paramNames: [],
    queryNames: [
        "bookType",
        "\bkeyword"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookGetSearchLandingPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getSearchLandingPage 搜索通用落地页↗](https://yapi.yuewen.com/project/2309/interface/api/295734) 的 **请求函数**
 *
 * @分类 [Book↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23011)
 * @请求头 `GET /go/pcm/book/getSearchLandingPage`
 * @更新时间 `2024-11-08 14:25:27`
 */ const goPcmBookGetSearchLandingPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookGetSearchLandingPageRequestConfig, requestData), ...args);
};
goPcmBookGetSearchLandingPage.requestConfig = goPcmBookGetSearchLandingPageRequestConfig;
const mockUrl_0_0_0_14 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_14 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_14 = "https://www.webnovel.com";
const dataKey_0_0_0_14 = "data";
/**
 * 接口 [给作品打赏礼物↗](https://yapi.yuewen.com/project/2309/interface/api/176398) 的 **请求配置**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `POST /go/pcm/gift/donateGift`
 * @更新时间 `2021-01-20 15:16:38`
 */ const goPcmGiftDonateGiftRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_14,
    devUrl: devUrl_0_0_0_14,
    prodUrl: prodUrl_0_0_0_14,
    path: "/go/pcm/gift/donateGift",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_14,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftDonateGift",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [给作品打赏礼物↗](https://yapi.yuewen.com/project/2309/interface/api/176398) 的 **请求函数**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `POST /go/pcm/gift/donateGift`
 * @更新时间 `2021-01-20 15:16:38`
 */ const goPcmGiftDonateGift = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGiftDonateGiftRequestConfig, requestData), ...args);
};
goPcmGiftDonateGift.requestConfig = goPcmGiftDonateGiftRequestConfig;
/**
 * 接口 [获取作品礼物列表↗](https://yapi.yuewen.com/project/2309/interface/api/176406) 的 **请求配置**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/getBookGiftList`
 * @更新时间 `2021-01-20 15:14:33`
 */ const goPcmGiftGetBookGiftListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_14,
    devUrl: devUrl_0_0_0_14,
    prodUrl: prodUrl_0_0_0_14,
    path: "/go/pcm/gift/getBookGiftList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_14,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftGetBookGiftList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取作品礼物列表↗](https://yapi.yuewen.com/project/2309/interface/api/176406) 的 **请求函数**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/getBookGiftList`
 * @更新时间 `2021-01-20 15:14:33`
 */ const goPcmGiftGetBookGiftList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGiftGetBookGiftListRequestConfig, requestData), ...args);
};
goPcmGiftGetBookGiftList.requestConfig = goPcmGiftGetBookGiftListRequestConfig;
/**
 * 接口 [获取作品礼物打赏信息↗](https://yapi.yuewen.com/project/2309/interface/api/176411) 的 **请求配置**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2022-09-06 17:27:58`
 */ const goPcmGiftGetGiftInfo2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_14,
    devUrl: devUrl_0_0_0_14,
    prodUrl: prodUrl_0_0_0_14,
    path: "/go/pcm/gift/get-gift-info",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_14,
    paramNames: [],
    queryNames: [
        "bookId",
        "_csrfToken",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGiftGetGiftInfo2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取作品礼物打赏信息↗](https://yapi.yuewen.com/project/2309/interface/api/176411) 的 **请求函数**
 *
 * @分类 [Gift↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23015)
 * @请求头 `GET /go/pcm/gift/get-gift-info`
 * @更新时间 `2022-09-06 17:27:58`
 */ const goPcmGiftGetGiftInfo2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGiftGetGiftInfo2RequestConfig, requestData), ...args);
};
goPcmGiftGetGiftInfo2.requestConfig = goPcmGiftGetGiftInfo2RequestConfig;
const mockUrl_0_0_0_15 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_15 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_15 = "https://www.webnovel.com";
const dataKey_0_0_0_15 = "data";
/**
 * 接口 [解锁章节↗](https://yapi.yuewen.com/project/2309/interface/api/176451) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/unlockChapter`
 * @更新时间 `2021-05-06 16:33:16`
 */ const goPcmComicUnlockChapterRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/unlockChapter",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "width",
        "unlockType",
        "price"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicUnlockChapter",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [解锁章节↗](https://yapi.yuewen.com/project/2309/interface/api/176451) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/unlockChapter`
 * @更新时间 `2021-05-06 16:33:16`
 */ const goPcmComicUnlockChapter = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicUnlockChapterRequestConfig, requestData), ...args);
};
goPcmComicUnlockChapter.requestConfig = goPcmComicUnlockChapterRequestConfig;
/**
 * 接口 [阅读页(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176458) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2022-12-20 13:51:54`
 */ const goPcmComicGetContent2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getContent",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "width"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetContent2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [阅读页(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176458) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContent`
 * @更新时间 `2022-12-20 13:51:54`
 */ const goPcmComicGetContent2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetContent2RequestConfig, requestData), ...args);
};
goPcmComicGetContent2.requestConfig = goPcmComicGetContent2RequestConfig;
/**
 * 接口 [阅读页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176466) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContentPage`
 * @更新时间 `2022-08-18 14:58:38`
 */ const goPcmComicGetContentPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getContentPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "width"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetContentPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [阅读页直出(go)↗](https://yapi.yuewen.com/project/2309/interface/api/176466) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getContentPage`
 * @更新时间 `2022-08-18 14:58:38`
 */ const goPcmComicGetContentPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetContentPageRequestConfig, requestData), ...args);
};
goPcmComicGetContentPage.requestConfig = goPcmComicGetContentPageRequestConfig;
/**
 * 接口 [addBullet - 添加弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195816) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `POST /go/pcm/comic/addBullet`
 * @更新时间 `2021-01-28 13:53:19`
 */ const goPcmComicAddBulletRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/addBullet",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicAddBullet",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [addBullet - 添加弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195816) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `POST /go/pcm/comic/addBullet`
 * @更新时间 `2021-01-28 13:53:19`
 */ const goPcmComicAddBullet = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicAddBulletRequestConfig, requestData), ...args);
};
goPcmComicAddBullet.requestConfig = goPcmComicAddBulletRequestConfig;
/**
 * 接口 [getBullet - 获取弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195821) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getBullet`
 * @更新时间 `2021-01-28 13:59:48`
 */ const goPcmComicGetBulletRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getBullet",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "comicId",
        "chapterId",
        "pageId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetBullet",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getBullet - 获取弹幕↗](https://yapi.yuewen.com/project/2309/interface/api/195821) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getBullet`
 * @更新时间 `2021-01-28 13:59:48`
 */ const goPcmComicGetBullet = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetBulletRequestConfig, requestData), ...args);
};
goPcmComicGetBullet.requestConfig = goPcmComicGetBulletRequestConfig;
/**
 * 接口 [getLatestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195830) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getLatestUpdates`
 * @更新时间 `2021-01-28 14:03:26`
 */ const goPcmComicGetLatestUpdatesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getLatestUpdates",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetLatestUpdates",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getLatestUpdates - 获取最近更新列表↗](https://yapi.yuewen.com/project/2309/interface/api/195830) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getLatestUpdates`
 * @更新时间 `2021-01-28 14:03:26`
 */ const goPcmComicGetLatestUpdates = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetLatestUpdatesRequestConfig, requestData), ...args);
};
goPcmComicGetLatestUpdates.requestConfig = goPcmComicGetLatestUpdatesRequestConfig;
/**
 * 接口 [getComicDetailPage - 获取详情页 ↗](https://yapi.yuewen.com/project/2309/interface/api/195847) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPage`
 * @更新时间 `2021-10-19 19:30:07`
 */ const goPcmComicGetComicDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getComicDetailPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "comicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetComicDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getComicDetailPage - 获取详情页 ↗](https://yapi.yuewen.com/project/2309/interface/api/195847) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPage`
 * @更新时间 `2021-10-19 19:30:07`
 */ const goPcmComicGetComicDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetComicDetailPageRequestConfig, requestData), ...args);
};
goPcmComicGetComicDetailPage.requestConfig = goPcmComicGetComicDetailPageRequestConfig;
/**
 * 接口 [getList - 获取漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195855) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getList`
 * @更新时间 `2021-01-28 14:47:08`
 */ const goPcmComicGetListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "pageSize",
        "orderBy"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getList - 获取漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195855) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getList`
 * @更新时间 `2021-01-28 14:47:08`
 */ const goPcmComicGetList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetListRequestConfig, requestData), ...args);
};
goPcmComicGetList.requestConfig = goPcmComicGetListRequestConfig;
/**
 * 接口 [getListPage - 获取漫画列表(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195858) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getListPage`
 * @更新时间 `2021-01-28 14:47:19`
 */ const goPcmComicGetListPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getListPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "pageSize",
        "orderBy"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetListPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getListPage - 获取漫画列表(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195858) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getListPage`
 * @更新时间 `2021-01-28 14:47:19`
 */ const goPcmComicGetListPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetListPageRequestConfig, requestData), ...args);
};
goPcmComicGetListPage.requestConfig = goPcmComicGetListPageRequestConfig;
/**
 * 接口 [getChapterList - 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195876) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getChapterList`
 * @更新时间 `2022-12-05 14:46:18`
 */ const goPcmComicGetChapterListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getChapterList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "comicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetChapterList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getChapterList - 获取章节列表↗](https://yapi.yuewen.com/project/2309/interface/api/195876) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getChapterList`
 * @更新时间 `2022-12-05 14:46:18`
 */ const goPcmComicGetChapterList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetChapterListRequestConfig, requestData), ...args);
};
goPcmComicGetChapterList.requestConfig = goPcmComicGetChapterListRequestConfig;
/**
 * 接口 [getUpdateList - 每日漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195882) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getUpdateList`
 * @更新时间 `2021-01-28 15:04:18`
 */ const goPcmComicGetUpdateListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getUpdateList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "logTime"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetUpdateList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getUpdateList - 每日漫画列表↗](https://yapi.yuewen.com/project/2309/interface/api/195882) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getUpdateList`
 * @更新时间 `2021-01-28 15:04:18`
 */ const goPcmComicGetUpdateList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetUpdateListRequestConfig, requestData), ...args);
};
goPcmComicGetUpdateList.requestConfig = goPcmComicGetUpdateListRequestConfig;
/**
 * 接口 [getComicDetailPc - 获取详情页PC直出↗](https://yapi.yuewen.com/project/2309/interface/api/292307) 的 **请求配置**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPc`
 * @更新时间 `2024-09-09 20:38:31`
 */ const goPcmComicGetComicDetailPcRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_15,
    devUrl: devUrl_0_0_0_15,
    prodUrl: prodUrl_0_0_0_15,
    path: "/go/pcm/comic/getComicDetailPc",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_15,
    paramNames: [],
    queryNames: [
        "comicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetComicDetailPc",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getComicDetailPc - 获取详情页PC直出↗](https://yapi.yuewen.com/project/2309/interface/api/292307) 的 **请求函数**
 *
 * @分类 [Comic↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23028)
 * @请求头 `GET /go/pcm/comic/getComicDetailPc`
 * @更新时间 `2024-09-09 20:38:31`
 */ const goPcmComicGetComicDetailPc = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetComicDetailPcRequestConfig, requestData), ...args);
};
goPcmComicGetComicDetailPc.requestConfig = goPcmComicGetComicDetailPcRequestConfig;
const mockUrl_0_0_0_16 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_16 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_16 = "https://www.webnovel.com";
const dataKey_0_0_0_16 = "data";
/**
 * 接口 [智能推荐二级页（go直出页）↗](https://yapi.yuewen.com/project/2309/interface/api/176525) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendListPage`
 * @更新时间 `2020-12-02 19:36:45`
 */ const goPcmRecommendGetRecommendListPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/getRecommendListPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: [
        "type",
        "bookId",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendGetRecommendListPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [智能推荐二级页（go直出页）↗](https://yapi.yuewen.com/project/2309/interface/api/176525) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendListPage`
 * @更新时间 `2020-12-02 19:36:45`
 */ const goPcmRecommendGetRecommendListPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRecommendGetRecommendListPageRequestConfig, requestData), ...args);
};
goPcmRecommendGetRecommendListPage.requestConfig = goPcmRecommendGetRecommendListPageRequestConfig;
/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/2309/interface/api/176533) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2022-05-30 17:04:37`
 */ const goPcmRecommendGetRecommendList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/getRecommendList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: [
        "type",
        "bookId",
        "pageIndex",
        "withOrigin"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendGetRecommendList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [智能推荐二级页（go）↗](https://yapi.yuewen.com/project/2309/interface/api/176533) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/getRecommendList`
 * @更新时间 `2022-05-30 17:04:37`
 */ const goPcmRecommendGetRecommendList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRecommendGetRecommendList2RequestConfig, requestData), ...args);
};
goPcmRecommendGetRecommendList2.requestConfig = goPcmRecommendGetRecommendList2RequestConfig;
/**
 * 接口 [list - 获取推荐书籍列表↗](https://yapi.yuewen.com/project/2309/interface/api/198691) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/list`
 * @更新时间 `2021-03-15 19:41:11`
 */ const goPcmRecommendListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: [
        "recommendType",
        "bookId",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [list - 获取推荐书籍列表↗](https://yapi.yuewen.com/project/2309/interface/api/198691) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/list`
 * @更新时间 `2021-03-15 19:41:11`
 */ const goPcmRecommendList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRecommendListRequestConfig, requestData), ...args);
};
goPcmRecommendList.requestConfig = goPcmRecommendListRequestConfig;
/**
 * 接口 [recommendItems you may also like逻辑↗](https://yapi.yuewen.com/project/2309/interface/api/287842) 的 **请求配置**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/youMayAlsoLike`
 * @更新时间 `2024-06-12 14:17:51`
 */ const goPcmRecommendYouMayAlsoLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_16,
    devUrl: devUrl_0_0_0_16,
    prodUrl: prodUrl_0_0_0_16,
    path: "/go/pcm/recommend/youMayAlsoLike",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_16,
    paramNames: [],
    queryNames: [
        "itemId",
        "bookType",
        "pageIndex",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRecommendYouMayAlsoLike",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [recommendItems you may also like逻辑↗](https://yapi.yuewen.com/project/2309/interface/api/287842) 的 **请求函数**
 *
 * @分类 [Recommend - 智能推荐↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23058)
 * @请求头 `GET /go/pcm/recommend/youMayAlsoLike`
 * @更新时间 `2024-06-12 14:17:51`
 */ const goPcmRecommendYouMayAlsoLike = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRecommendYouMayAlsoLikeRequestConfig, requestData), ...args);
};
goPcmRecommendYouMayAlsoLike.requestConfig = goPcmRecommendYouMayAlsoLikeRequestConfig;
const mockUrl_0_0_0_17 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_17 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_17 = "https://www.webnovel.com";
const dataKey_0_0_0_17 = "data";
/**
 * 接口 [期待票直出新↗](https://yapi.yuewen.com/project/2309/interface/api/176353) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2021-04-08 19:52:43`
 */ const goPcmExpectEsList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_17,
    devUrl: devUrl_0_0_0_17,
    prodUrl: prodUrl_0_0_0_17,
    path: "/go/pcm/expect/esList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectEsList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [期待票直出新↗](https://yapi.yuewen.com/project/2309/interface/api/176353) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/esList`
 * @更新时间 `2021-04-08 19:52:43`
 */ const goPcmExpectEsList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmExpectEsList2RequestConfig, requestData), ...args);
};
goPcmExpectEsList2.requestConfig = goPcmExpectEsList2RequestConfig;
/**
 * 接口 [试读书列表↗](https://yapi.yuewen.com/project/2309/interface/api/176578) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2021-04-09 20:04:32`
 */ const goPcmExpectTrailerList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_17,
    devUrl: devUrl_0_0_0_17,
    prodUrl: prodUrl_0_0_0_17,
    path: "/go/pcm/expect/trailerList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_17,
    paramNames: [],
    queryNames: [
        "status",
        "pageId",
        "pageSize"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectTrailerList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [试读书列表↗](https://yapi.yuewen.com/project/2309/interface/api/176578) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/trailerList`
 * @更新时间 `2021-04-09 20:04:32`
 */ const goPcmExpectTrailerList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmExpectTrailerList2RequestConfig, requestData), ...args);
};
goPcmExpectTrailerList2.requestConfig = goPcmExpectTrailerList2RequestConfig;
/**
 * 接口 [已读书列表【废弃】↗](https://yapi.yuewen.com/project/2309/interface/api/200003) 的 **请求配置**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/tryReadBookList`
 * @更新时间 `2021-03-30 17:08:50`
 */ const goPcmExpectTryReadBookListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_17,
    devUrl: devUrl_0_0_0_17,
    prodUrl: prodUrl_0_0_0_17,
    path: "/go/pcm/expect/tryReadBookList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_17,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmExpectTryReadBookList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [已读书列表【废弃】↗](https://yapi.yuewen.com/project/2309/interface/api/200003) 的 **请求函数**
 *
 * @分类 [expect-what's next↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23075)
 * @请求头 `GET /go/pcm/expect/tryReadBookList`
 * @更新时间 `2021-03-30 17:08:50`
 */ const goPcmExpectTryReadBookList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmExpectTryReadBookListRequestConfig, requestData), ...args);
};
goPcmExpectTryReadBookList.requestConfig = goPcmExpectTryReadBookListRequestConfig;
const mockUrl_0_0_0_18 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_18 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_18 = "https://www.webnovel.com";
const dataKey_0_0_0_18 = "data";
/**
 * 接口 [领取奖励接口↗](https://yapi.yuewen.com/project/2309/interface/api/176585) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getBonus`
 * @更新时间 `2020-12-02 19:45:40`
 */ const goPcmMembershipGetBonusRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getBonus",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetBonus",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [领取奖励接口↗](https://yapi.yuewen.com/project/2309/interface/api/176585) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getBonus`
 * @更新时间 `2020-12-02 19:45:40`
 */ const goPcmMembershipGetBonus = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMembershipGetBonusRequestConfig, requestData), ...args);
};
goPcmMembershipGetBonus.requestConfig = goPcmMembershipGetBonusRequestConfig;
/**
 * 接口 [获取会员信息_PC↗](https://yapi.yuewen.com/project/2309/interface/api/177876) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getInfoAjax`
 * @更新时间 `2021-03-02 13:49:03`
 */ const goPcmMembershipGetInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取会员信息_PC↗](https://yapi.yuewen.com/project/2309/interface/api/177876) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getInfoAjax`
 * @更新时间 `2021-03-02 13:49:03`
 */ const goPcmMembershipGetInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMembershipGetInfoAjaxRequestConfig, requestData), ...args);
};
goPcmMembershipGetInfoAjax.requestConfig = goPcmMembershipGetInfoAjaxRequestConfig;
/**
 * 接口 [获取会员信息_M站↗](https://yapi.yuewen.com/project/2309/interface/api/195503) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShip`
 * @更新时间 `2021-04-02 15:29:31`
 */ const goPcmMembershipGetMemberShipRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getMemberShip",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetMemberShip",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取会员信息_M站↗](https://yapi.yuewen.com/project/2309/interface/api/195503) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShip`
 * @更新时间 `2021-04-02 15:29:31`
 */ const goPcmMembershipGetMemberShip = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMembershipGetMemberShipRequestConfig, requestData), ...args);
};
goPcmMembershipGetMemberShip.requestConfig = goPcmMembershipGetMemberShipRequestConfig;
/**
 * 接口 [会员卡管理-M站↗](https://yapi.yuewen.com/project/2309/interface/api/195558) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShipManager`
 * @更新时间 `2021-04-07 10:09:50`
 */ const goPcmMembershipGetMemberShipManagerRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/getMemberShipManager",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipGetMemberShipManager",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [会员卡管理-M站↗](https://yapi.yuewen.com/project/2309/interface/api/195558) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/getMemberShipManager`
 * @更新时间 `2021-04-07 10:09:50`
 */ const goPcmMembershipGetMemberShipManager = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMembershipGetMemberShipManagerRequestConfig, requestData), ...args);
};
goPcmMembershipGetMemberShipManager.requestConfig = goPcmMembershipGetMemberShipManagerRequestConfig;
/**
 * 接口 [退订stripe会员卡↗](https://yapi.yuewen.com/project/2309/interface/api/197937) 的 **请求配置**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/cancel`
 * @更新时间 `2021-05-31 19:17:18`
 */ const goPcmMembershipCancelRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_18,
    devUrl: devUrl_0_0_0_18,
    prodUrl: prodUrl_0_0_0_18,
    path: "/go/pcm/membership/cancel",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_18,
    paramNames: [],
    queryNames: [
        "itemId",
        "channelCode"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMembershipCancel",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [退订stripe会员卡↗](https://yapi.yuewen.com/project/2309/interface/api/197937) 的 **请求函数**
 *
 * @分类 [Membership↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23079)
 * @请求头 `GET /go/pcm/membership/cancel`
 * @更新时间 `2021-05-31 19:17:18`
 */ const goPcmMembershipCancel = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMembershipCancelRequestConfig, requestData), ...args);
};
goPcmMembershipCancel.requestConfig = goPcmMembershipCancelRequestConfig;
const mockUrl_0_0_0_19 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_19 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_19 = "https://www.webnovel.com";
const dataKey_0_0_0_19 = "data";
/**
 * 接口 [get-more-list 获取more模块配置的内容↗](https://yapi.yuewen.com/project/2309/interface/api/178037) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-more-list`
 * @更新时间 `2020-12-17 11:49:19`
 */ const goPcmBookcityGetMoreListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-more-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "contentId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetMoreList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-more-list 获取more模块配置的内容↗](https://yapi.yuewen.com/project/2309/interface/api/178037) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-more-list`
 * @更新时间 `2020-12-17 11:49:19`
 */ const goPcmBookcityGetMoreList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetMoreListRequestConfig, requestData), ...args);
};
goPcmBookcityGetMoreList.requestConfig = goPcmBookcityGetMoreListRequestConfig;
/**
 * 接口 [语言选择列表↗](https://yapi.yuewen.com/project/2309/interface/api/178039) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/country-language`
 * @更新时间 `2020-12-15 16:28:42`
 */ const goPcmBookcityCountryLanguageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/country-language",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityCountryLanguage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [语言选择列表↗](https://yapi.yuewen.com/project/2309/interface/api/178039) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/country-language`
 * @更新时间 `2020-12-15 16:28:42`
 */ const goPcmBookcityCountryLanguage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityCountryLanguageRequestConfig, requestData), ...args);
};
goPcmBookcityCountryLanguage.requestConfig = goPcmBookcityCountryLanguageRequestConfig;
/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178047) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-feed-list`
 * @更新时间 `2020-12-17 16:44:49`
 */ const goPcmBookcityGetFeedListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-feed-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetFeedList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178047) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-feed-list`
 * @更新时间 `2020-12-17 16:44:49`
 */ const goPcmBookcityGetFeedList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetFeedListRequestConfig, requestData), ...args);
};
goPcmBookcityGetFeedList.requestConfig = goPcmBookcityGetFeedListRequestConfig;
/**
 * 接口 [get-comic-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178052) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-comic-feed-list`
 * @更新时间 `2020-12-14 14:52:58`
 */ const goPcmBookcityGetComicFeedListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-comic-feed-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetComicFeedList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-comic-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/178052) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-comic-feed-list`
 * @更新时间 `2020-12-14 14:52:58`
 */ const goPcmBookcityGetComicFeedList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetComicFeedListRequestConfig, requestData), ...args);
};
goPcmBookcityGetComicFeedList.requestConfig = goPcmBookcityGetComicFeedListRequestConfig;
/**
 * 接口 [新书城获取pageList接口↗](https://yapi.yuewen.com/project/2309/interface/api/178054) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page-list`
 * @更新时间 `2020-12-21 14:45:59`
 */ const goPcmBookcityPageListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/page-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "country",
        "sex",
        "language",
        "bookCityType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityPageList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [新书城获取pageList接口↗](https://yapi.yuewen.com/project/2309/interface/api/178054) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page-list`
 * @更新时间 `2020-12-21 14:45:59`
 */ const goPcmBookcityPageList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityPageListRequestConfig, requestData), ...args);
};
goPcmBookcityPageList.requestConfig = goPcmBookcityPageListRequestConfig;
/**
 * 接口 [新书城获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178062) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page`
 * @更新时间 `2023-05-23 15:48:35`
 */ const goPcmBookcityPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "pageId",
        "bookCityType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [新书城获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178062) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/page`
 * @更新时间 `2023-05-23 15:48:35`
 */ const goPcmBookcityPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityPageRequestConfig, requestData), ...args);
};
goPcmBookcityPage.requestConfig = goPcmBookcityPageRequestConfig;
/**
 * 接口 [get-qd-list 获取起点中文榜单↗](https://yapi.yuewen.com/project/2309/interface/api/178067) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-qd-list`
 * @更新时间 `2020-12-15 20:16:19`
 */ const goPcmBookcityGetQdListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-qd-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "type",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetQdList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-qd-list 获取起点中文榜单↗](https://yapi.yuewen.com/project/2309/interface/api/178067) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-qd-list`
 * @更新时间 `2020-12-15 20:16:19`
 */ const goPcmBookcityGetQdList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetQdListRequestConfig, requestData), ...args);
};
goPcmBookcityGetQdList.requestConfig = goPcmBookcityGetQdListRequestConfig;
/**
 * 接口 [get-relation-page 通过偏好id获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178069) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-relation-page`
 * @更新时间 `2021-01-04 11:05:59`
 */ const goPcmBookcityGetRelationPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-relation-page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "index",
        "sex",
        "bookCityType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetRelationPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-relation-page 通过偏好id获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/178069) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-relation-page`
 * @更新时间 `2021-01-04 11:05:59`
 */ const goPcmBookcityGetRelationPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetRelationPageRequestConfig, requestData), ...args);
};
goPcmBookcityGetRelationPage.requestConfig = goPcmBookcityGetRelationPageRequestConfig;
/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/178077) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-change`
 * @更新时间 `2020-12-17 16:54:12`
 */ const goPcmBookcityGetChangeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-change",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "blockId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetChange",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/178077) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-change`
 * @更新时间 `2020-12-17 16:54:12`
 */ const goPcmBookcityGetChange = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetChangeRequestConfig, requestData), ...args);
};
goPcmBookcityGetChange.requestConfig = goPcmBookcityGetChangeRequestConfig;
/**
 * 接口 [get-history-list 获取block往期列表↗](https://yapi.yuewen.com/project/2309/interface/api/178082) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history-list`
 * @更新时间 `2020-12-17 10:08:19`
 */ const goPcmBookcityGetHistoryListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-history-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "blockId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetHistoryList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-history-list 获取block往期列表↗](https://yapi.yuewen.com/project/2309/interface/api/178082) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history-list`
 * @更新时间 `2020-12-17 10:08:19`
 */ const goPcmBookcityGetHistoryList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetHistoryListRequestConfig, requestData), ...args);
};
goPcmBookcityGetHistoryList.requestConfig = goPcmBookcityGetHistoryListRequestConfig;
/**
 * 接口 [get-history 获取block某期配置内容↗](https://yapi.yuewen.com/project/2309/interface/api/178084) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history`
 * @更新时间 `2020-12-17 10:34:21`
 */ const goPcmBookcityGetHistoryRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/bookcity/get-history",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "contentId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookcityGetHistory",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-history 获取block某期配置内容↗](https://yapi.yuewen.com/project/2309/interface/api/178084) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/bookcity/get-history`
 * @更新时间 `2020-12-17 10:34:21`
 */ const goPcmBookcityGetHistory = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookcityGetHistoryRequestConfig, requestData), ...args);
};
goPcmBookcityGetHistory.requestConfig = goPcmBookcityGetHistoryRequestConfig;
/**
 * 接口 [get-calendar漫画日历↗](https://yapi.yuewen.com/project/2309/interface/api/179033) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-calendar`
 * @更新时间 `2020-12-17 17:22:07`
 */ const goPcmComicGetCalendarRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/comic/get-calendar",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "date",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetCalendar",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-calendar漫画日历↗](https://yapi.yuewen.com/project/2309/interface/api/179033) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-calendar`
 * @更新时间 `2020-12-17 17:22:07`
 */ const goPcmComicGetCalendar = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetCalendarRequestConfig, requestData), ...args);
};
goPcmComicGetCalendar.requestConfig = goPcmComicGetCalendarRequestConfig;
/**
 * 接口 [get-date-comic漫画日历全部↗](https://yapi.yuewen.com/project/2309/interface/api/179825) 的 **请求配置**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-date-comic`
 * @更新时间 `2020-12-17 19:43:50`
 */ const goPcmComicGetDateComicRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_19,
    devUrl: devUrl_0_0_0_19,
    prodUrl: prodUrl_0_0_0_19,
    path: "/go/pcm/comic/get-date-comic",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_19,
    paramNames: [],
    queryNames: [
        "dateList"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmComicGetDateComic",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-date-comic漫画日历全部↗](https://yapi.yuewen.com/project/2309/interface/api/179825) 的 **请求函数**
 *
 * @分类 [m站 bookcity 书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_23414)
 * @请求头 `GET /go/pcm/comic/get-date-comic`
 * @更新时间 `2020-12-17 19:43:50`
 */ const goPcmComicGetDateComic = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmComicGetDateComicRequestConfig, requestData), ...args);
};
goPcmComicGetDateComic.requestConfig = goPcmComicGetDateComicRequestConfig;
const mockUrl_0_0_0_20 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_20 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_20 = "https://www.webnovel.com";
const dataKey_0_0_0_20 = "data";
/**
 * 接口 [获取用户信息接口PC↗](https://yapi.yuewen.com/project/2309/interface/api/177874) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getUserInfo`
 * @更新时间 `2021-04-02 15:47:24`
 */ const goPcmLoginGetUserInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/getUserInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginGetUserInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户信息接口PC↗](https://yapi.yuewen.com/project/2309/interface/api/177874) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getUserInfo`
 * @更新时间 `2021-04-02 15:47:24`
 */ const goPcmLoginGetUserInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLoginGetUserInfoRequestConfig, requestData), ...args);
};
goPcmLoginGetUserInfo.requestConfig = goPcmLoginGetUserInfoRequestConfig;
/**
 * 接口 [登录接口↗](https://yapi.yuewen.com/project/2309/interface/api/181723) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/login`
 * @更新时间 `2020-12-23 19:50:33`
 */ const goPcmLoginLoginRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/login",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginLogin",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [登录接口↗](https://yapi.yuewen.com/project/2309/interface/api/181723) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/login`
 * @更新时间 `2020-12-23 19:50:33`
 */ const goPcmLoginLogin = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLoginLoginRequestConfig, requestData), ...args);
};
goPcmLoginLogin.requestConfig = goPcmLoginLoginRequestConfig;
/**
 * 接口 [获取第三方信息↗](https://yapi.yuewen.com/project/2309/interface/api/181728) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getThirdPartyInfo`
 * @更新时间 `2020-12-24 17:20:26`
 */ const goPcmLoginGetThirdPartyInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/getThirdPartyInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginGetThirdPartyInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取第三方信息↗](https://yapi.yuewen.com/project/2309/interface/api/181728) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `GET /go/pcm/login/getThirdPartyInfo`
 * @更新时间 `2020-12-24 17:20:26`
 */ const goPcmLoginGetThirdPartyInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLoginGetThirdPartyInfoRequestConfig, requestData), ...args);
};
goPcmLoginGetThirdPartyInfo.requestConfig = goPcmLoginGetThirdPartyInfoRequestConfig;
/**
 * 接口 [激活用户名↗](https://yapi.yuewen.com/project/2309/interface/api/181733) 的 **请求配置**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `POST /go/pcm/login/checkAndActivate`
 * @更新时间 `2020-12-24 17:12:38`
 */ const goPcmLoginCheckAndActivateRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_20,
    devUrl: devUrl_0_0_0_20,
    prodUrl: prodUrl_0_0_0_20,
    path: "/go/pcm/login/checkAndActivate",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_20,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLoginCheckAndActivate",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [激活用户名↗](https://yapi.yuewen.com/project/2309/interface/api/181733) 的 **请求函数**
 *
 * @分类 [登录Login↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24028)
 * @请求头 `POST /go/pcm/login/checkAndActivate`
 * @更新时间 `2020-12-24 17:12:38`
 */ const goPcmLoginCheckAndActivate = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLoginCheckAndActivateRequestConfig, requestData), ...args);
};
goPcmLoginCheckAndActivate.requestConfig = goPcmLoginCheckAndActivateRequestConfig;
const mockUrl_0_0_0_21 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_21 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_21 = "https://www.webnovel.com";
const dataKey_0_0_0_21 = "data";
/**
 * 接口 [加入书架↗](https://yapi.yuewen.com/project/2309/interface/api/181747) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/addLibraryItemsAjax`
 * @更新时间 `2020-12-30 14:04:45`
 */ const goPcmLibraryAddLibraryItemsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/addLibraryItemsAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryAddLibraryItemsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [加入书架↗](https://yapi.yuewen.com/project/2309/interface/api/181747) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/addLibraryItemsAjax`
 * @更新时间 `2020-12-30 14:04:45`
 */ const goPcmLibraryAddLibraryItemsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLibraryAddLibraryItemsAjaxRequestConfig, requestData), ...args);
};
goPcmLibraryAddLibraryItemsAjax.requestConfig = goPcmLibraryAddLibraryItemsAjaxRequestConfig;
/**
 * 接口 [check是否在书架内↗](https://yapi.yuewen.com/project/2309/interface/api/181751) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/checkInLibraryAjax`
 * @更新时间 `2020-12-30 14:00:50`
 */ const goPcmLibraryCheckInLibraryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/checkInLibraryAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryCheckInLibraryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [check是否在书架内↗](https://yapi.yuewen.com/project/2309/interface/api/181751) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/checkInLibraryAjax`
 * @更新时间 `2020-12-30 14:00:50`
 */ const goPcmLibraryCheckInLibraryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLibraryCheckInLibraryAjaxRequestConfig, requestData), ...args);
};
goPcmLibraryCheckInLibraryAjax.requestConfig = goPcmLibraryCheckInLibraryAjaxRequestConfig;
/**
 * 接口 [删除书架页书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181756) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/deleteLibraryItemsAjax`
 * @更新时间 `2020-12-30 15:08:01`
 */ const goPcmLibraryDeleteLibraryItemsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/deleteLibraryItemsAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryDeleteLibraryItemsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [删除书架页书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181756) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/deleteLibraryItemsAjax`
 * @更新时间 `2020-12-30 15:08:01`
 */ const goPcmLibraryDeleteLibraryItemsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLibraryDeleteLibraryItemsAjaxRequestConfig, requestData), ...args);
};
goPcmLibraryDeleteLibraryItemsAjax.requestConfig = goPcmLibraryDeleteLibraryItemsAjaxRequestConfig;
/**
 * 接口 [获取阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181760) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/getReadingProgress`
 * @更新时间 `2020-12-30 14:57:16`
 */ const goPcmLibraryGetReadingProgressRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/getReadingProgress",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryGetReadingProgress",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181760) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/getReadingProgress`
 * @更新时间 `2020-12-30 14:57:16`
 */ const goPcmLibraryGetReadingProgress = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLibraryGetReadingProgressRequestConfig, requestData), ...args);
};
goPcmLibraryGetReadingProgress.requestConfig = goPcmLibraryGetReadingProgressRequestConfig;
/**
 * 接口 [书架页↗](https://yapi.yuewen.com/project/2309/interface/api/181765) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/library`
 * @更新时间 `2022-05-11 10:32:44`
 */ const goPcmLibraryLibraryRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/library",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "pageSize",
        "orderBy",
        "encryptType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibraryLibrary",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书架页↗](https://yapi.yuewen.com/project/2309/interface/api/181765) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/library/library`
 * @更新时间 `2022-05-11 10:32:44`
 */ const goPcmLibraryLibrary = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLibraryLibraryRequestConfig, requestData), ...args);
};
goPcmLibraryLibrary.requestConfig = goPcmLibraryLibraryRequestConfig;
/**
 * 接口 [设置阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181774) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setReadingProgressAjax`
 * @更新时间 `2024-06-11 16:44:11`
 */ const goPcmLibrarySetReadingProgressAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/setReadingProgressAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibrarySetReadingProgressAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [设置阅读进度↗](https://yapi.yuewen.com/project/2309/interface/api/181774) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setReadingProgressAjax`
 * @更新时间 `2024-06-11 16:44:11`
 */ const goPcmLibrarySetReadingProgressAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLibrarySetReadingProgressAjaxRequestConfig, requestData), ...args);
};
goPcmLibrarySetReadingProgressAjax.requestConfig = goPcmLibrarySetReadingProgressAjaxRequestConfig;
/**
 * 接口 [修改偏好↗](https://yapi.yuewen.com/project/2309/interface/api/181779) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setUserPreferenceAjax`
 * @更新时间 `2020-12-24 18:04:32`
 */ const goPcmLibrarySetUserPreferenceAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/library/setUserPreferenceAjax",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.none */.Py.none,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmLibrarySetUserPreferenceAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [修改偏好↗](https://yapi.yuewen.com/project/2309/interface/api/181779) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `POST /go/pcm/library/setUserPreferenceAjax`
 * @更新时间 `2020-12-24 18:04:32`
 */ const goPcmLibrarySetUserPreferenceAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmLibrarySetUserPreferenceAjaxRequestConfig, requestData), ...args);
};
goPcmLibrarySetUserPreferenceAjax.requestConfig = goPcmLibrarySetUserPreferenceAjaxRequestConfig;
/**
 * 接口 [test↗](https://yapi.yuewen.com/project/2309/interface/api/277617) 的 **请求配置**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/`
 * @更新时间 `2023-12-04 11:06:38`
 */ const goPcmRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_21,
    devUrl: devUrl_0_0_0_21,
    prodUrl: prodUrl_0_0_0_21,
    path: "/go/pcm/",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_21,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcm",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [test↗](https://yapi.yuewen.com/project/2309/interface/api/277617) 的 **请求函数**
 *
 * @分类 [library↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24041)
 * @请求头 `GET /go/pcm/`
 * @更新时间 `2023-12-04 11:06:38`
 */ const goPcm = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRequestConfig, requestData), ...args);
};
goPcm.requestConfig = goPcmRequestConfig;
const mockUrl_0_0_0_22 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_22 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_22 = "https://www.webnovel.com";
const dataKey_0_0_0_22 = "data";
/**
 * 接口 [获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/181864) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/page`
 * @更新时间 `2024-04-26 15:04:03`
 */ const goPcmPcbookcityPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: [
        "sex",
        "bookCityType",
        "language",
        "country"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取单个page页↗](https://yapi.yuewen.com/project/2309/interface/api/181864) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/page`
 * @更新时间 `2024-04-26 15:04:03`
 */ const goPcmPcbookcityPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPcbookcityPageRequestConfig, requestData), ...args);
};
goPcmPcbookcityPage.requestConfig = goPcmPcbookcityPageRequestConfig;
/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/181868) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-change`
 * @更新时间 `2020-12-25 17:20:18`
 */ const goPcmPcbookcityGetChangeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/get-change",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: [
        "pblockId",
        "blockId",
        "index"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityGetChange",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-change 书城block换一换接口↗](https://yapi.yuewen.com/project/2309/interface/api/181868) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-change`
 * @更新时间 `2020-12-25 17:20:18`
 */ const goPcmPcbookcityGetChange = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPcbookcityGetChangeRequestConfig, requestData), ...args);
};
goPcmPcbookcityGetChange.requestConfig = goPcmPcbookcityGetChangeRequestConfig;
/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181887) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-feed-list`
 * @更新时间 `2020-12-25 18:39:17`
 */ const goPcmPcbookcityGetFeedListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/get-feed-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityGetFeedList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-feed-list 获取feed流书籍↗](https://yapi.yuewen.com/project/2309/interface/api/181887) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/get-feed-list`
 * @更新时间 `2020-12-25 18:39:17`
 */ const goPcmPcbookcityGetFeedList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPcbookcityGetFeedListRequestConfig, requestData), ...args);
};
goPcmPcbookcityGetFeedList.requestConfig = goPcmPcbookcityGetFeedListRequestConfig;
/**
 * 接口 [游戏助手内嵌页推书接口↗](https://yapi.yuewen.com/project/2309/interface/api/216193) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/gameLoop`
 * @更新时间 `2021-06-22 14:10:32`
 */ const goPcmPcbookcityGameLoopRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/gameLoop",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityGameLoop",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [游戏助手内嵌页推书接口↗](https://yapi.yuewen.com/project/2309/interface/api/216193) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/gameLoop`
 * @更新时间 `2021-06-22 14:10:32`
 */ const goPcmPcbookcityGameLoop = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPcbookcityGameLoopRequestConfig, requestData), ...args);
};
goPcmPcbookcityGameLoop.requestConfig = goPcmPcbookcityGameLoopRequestConfig;
/**
 * 接口 [征文入口信息↗](https://yapi.yuewen.com/project/2309/interface/api/252153) 的 **请求配置**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/essay`
 * @更新时间 `2022-11-18 11:39:00`
 */ const goPcmPcbookcityEssayRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_22,
    devUrl: devUrl_0_0_0_22,
    prodUrl: prodUrl_0_0_0_22,
    path: "/go/pcm/pcbookcity/essay",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_22,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPcbookcityEssay",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [征文入口信息↗](https://yapi.yuewen.com/project/2309/interface/api/252153) 的 **请求函数**
 *
 * @分类 [PC 站 bookCity书城↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24057)
 * @请求头 `GET /go/pcm/pcbookcity/essay`
 * @更新时间 `2022-11-18 11:39:00`
 */ const goPcmPcbookcityEssay = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPcbookcityEssayRequestConfig, requestData), ...args);
};
goPcmPcbookcityEssay.requestConfig = goPcmPcbookcityEssayRequestConfig;
const mockUrl_0_0_0_23 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_23 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_23 = "https://www.webnovel.com";
const dataKey_0_0_0_23 = "data";
/**
 * 接口 [上报阅读时长↗](https://yapi.yuewen.com/project/2309/interface/api/182101) 的 **请求配置**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `POST /go/pcm/reading/report`
 * @更新时间 `2021-01-08 21:03:05`
 */ const goPcmReadingReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_23,
    devUrl: devUrl_0_0_0_23,
    prodUrl: prodUrl_0_0_0_23,
    path: "/go/pcm/reading/report",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_23,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [上报阅读时长↗](https://yapi.yuewen.com/project/2309/interface/api/182101) 的 **请求函数**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `POST /go/pcm/reading/report`
 * @更新时间 `2021-01-08 21:03:05`
 */ const goPcmReadingReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadingReportRequestConfig, requestData), ...args);
};
goPcmReadingReport.requestConfig = goPcmReadingReportRequestConfig;
/**
 * 接口 [末页↗](https://yapi.yuewen.com/project/2309/interface/api/246501) 的 **请求配置**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2022-09-23 10:25:29`
 */ const goPcmReadingLastPage2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_23,
    devUrl: devUrl_0_0_0_23,
    prodUrl: prodUrl_0_0_0_23,
    path: "/go/pcm/reading/lastPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_23,
    paramNames: [],
    queryNames: [
        "itemId",
        "itemType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingLastPage2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [末页↗](https://yapi.yuewen.com/project/2309/interface/api/246501) 的 **请求函数**
 *
 * @分类 [reading↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24128)
 * @请求头 `GET /go/pcm/reading/lastPage`
 * @更新时间 `2022-09-23 10:25:29`
 */ const goPcmReadingLastPage2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadingLastPage2RequestConfig, requestData), ...args);
};
goPcmReadingLastPage2.requestConfig = goPcmReadingLastPage2RequestConfig;
const mockUrl_0_0_0_24 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_24 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_24 = "https://www.webnovel.com";
const dataKey_0_0_0_24 = "data";
/**
 * 接口 [投票↗](https://yapi.yuewen.com/project/2309/interface/api/182128) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `POST /go/pcm/powerStone/vote`
 * @更新时间 `2021-02-07 01:30:28`
 */ const goPcmPowerStoneVoteRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/vote",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneVote",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [投票↗](https://yapi.yuewen.com/project/2309/interface/api/182128) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `POST /go/pcm/powerStone/vote`
 * @更新时间 `2021-02-07 01:30:28`
 */ const goPcmPowerStoneVote = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneVoteRequestConfig, requestData), ...args);
};
goPcmPowerStoneVote.requestConfig = goPcmPowerStoneVoteRequestConfig;
/**
 * 接口 [获取用户推荐票投票记录(ajax)↗](https://yapi.yuewen.com/project/2309/interface/api/195219) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryAjax`
 * @更新时间 `2021-01-25 20:06:43`
 */ const goPcmPowerStoneGetHistoryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getHistoryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetHistoryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户推荐票投票记录(ajax)↗](https://yapi.yuewen.com/project/2309/interface/api/195219) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryAjax`
 * @更新时间 `2021-01-25 20:06:43`
 */ const goPcmPowerStoneGetHistoryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneGetHistoryAjaxRequestConfig, requestData), ...args);
};
goPcmPowerStoneGetHistoryAjax.requestConfig = goPcmPowerStoneGetHistoryAjaxRequestConfig;
/**
 * 接口 [获取用户推荐票投票记录(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195225) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryPage`
 * @更新时间 `2021-01-25 20:07:14`
 */ const goPcmPowerStoneGetHistoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getHistoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetHistoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取用户推荐票投票记录(直出)↗](https://yapi.yuewen.com/project/2309/interface/api/195225) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getHistoryPage`
 * @更新时间 `2021-01-25 20:07:14`
 */ const goPcmPowerStoneGetHistoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneGetHistoryPageRequestConfig, requestData), ...args);
};
goPcmPowerStoneGetHistoryPage.requestConfig = goPcmPowerStoneGetHistoryPageRequestConfig;
/**
 * 接口 [powerStone\/getList↗](https://yapi.yuewen.com/project/2309/interface/api/195231) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getList`
 * @更新时间 `2021-02-06 23:09:43`
 */ const goPcmPowerStoneGetListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "timestamp",
        "type",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [powerStone\/getList↗](https://yapi.yuewen.com/project/2309/interface/api/195231) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getList`
 * @更新时间 `2021-02-06 23:09:43`
 */ const goPcmPowerStoneGetList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneGetListRequestConfig, requestData), ...args);
};
goPcmPowerStoneGetList.requestConfig = goPcmPowerStoneGetListRequestConfig;
/**
 * 接口 [getListAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195237) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getListAjax`
 * @更新时间 `2021-01-25 20:08:55`
 */ const goPcmPowerStoneGetListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "timestamp",
        "type",
        "pageIndex",
        "_csrfToken"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getListAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195237) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getListAjax`
 * @更新时间 `2021-01-25 20:08:55`
 */ const goPcmPowerStoneGetListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneGetListAjaxRequestConfig, requestData), ...args);
};
goPcmPowerStoneGetListAjax.requestConfig = goPcmPowerStoneGetListAjaxRequestConfig;
/**
 * 接口 [推荐票排行榜直出↗](https://yapi.yuewen.com/project/2309/interface/api/195243) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookId`
 * @更新时间 `2021-02-06 23:36:10`
 */ const goPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getPowerStoneRankingByBookId",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetPowerStoneRankingByBookId",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [推荐票排行榜直出↗](https://yapi.yuewen.com/project/2309/interface/api/195243) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookId`
 * @更新时间 `2021-02-06 23:36:10`
 */ const goPcmPowerStoneGetPowerStoneRankingByBookId = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig, requestData), ...args);
};
goPcmPowerStoneGetPowerStoneRankingByBookId.requestConfig = goPcmPowerStoneGetPowerStoneRankingByBookIdRequestConfig;
/**
 * 接口 [推荐票排行榜-分页↗](https://yapi.yuewen.com/project/2309/interface/api/195250) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2021-02-05 17:42:31`
 */ const goPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getPowerStoneRankingByBookIdList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetPowerStoneRankingByBookIdList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [推荐票排行榜-分页↗](https://yapi.yuewen.com/project/2309/interface/api/195250) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getPowerStoneRankingByBookIdList`
 * @更新时间 `2021-02-05 17:42:31`
 */ const goPcmPowerStoneGetPowerStoneRankingByBookIdList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig, requestData), ...args);
};
goPcmPowerStoneGetPowerStoneRankingByBookIdList.requestConfig = goPcmPowerStoneGetPowerStoneRankingByBookIdListRequestConfig;
/**
 * 接口 [getRankInfoAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195256) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getRankInfoAjax`
 * @更新时间 `2021-02-07 19:46:38`
 */ const goPcmPowerStoneGetRankInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/getRankInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "bookId",
        "bookType",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneGetRankInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getRankInfoAjax↗](https://yapi.yuewen.com/project/2309/interface/api/195256) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/getRankInfoAjax`
 * @更新时间 `2021-02-07 19:46:38`
 */ const goPcmPowerStoneGetRankInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneGetRankInfoAjaxRequestConfig, requestData), ...args);
};
goPcmPowerStoneGetRankInfoAjax.requestConfig = goPcmPowerStoneGetRankInfoAjaxRequestConfig;
/**
 * 接口 [拉取票详情页数据 - 用户期待票、推荐票信息，及流水↗](https://yapi.yuewen.com/project/2309/interface/api/197915) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/stoneDetailAjax`
 * @更新时间 `2021-02-20 18:35:17`
 */ const goPcmPowerStoneStoneDetailAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/powerStone/stoneDetailAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "type"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPowerStoneStoneDetailAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取票详情页数据 - 用户期待票、推荐票信息，及流水↗](https://yapi.yuewen.com/project/2309/interface/api/197915) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/powerStone/stoneDetailAjax`
 * @更新时间 `2021-02-20 18:35:17`
 */ const goPcmPowerStoneStoneDetailAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPowerStoneStoneDetailAjaxRequestConfig, requestData), ...args);
};
goPcmPowerStoneStoneDetailAjax.requestConfig = goPcmPowerStoneStoneDetailAjaxRequestConfig;
/**
 * 接口 [拉取书籍的推荐票信息↗](https://yapi.yuewen.com/project/2309/interface/api/197922) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/powerStone/powerInfoAjax`
 * @更新时间 `2021-02-22 16:06:08`
 */ const goPcmGoPcmPowerStonePowerInfoAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/go/pcm/powerStone/powerInfoAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "bookId",
        "bookType",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGoPcmPowerStonePowerInfoAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取书籍的推荐票信息↗](https://yapi.yuewen.com/project/2309/interface/api/197922) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/powerStone/powerInfoAjax`
 * @更新时间 `2021-02-22 16:06:08`
 */ const goPcmGoPcmPowerStonePowerInfoAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGoPcmPowerStonePowerInfoAjaxRequestConfig, requestData), ...args);
};
goPcmGoPcmPowerStonePowerInfoAjax.requestConfig = goPcmGoPcmPowerStonePowerInfoAjaxRequestConfig;
/**
 * 接口 [拉取排行榜列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/197924) 的 **请求配置**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/go/pcm/powerStone/powerListAjax`
 * @更新时间 `2021-02-22 16:07:01`
 */ const goPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_24,
    devUrl: devUrl_0_0_0_24,
    prodUrl: prodUrl_0_0_0_24,
    path: "/go/pcm/go/pcm/go/pcm/powerStone/powerListAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_24,
    paramNames: [],
    queryNames: [
        "bookType",
        "pageIndex",
        "pageSize",
        "timestamp"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmGoPcmGoPcmPowerStonePowerListAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取排行榜列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/197924) 的 **请求函数**
 *
 * @分类 [powerStone↗](https://yapi.yuewen.com/project/2309/interface/api/cat_24138)
 * @请求头 `GET /go/pcm/go/pcm/go/pcm/powerStone/powerListAjax`
 * @更新时间 `2021-02-22 16:07:01`
 */ const goPcmGoPcmGoPcmPowerStonePowerListAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig, requestData), ...args);
};
goPcmGoPcmGoPcmPowerStonePowerListAjax.requestConfig = goPcmGoPcmGoPcmPowerStonePowerListAjaxRequestConfig;
const mockUrl_0_0_0_25 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_25 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_25 = "https://www.webnovel.com";
const dataKey_0_0_0_25 = "data";
/**
 * 接口 [发送Download Webnovel APP邮件↗](https://yapi.yuewen.com/project/2309/interface/api/191389) 的 **请求配置**
 *
 * @分类 [mailService↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25103)
 * @请求头 `POST /go/pcm/mail/SendAppLink`
 * @更新时间 `2021-01-18 14:36:58`
 */ const goPcmMailSendAppLinkRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_25,
    devUrl: devUrl_0_0_0_25,
    prodUrl: prodUrl_0_0_0_25,
    path: "/go/pcm/mail/SendAppLink",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_25,
    paramNames: [],
    queryNames: [
        "addr"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMailSendAppLink",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [发送Download Webnovel APP邮件↗](https://yapi.yuewen.com/project/2309/interface/api/191389) 的 **请求函数**
 *
 * @分类 [mailService↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25103)
 * @请求头 `POST /go/pcm/mail/SendAppLink`
 * @更新时间 `2021-01-18 14:36:58`
 */ const goPcmMailSendAppLink = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMailSendAppLinkRequestConfig, requestData), ...args);
};
goPcmMailSendAppLink.requestConfig = goPcmMailSendAppLinkRequestConfig;
const mockUrl_0_0_0_26 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_26 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_26 = "https://www.webnovel.com";
const dataKey_0_0_0_26 = "data";
/**
 * 接口 [getRankConfig 获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/191396) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankConfig`
 * @更新时间 `2021-01-18 19:54:11`
 */ const goPcmCategoryGetRankConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankConfig",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankConfig",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getRankConfig 获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/191396) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankConfig`
 * @更新时间 `2021-01-18 19:54:11`
 */ const goPcmCategoryGetRankConfig = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryGetRankConfigRequestConfig, requestData), ...args);
};
goPcmCategoryGetRankConfig.requestConfig = goPcmCategoryGetRankConfigRequestConfig;
/**
 * 接口 [getRankList 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/191409) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankList`
 * @更新时间 `2023-11-03 16:48:32`
 */ const goPcmCategoryGetRankListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
        "listType",
        "type",
        "rankId",
        "timeType",
        "pageIndex",
        "sourceType",
        "sex",
        "signStatus"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getRankList 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/191409) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankList`
 * @更新时间 `2023-11-03 16:48:32`
 */ const goPcmCategoryGetRankList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryGetRankListRequestConfig, requestData), ...args);
};
goPcmCategoryGetRankList.requestConfig = goPcmCategoryGetRankListRequestConfig;
/**
 * 接口 [categoryPage 书库分类列表（带fanfic）↗](https://yapi.yuewen.com/project/2309/interface/api/192865) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryPage`
 * @更新时间 `2021-02-22 13:47:02`
 */ const goPcmCategoryCategoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/categoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
        "categoryType",
        "categoryId",
        "sourceType",
        "bookStatus",
        "orderBy",
        "pageIndex",
        "gender",
        "chapterNum",
        "translateMode",
        "priceType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryCategoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [categoryPage 书库分类列表（带fanfic）↗](https://yapi.yuewen.com/project/2309/interface/api/192865) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryPage`
 * @更新时间 `2021-02-22 13:47:02`
 */ const goPcmCategoryCategoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryCategoryPageRequestConfig, requestData), ...args);
};
goPcmCategoryCategoryPage.requestConfig = goPcmCategoryCategoryPageRequestConfig;
/**
 * 接口 [categoryAjax 书库分类列表（带fanfic)↗](https://yapi.yuewen.com/project/2309/interface/api/192872) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryAjax`
 * @更新时间 `2021-06-08 10:23:37`
 */ const goPcmCategoryCategoryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/categoryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
        "categoryType",
        "categoryId",
        "sourceType",
        "bookStatus",
        "orderBy",
        "pageIndex",
        "gender",
        "chapterNum",
        "translateMode",
        "priceType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryCategoryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [categoryAjax 书库分类列表（带fanfic)↗](https://yapi.yuewen.com/project/2309/interface/api/192872) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/categoryAjax`
 * @更新时间 `2021-06-08 10:23:37`
 */ const goPcmCategoryCategoryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryCategoryAjaxRequestConfig, requestData), ...args);
};
goPcmCategoryCategoryAjax.requestConfig = goPcmCategoryCategoryAjaxRequestConfig;
/**
 * 接口 [getRankCollections 获取书库榜单集合 （PC用）↗](https://yapi.yuewen.com/project/2309/interface/api/192993) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `POST /go/pcm/category/getRankCollections`
 * @更新时间 `2021-02-01 19:12:58`
 */ const goPcmCategoryGetRankCollectionsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankCollections",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankCollections",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getRankCollections 获取书库榜单集合 （PC用）↗](https://yapi.yuewen.com/project/2309/interface/api/192993) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `POST /go/pcm/category/getRankCollections`
 * @更新时间 `2021-02-01 19:12:58`
 */ const goPcmCategoryGetRankCollections = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryGetRankCollectionsRequestConfig, requestData), ...args);
};
goPcmCategoryGetRankCollections.requestConfig = goPcmCategoryGetRankCollectionsRequestConfig;
/**
 * 接口 [getRankListPage 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/196567) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankListPage`
 * @更新时间 `2021-06-08 10:24:50`
 */ const goPcmCategoryGetRankListPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getRankListPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
        "listType",
        "type",
        "rankId",
        "timeType",
        "pageIndex",
        "sourceType",
        "sex",
        "signStatus"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetRankListPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getRankListPage 获取书库榜单书籍↗](https://yapi.yuewen.com/project/2309/interface/api/196567) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getRankListPage`
 * @更新时间 `2021-06-08 10:24:50`
 */ const goPcmCategoryGetRankListPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryGetRankListPageRequestConfig, requestData), ...args);
};
goPcmCategoryGetRankListPage.requestConfig = goPcmCategoryGetRankListPageRequestConfig;
/**
 * 接口 [根据TYPE获取分类列表, 默认给全部↗](https://yapi.yuewen.com/project/2309/interface/api/207086) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getCategories`
 * @更新时间 `2021-04-28 19:49:34`
 */ const goPcmCategoryGetCategoriesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getCategories",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [
        "categoryType",
        "gender"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetCategories",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [根据TYPE获取分类列表, 默认给全部↗](https://yapi.yuewen.com/project/2309/interface/api/207086) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getCategories`
 * @更新时间 `2021-04-28 19:49:34`
 */ const goPcmCategoryGetCategories = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryGetCategoriesRequestConfig, requestData), ...args);
};
goPcmCategoryGetCategories.requestConfig = goPcmCategoryGetCategoriesRequestConfig;
/**
 * 接口 [GetAllAjax  获取所有的分类 名称+bookid↗](https://yapi.yuewen.com/project/2309/interface/api/207427) 的 **请求配置**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getAllAjax`
 * @更新时间 `2021-05-11 16:23:23`
 */ const goPcmCategoryGetAllAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_26,
    devUrl: devUrl_0_0_0_26,
    prodUrl: prodUrl_0_0_0_26,
    path: "/go/pcm/category/getAllAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_26,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCategoryGetAllAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [GetAllAjax  获取所有的分类 名称+bookid↗](https://yapi.yuewen.com/project/2309/interface/api/207427) 的 **请求函数**
 *
 * @分类 [category↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25106)
 * @请求头 `GET /go/pcm/category/getAllAjax`
 * @更新时间 `2021-05-11 16:23:23`
 */ const goPcmCategoryGetAllAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCategoryGetAllAjaxRequestConfig, requestData), ...args);
};
goPcmCategoryGetAllAjax.requestConfig = goPcmCategoryGetAllAjaxRequestConfig;
const mockUrl_0_0_0_27 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_27 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_27 = "https://www.webnovel.com";
const dataKey_0_0_0_27 = "data";
/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/2309/interface/api/191937) 的 **请求配置**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRankingList`
 * @更新时间 `2021-01-20 14:28:14`
 */ const goPcmFansGetBookFansRankingListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_27,
    devUrl: devUrl_0_0_0_27,
    prodUrl: prodUrl_0_0_0_27,
    path: "/go/pcm/fans/getBookFansRankingList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_27,
    paramNames: [],
    queryNames: [
        "bookId",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFansGetBookFansRankingList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [粉丝排行榜-Ajax↗](https://yapi.yuewen.com/project/2309/interface/api/191937) 的 **请求函数**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRankingList`
 * @更新时间 `2021-01-20 14:28:14`
 */ const goPcmFansGetBookFansRankingList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmFansGetBookFansRankingListRequestConfig, requestData), ...args);
};
goPcmFansGetBookFansRankingList.requestConfig = goPcmFansGetBookFansRankingListRequestConfig;
/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/2309/interface/api/191951) 的 **请求配置**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRanking`
 * @更新时间 `2021-04-29 17:12:28`
 */ const goPcmFansGetBookFansRankingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_27,
    devUrl: devUrl_0_0_0_27,
    prodUrl: prodUrl_0_0_0_27,
    path: "/go/pcm/fans/getBookFansRanking",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_27,
    paramNames: [],
    queryNames: [
        "bookId",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmFansGetBookFansRanking",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [粉丝排行榜-直出↗](https://yapi.yuewen.com/project/2309/interface/api/191951) 的 **请求函数**
 *
 * @分类 [Fans↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25163)
 * @请求头 `GET /go/pcm/fans/getBookFansRanking`
 * @更新时间 `2021-04-29 17:12:28`
 */ const goPcmFansGetBookFansRanking = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmFansGetBookFansRankingRequestConfig, requestData), ...args);
};
goPcmFansGetBookFansRanking.requestConfig = goPcmFansGetBookFansRankingRequestConfig;
const mockUrl_0_0_0_28 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_28 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_28 = "https://www.webnovel.com";
const dataKey_0_0_0_28 = "data";
/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/2309/interface/api/191970) 的 **请求配置**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/needCaptcha`
 * @更新时间 `2021-01-20 16:34:15`
 */ const goPcmCdkeyNeedCaptchaRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_28,
    devUrl: devUrl_0_0_0_28,
    prodUrl: prodUrl_0_0_0_28,
    path: "/go/pcm/cdkey/needCaptcha",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCdkeyNeedCaptcha",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [是否需要验证码↗](https://yapi.yuewen.com/project/2309/interface/api/191970) 的 **请求函数**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/needCaptcha`
 * @更新时间 `2021-01-20 16:34:15`
 */ const goPcmCdkeyNeedCaptcha = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCdkeyNeedCaptchaRequestConfig, requestData), ...args);
};
goPcmCdkeyNeedCaptcha.requestConfig = goPcmCdkeyNeedCaptchaRequestConfig;
/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/2309/interface/api/191976) 的 **请求配置**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `POST /go/pcm/cdkey/redeem`
 * @更新时间 `2021-01-20 16:38:25`
 */ const goPcmCdkeyRedeemRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_28,
    devUrl: devUrl_0_0_0_28,
    prodUrl: prodUrl_0_0_0_28,
    path: "/go/pcm/cdkey/redeem",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCdkeyRedeem",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [兑换积分↗](https://yapi.yuewen.com/project/2309/interface/api/191976) 的 **请求函数**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `POST /go/pcm/cdkey/redeem`
 * @更新时间 `2021-01-20 16:38:25`
 */ const goPcmCdkeyRedeem = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCdkeyRedeemRequestConfig, requestData), ...args);
};
goPcmCdkeyRedeem.requestConfig = goPcmCdkeyRedeemRequestConfig;
/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/2309/interface/api/191982) 的 **请求配置**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/userStatus`
 * @更新时间 `2021-01-20 17:40:17`
 */ const goPcmCdkeyUserStatusRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_28,
    devUrl: devUrl_0_0_0_28,
    prodUrl: prodUrl_0_0_0_28,
    path: "/go/pcm/cdkey/userStatus",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_28,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmCdkeyUserStatus",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [用户封禁状态↗](https://yapi.yuewen.com/project/2309/interface/api/191982) 的 **请求函数**
 *
 * @分类 [cdKey↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25166)
 * @请求头 `GET /go/pcm/cdkey/userStatus`
 * @更新时间 `2021-01-20 17:40:17`
 */ const goPcmCdkeyUserStatus = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmCdkeyUserStatusRequestConfig, requestData), ...args);
};
goPcmCdkeyUserStatus.requestConfig = goPcmCdkeyUserStatusRequestConfig;
const mockUrl_0_0_0_29 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_29 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_29 = "https://www.webnovel.com";
const dataKey_0_0_0_29 = "data";
/**
 * 接口 [获取我的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/191988) 的 **请求配置**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getMyBadges`
 * @更新时间 `2021-01-20 17:43:31`
 */ const goPcmBadgeGetMyBadgesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_29,
    devUrl: devUrl_0_0_0_29,
    prodUrl: prodUrl_0_0_0_29,
    path: "/go/pcm/badge/getMyBadges",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_29,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBadgeGetMyBadges",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取我的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/191988) 的 **请求函数**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getMyBadges`
 * @更新时间 `2021-01-20 17:43:31`
 */ const goPcmBadgeGetMyBadges = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBadgeGetMyBadgesRequestConfig, requestData), ...args);
};
goPcmBadgeGetMyBadges.requestConfig = goPcmBadgeGetMyBadgesRequestConfig;
/**
 * 接口 [获取徽章详情↗](https://yapi.yuewen.com/project/2309/interface/api/191994) 的 **请求配置**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getBadgeDetail`
 * @更新时间 `2021-01-20 17:45:53`
 */ const goPcmBadgeGetBadgeDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_29,
    devUrl: devUrl_0_0_0_29,
    prodUrl: prodUrl_0_0_0_29,
    path: "/go/pcm/badge/getBadgeDetail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_29,
    paramNames: [],
    queryNames: [
        "badgeId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBadgeGetBadgeDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取徽章详情↗](https://yapi.yuewen.com/project/2309/interface/api/191994) 的 **请求函数**
 *
 * @分类 [badge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25175)
 * @请求头 `GET /go/pcm/badge/getBadgeDetail`
 * @更新时间 `2021-01-20 17:45:53`
 */ const goPcmBadgeGetBadgeDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBadgeGetBadgeDetailRequestConfig, requestData), ...args);
};
goPcmBadgeGetBadgeDetail.requestConfig = goPcmBadgeGetBadgeDetailRequestConfig;
const mockUrl_0_0_0_30 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_30 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_30 = "https://www.webnovel.com";
const dataKey_0_0_0_30 = "data";
/**
 * 接口 [getGearInfo↗](https://yapi.yuewen.com/project/2309/interface/api/175513) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2021-03-29 11:26:42`
 */ const goPcmRechargeGetGearInfo2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_30,
    devUrl: devUrl_0_0_0_30,
    prodUrl: prodUrl_0_0_0_30,
    path: "/go/pcm/recharge/getGearInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRechargeGetGearInfo2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getGearInfo↗](https://yapi.yuewen.com/project/2309/interface/api/175513) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfo`
 * @更新时间 `2021-03-29 11:26:42`
 */ const goPcmRechargeGetGearInfo2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRechargeGetGearInfo2RequestConfig, requestData), ...args);
};
goPcmRechargeGetGearInfo2.requestConfig = goPcmRechargeGetGearInfo2RequestConfig;
/**
 * 接口 [m站获取充值接口↗](https://yapi.yuewen.com/project/2309/interface/api/195497) 的 **请求配置**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfoByMobileNew`
 * @更新时间 `2021-05-28 14:26:17`
 */ const goPcmRechargeGetGearInfoByMobileNewRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_30,
    devUrl: devUrl_0_0_0_30,
    prodUrl: prodUrl_0_0_0_30,
    path: "/go/pcm/recharge/getGearInfoByMobileNew",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_30,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRechargeGetGearInfoByMobileNew",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [m站获取充值接口↗](https://yapi.yuewen.com/project/2309/interface/api/195497) 的 **请求函数**
 *
 * @分类 [recharge↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25322)
 * @请求头 `GET /go/pcm/recharge/getGearInfoByMobileNew`
 * @更新时间 `2021-05-28 14:26:17`
 */ const goPcmRechargeGetGearInfoByMobileNew = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRechargeGetGearInfoByMobileNewRequestConfig, requestData), ...args);
};
goPcmRechargeGetGearInfoByMobileNew.requestConfig = goPcmRechargeGetGearInfoByMobileNewRequestConfig;
const mockUrl_0_0_0_31 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_31 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_31 = "https://www.webnovel.com";
const dataKey_0_0_0_31 = "data";
/**
 * 接口 [addContent - 新增机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195180) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/addContent`
 * @更新时间 `2021-01-25 20:02:30`
 */ const goPcmMachineTransAddContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/addContent",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransAddContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [addContent - 新增机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195180) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/addContent`
 * @更新时间 `2021-01-25 20:02:30`
 */ const goPcmMachineTransAddContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMachineTransAddContentRequestConfig, requestData), ...args);
};
goPcmMachineTransAddContent.requestConfig = goPcmMachineTransAddContentRequestConfig;
/**
 * 接口 [updateContent - 修改机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195187) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/updateContent`
 * @更新时间 `2021-01-25 20:01:57`
 */ const goPcmMachineTransUpdateContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/updateContent",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransUpdateContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [updateContent - 修改机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195187) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/updateContent`
 * @更新时间 `2021-01-25 20:01:57`
 */ const goPcmMachineTransUpdateContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMachineTransUpdateContentRequestConfig, requestData), ...args);
};
goPcmMachineTransUpdateContent.requestConfig = goPcmMachineTransUpdateContentRequestConfig;
/**
 * 接口 [delContent - 删除机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195194) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/delContent`
 * @更新时间 `2021-01-25 20:01:28`
 */ const goPcmMachineTransDelContentRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/delContent",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransDelContent",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [delContent - 删除机翻内容↗](https://yapi.yuewen.com/project/2309/interface/api/195194) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/delContent`
 * @更新时间 `2021-01-25 20:01:28`
 */ const goPcmMachineTransDelContent = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMachineTransDelContentRequestConfig, requestData), ...args);
};
goPcmMachineTransDelContent.requestConfig = goPcmMachineTransDelContentRequestConfig;
/**
 * 接口 [like - 对机翻内容点赞和取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/195201) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/like`
 * @更新时间 `2021-01-25 20:00:52`
 */ const goPcmMachineTransLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/like",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransLike",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [like - 对机翻内容点赞和取消点赞↗](https://yapi.yuewen.com/project/2309/interface/api/195201) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/like`
 * @更新时间 `2021-01-25 20:00:52`
 */ const goPcmMachineTransLike = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMachineTransLikeRequestConfig, requestData), ...args);
};
goPcmMachineTransLike.requestConfig = goPcmMachineTransLikeRequestConfig;
/**
 * 接口 [getContentList - 获取机翻内容列表↗](https://yapi.yuewen.com/project/2309/interface/api/195207) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `GET /go/pcm/machineTrans/getContentList`
 * @更新时间 `2021-01-25 20:00:07`
 */ const goPcmMachineTransGetContentListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/getContentList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [
        "chapterId",
        "paragraphId",
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransGetContentList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getContentList - 获取机翻内容列表↗](https://yapi.yuewen.com/project/2309/interface/api/195207) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `GET /go/pcm/machineTrans/getContentList`
 * @更新时间 `2021-01-25 20:00:07`
 */ const goPcmMachineTransGetContentList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMachineTransGetContentListRequestConfig, requestData), ...args);
};
goPcmMachineTransGetContentList.requestConfig = goPcmMachineTransGetContentListRequestConfig;
/**
 * 接口 [report - 对机翻内容举报↗](https://yapi.yuewen.com/project/2309/interface/api/195213) 的 **请求配置**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/report`
 * @更新时间 `2021-01-25 19:59:30`
 */ const goPcmMachineTransReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_31,
    devUrl: devUrl_0_0_0_31,
    prodUrl: prodUrl_0_0_0_31,
    path: "/go/pcm/machineTrans/report",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_31,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMachineTransReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [report - 对机翻内容举报↗](https://yapi.yuewen.com/project/2309/interface/api/195213) 的 **请求函数**
 *
 * @分类 [machineTrans机翻↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25709)
 * @请求头 `POST /go/pcm/machineTrans/report`
 * @更新时间 `2021-01-25 19:59:30`
 */ const goPcmMachineTransReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMachineTransReportRequestConfig, requestData), ...args);
};
goPcmMachineTransReport.requestConfig = goPcmMachineTransReportRequestConfig;
const mockUrl_0_0_0_32 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_32 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_32 = "https://www.webnovel.com";
const dataKey_0_0_0_32 = "data";
/**
 * 接口 [ readingHistoryAjax - 历史记录列表↗](https://yapi.yuewen.com/project/2309/interface/api/195906) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryAjax`
 * @更新时间 `2021-01-28 15:36:35`
 */ const goPcmReadingHistoryReadingHistoryAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/readingHistoryAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryReadingHistoryAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ readingHistoryAjax - 历史记录列表↗](https://yapi.yuewen.com/project/2309/interface/api/195906) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryAjax`
 * @更新时间 `2021-01-28 15:36:35`
 */ const goPcmReadingHistoryReadingHistoryAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadingHistoryReadingHistoryAjaxRequestConfig, requestData), ...args);
};
goPcmReadingHistoryReadingHistoryAjax.requestConfig = goPcmReadingHistoryReadingHistoryAjaxRequestConfig;
/**
 * 接口 [ readingHistoryPage - 历史记录列表直出↗](https://yapi.yuewen.com/project/2309/interface/api/195917) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryPage`
 * @更新时间 `2021-01-28 15:38:09`
 */ const goPcmReadingHistoryReadingHistoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/readingHistoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryReadingHistoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ readingHistoryPage - 历史记录列表直出↗](https://yapi.yuewen.com/project/2309/interface/api/195917) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/readingHistoryPage`
 * @更新时间 `2021-01-28 15:38:09`
 */ const goPcmReadingHistoryReadingHistoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadingHistoryReadingHistoryPageRequestConfig, requestData), ...args);
};
goPcmReadingHistoryReadingHistoryPage.requestConfig = goPcmReadingHistoryReadingHistoryPageRequestConfig;
/**
 * 接口 [deleteReadingHistory - 删除阅读历史↗](https://yapi.yuewen.com/project/2309/interface/api/195923) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/deleteReadingHistory`
 * @更新时间 `2021-01-28 15:42:55`
 */ const goPcmReadingHistoryDeleteReadingHistoryRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/deleteReadingHistory",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryDeleteReadingHistory",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [deleteReadingHistory - 删除阅读历史↗](https://yapi.yuewen.com/project/2309/interface/api/195923) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/deleteReadingHistory`
 * @更新时间 `2021-01-28 15:42:55`
 */ const goPcmReadingHistoryDeleteReadingHistory = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadingHistoryDeleteReadingHistoryRequestConfig, requestData), ...args);
};
goPcmReadingHistoryDeleteReadingHistory.requestConfig = goPcmReadingHistoryDeleteReadingHistoryRequestConfig;
/**
 * 接口 [clearReadingHistory - 清除所有历史记录↗](https://yapi.yuewen.com/project/2309/interface/api/195924) 的 **请求配置**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/clearReadingHistory`
 * @更新时间 `2021-01-28 15:49:51`
 */ const goPcmReadingHistoryClearReadingHistoryRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_32,
    devUrl: devUrl_0_0_0_32,
    prodUrl: prodUrl_0_0_0_32,
    path: "/go/pcm/readingHistory/clearReadingHistory",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_32,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadingHistoryClearReadingHistory",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [clearReadingHistory - 清除所有历史记录↗](https://yapi.yuewen.com/project/2309/interface/api/195924) 的 **请求函数**
 *
 * @分类 [readingHistory↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25792)
 * @请求头 `GET /go/pcm/readingHistory/clearReadingHistory`
 * @更新时间 `2021-01-28 15:49:51`
 */ const goPcmReadingHistoryClearReadingHistory = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadingHistoryClearReadingHistoryRequestConfig, requestData), ...args);
};
goPcmReadingHistoryClearReadingHistory.requestConfig = goPcmReadingHistoryClearReadingHistoryRequestConfig;
const mockUrl_0_0_0_33 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_33 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_33 = "https://www.webnovel.com";
const dataKey_0_0_0_33 = "data";
/**
 * 接口 [GetMessages 消息页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/196778) 的 **请求配置**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessages`
 * @更新时间 `2021-02-07 14:57:25`
 */ const goPcmMessageGetMessagesRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_33,
    devUrl: devUrl_0_0_0_33,
    prodUrl: prodUrl_0_0_0_33,
    path: "/go/pcm/message/getMessages",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_33,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetMessages",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [GetMessages 消息页直出数据↗](https://yapi.yuewen.com/project/2309/interface/api/196778) 的 **请求函数**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessages`
 * @更新时间 `2021-02-07 14:57:25`
 */ const goPcmMessageGetMessages = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMessageGetMessagesRequestConfig, requestData), ...args);
};
goPcmMessageGetMessages.requestConfig = goPcmMessageGetMessagesRequestConfig;
/**
 * 接口 [GetMessagesAjax 消息列表ajax请求接口↗](https://yapi.yuewen.com/project/2309/interface/api/196787) 的 **请求配置**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessagesAjax`
 * @更新时间 `2021-02-07 14:20:59`
 */ const goPcmMessageGetMessagesAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_33,
    devUrl: devUrl_0_0_0_33,
    prodUrl: prodUrl_0_0_0_33,
    path: "/go/pcm/message/getMessagesAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_33,
    paramNames: [],
    queryNames: [
        "lastId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMessageGetMessagesAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [GetMessagesAjax 消息列表ajax请求接口↗](https://yapi.yuewen.com/project/2309/interface/api/196787) 的 **请求函数**
 *
 * @分类 [message↗](https://yapi.yuewen.com/project/2309/interface/api/cat_25856)
 * @请求头 `GET /go/pcm/message/getMessagesAjax`
 * @更新时间 `2021-02-07 14:20:59`
 */ const goPcmMessageGetMessagesAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMessageGetMessagesAjaxRequestConfig, requestData), ...args);
};
goPcmMessageGetMessagesAjax.requestConfig = goPcmMessageGetMessagesAjaxRequestConfig;
const mockUrl_0_0_0_34 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_34 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_34 = "https://www.webnovel.com";
const dataKey_0_0_0_34 = "data";
/**
 * 接口 [claimTaskReward↗](https://yapi.yuewen.com/project/2309/interface/api/197973) 的 **请求配置**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `POST /go/pcm/task/claimTaskReward`
 * @更新时间 `2021-02-23 19:39:41`
 */ const goPcmTaskClaimTaskRewardRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_34,
    devUrl: devUrl_0_0_0_34,
    prodUrl: prodUrl_0_0_0_34,
    path: "/go/pcm/task/claimTaskReward",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_34,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTaskClaimTaskReward",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [claimTaskReward↗](https://yapi.yuewen.com/project/2309/interface/api/197973) 的 **请求函数**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `POST /go/pcm/task/claimTaskReward`
 * @更新时间 `2021-02-23 19:39:41`
 */ const goPcmTaskClaimTaskReward = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTaskClaimTaskRewardRequestConfig, requestData), ...args);
};
goPcmTaskClaimTaskReward.requestConfig = goPcmTaskClaimTaskRewardRequestConfig;
/**
 * 接口 [getTaskList↗](https://yapi.yuewen.com/project/2309/interface/api/197990) 的 **请求配置**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `GET /go/pcm/task/getTaskList`
 * @更新时间 `2021-02-23 19:42:22`
 */ const goPcmTaskGetTaskListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_34,
    devUrl: devUrl_0_0_0_34,
    prodUrl: prodUrl_0_0_0_34,
    path: "/go/pcm/task/getTaskList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_34,
    paramNames: [],
    queryNames: [
        "taskType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTaskGetTaskList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getTaskList↗](https://yapi.yuewen.com/project/2309/interface/api/197990) 的 **请求函数**
 *
 * @分类 [task↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26290)
 * @请求头 `GET /go/pcm/task/getTaskList`
 * @更新时间 `2021-02-23 19:42:22`
 */ const goPcmTaskGetTaskList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTaskGetTaskListRequestConfig, requestData), ...args);
};
goPcmTaskGetTaskList.requestConfig = goPcmTaskGetTaskListRequestConfig;
const mockUrl_0_0_0_35 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_35 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_35 = "https://www.webnovel.com";
const dataKey_0_0_0_35 = "data";
/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/198180) 的 **请求配置**
 *
 * @分类 [PublishBook↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26333)
 * @请求头 `POST /go/pcm/publishBook/getBookDetailPage`
 * @更新时间 `2021-03-09 15:48:24`
 */ const goPcmPublishBookGetBookDetailPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_35,
    devUrl: devUrl_0_0_0_35,
    prodUrl: prodUrl_0_0_0_35,
    path: "/go/pcm/publishBook/getBookDetailPage",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_35,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPublishBookGetBookDetailPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getBookDetailPage 详情页直出↗](https://yapi.yuewen.com/project/2309/interface/api/198180) 的 **请求函数**
 *
 * @分类 [PublishBook↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26333)
 * @请求头 `POST /go/pcm/publishBook/getBookDetailPage`
 * @更新时间 `2021-03-09 15:48:24`
 */ const goPcmPublishBookGetBookDetailPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPublishBookGetBookDetailPageRequestConfig, requestData), ...args);
};
goPcmPublishBookGetBookDetailPage.requestConfig = goPcmPublishBookGetBookDetailPageRequestConfig;
const mockUrl_0_0_0_36 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_36 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_36 = "https://www.webnovel.com";
const dataKey_0_0_0_36 = "data";
/**
 * 接口 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/198696) 的 **请求配置**
 *
 * @分类 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26488)
 * @请求头 `GET /go/pcm/ranking/getRanking`
 * @更新时间 `2021-03-16 15:05:40`
 */ const goPcmRankingGetRankingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_36,
    devUrl: devUrl_0_0_0_36,
    prodUrl: prodUrl_0_0_0_36,
    path: "/go/pcm/ranking/getRanking",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_36,
    paramNames: [],
    queryNames: [
        "rankId",
        "timeType",
        "novelType",
        "categoryType",
        "listType",
        "language",
        "pageIndex",
        "bookType",
        "sex",
        "bookStatus"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmRankingGetRanking",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/198696) 的 **请求函数**
 *
 * @分类 [获取详细榜单内容↗](https://yapi.yuewen.com/project/2309/interface/api/cat_26488)
 * @请求头 `GET /go/pcm/ranking/getRanking`
 * @更新时间 `2021-03-16 15:05:40`
 */ const goPcmRankingGetRanking = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmRankingGetRankingRequestConfig, requestData), ...args);
};
goPcmRankingGetRanking.requestConfig = goPcmRankingGetRankingRequestConfig;
const mockUrl_0_0_0_37 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_37 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_37 = "https://www.webnovel.com";
const dataKey_0_0_0_37 = "data";
/**
 * 接口 [like 投票↗](https://yapi.yuewen.com/project/2309/interface/api/206970) 的 **请求配置**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/like`
 * @更新时间 `2021-05-11 19:11:59`
 */ const goPcmVoteLikeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_37,
    devUrl: devUrl_0_0_0_37,
    prodUrl: prodUrl_0_0_0_37,
    path: "/go/pcm/vote/like",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_37,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmVoteLike",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [like 投票↗](https://yapi.yuewen.com/project/2309/interface/api/206970) 的 **请求函数**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/like`
 * @更新时间 `2021-05-11 19:11:59`
 */ const goPcmVoteLike = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmVoteLikeRequestConfig, requestData), ...args);
};
goPcmVoteLike.requestConfig = goPcmVoteLikeRequestConfig;
/**
 * 接口 [list 拉取投票书列表↗](https://yapi.yuewen.com/project/2309/interface/api/207456) 的 **请求配置**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/list`
 * @更新时间 `2021-05-11 19:12:16`
 */ const goPcmVoteListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_37,
    devUrl: devUrl_0_0_0_37,
    prodUrl: prodUrl_0_0_0_37,
    path: "/go/pcm/vote/list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_37,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmVoteList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [list 拉取投票书列表↗](https://yapi.yuewen.com/project/2309/interface/api/207456) 的 **请求函数**
 *
 * @分类 [vote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27099)
 * @请求头 `GET /go/pcm/vote/list`
 * @更新时间 `2021-05-11 19:12:16`
 */ const goPcmVoteList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmVoteListRequestConfig, requestData), ...args);
};
goPcmVoteList.requestConfig = goPcmVoteListRequestConfig;
const mockUrl_0_0_0_38 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_38 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_38 = "https://www.webnovel.com";
const dataKey_0_0_0_38 = "data";
/**
 * 接口 [拉取更新信息 - 通知、消息、书架↗](https://yapi.yuewen.com/project/2309/interface/api/206975) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/getUpdateNums`
 * @更新时间 `2021-04-28 15:14:33`
 */ const goPcmBookstoreGetUpdateNumsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/getUpdateNums",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreGetUpdateNums",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取更新信息 - 通知、消息、书架↗](https://yapi.yuewen.com/project/2309/interface/api/206975) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/getUpdateNums`
 * @更新时间 `2021-04-28 15:14:33`
 */ const goPcmBookstoreGetUpdateNums = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookstoreGetUpdateNumsRequestConfig, requestData), ...args);
};
goPcmBookstoreGetUpdateNums.requestConfig = goPcmBookstoreGetUpdateNumsRequestConfig;
/**
 * 接口 [拉取用户优先级最高的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/206993) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/UserBadge`
 * @更新时间 `2021-04-28 15:50:50`
 */ const goPcmBookstoreUserBadgeRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/UserBadge",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreUserBadge",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [拉取用户优先级最高的徽章↗](https://yapi.yuewen.com/project/2309/interface/api/206993) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/UserBadge`
 * @更新时间 `2021-04-28 15:50:50`
 */ const goPcmBookstoreUserBadge = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookstoreUserBadgeRequestConfig, requestData), ...args);
};
goPcmBookstoreUserBadge.requestConfig = goPcmBookstoreUserBadgeRequestConfig;
/**
 * 接口 [Topic↗](https://yapi.yuewen.com/project/2309/interface/api/207370) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/topic`
 * @更新时间 `2021-05-10 17:48:09`
 */ const goPcmBookstoreTopicRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/topic",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: [
        "id"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreTopic",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Topic↗](https://yapi.yuewen.com/project/2309/interface/api/207370) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/topic`
 * @更新时间 `2021-05-10 17:48:09`
 */ const goPcmBookstoreTopic = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookstoreTopicRequestConfig, requestData), ...args);
};
goPcmBookstoreTopic.requestConfig = goPcmBookstoreTopicRequestConfig;
/**
 * 接口 [indexV3Page 3.2迭代后的新版首页↗](https://yapi.yuewen.com/project/2309/interface/api/207394) 的 **请求配置**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/indexV3Page`
 * @更新时间 `2021-05-11 15:10:15`
 */ const goPcmBookstoreIndexV3PageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_38,
    devUrl: devUrl_0_0_0_38,
    prodUrl: prodUrl_0_0_0_38,
    path: "/go/pcm/bookstore/indexV3Page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_38,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmBookstoreIndexV3Page",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [indexV3Page 3.2迭代后的新版首页↗](https://yapi.yuewen.com/project/2309/interface/api/207394) 的 **请求函数**
 *
 * @分类 [bookstore↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27102)
 * @请求头 `GET /go/pcm/bookstore/indexV3Page`
 * @更新时间 `2021-05-11 15:10:15`
 */ const goPcmBookstoreIndexV3Page = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmBookstoreIndexV3PageRequestConfig, requestData), ...args);
};
goPcmBookstoreIndexV3Page.requestConfig = goPcmBookstoreIndexV3PageRequestConfig;
const mockUrl_0_0_0_39 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_39 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_39 = "https://www.webnovel.com";
const dataKey_0_0_0_39 = "data";
/**
 * 接口 [书阅读进度数据↗](https://yapi.yuewen.com/project/2309/interface/api/207008) 的 **请求配置**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/addReview`
 * @更新时间 `2022-12-07 17:00:09`
 */ const goPcmReviewAddReviewRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_39,
    devUrl: devUrl_0_0_0_39,
    prodUrl: prodUrl_0_0_0_39,
    path: "/go/pcm/review/addReview",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_39,
    paramNames: [],
    queryNames: [
        "bookId",
        "novelType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReviewAddReview",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [书阅读进度数据↗](https://yapi.yuewen.com/project/2309/interface/api/207008) 的 **请求函数**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/addReview`
 * @更新时间 `2022-12-07 17:00:09`
 */ const goPcmReviewAddReview = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReviewAddReviewRequestConfig, requestData), ...args);
};
goPcmReviewAddReview.requestConfig = goPcmReviewAddReviewRequestConfig;
/**
 * 接口 [【下线】拉取书评列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/207344) 的 **请求配置**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/GetReviewsAjax`
 * @更新时间 `2022-12-07 17:01:34`
 */ const goPcmReviewGetReviewsAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_39,
    devUrl: devUrl_0_0_0_39,
    prodUrl: prodUrl_0_0_0_39,
    path: "/go/pcm/review/GetReviewsAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_39,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "bookId",
        "bookScore",
        "orderBy"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReviewGetReviewsAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [【下线】拉取书评列表数据↗](https://yapi.yuewen.com/project/2309/interface/api/207344) 的 **请求函数**
 *
 * @分类 [review↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27110)
 * @请求头 `GET /go/pcm/review/GetReviewsAjax`
 * @更新时间 `2022-12-07 17:01:34`
 */ const goPcmReviewGetReviewsAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReviewGetReviewsAjaxRequestConfig, requestData), ...args);
};
goPcmReviewGetReviewsAjax.requestConfig = goPcmReviewGetReviewsAjaxRequestConfig;
const mockUrl_0_0_0_40 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_40 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_40 = "https://www.webnovel.com";
const dataKey_0_0_0_40 = "data";
/**
 * 接口 [直出获取投票历史↗](https://yapi.yuewen.com/project/2309/interface/api/207125) 的 **请求配置**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPage`
 * @更新时间 `2024-08-23 15:49:18`
 */ const goPcmTranslationVoteGetHistoryPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_40,
    devUrl: devUrl_0_0_0_40,
    prodUrl: prodUrl_0_0_0_40,
    path: "/go/pcm/translationVote/getHistoryPage",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_40,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTranslationVoteGetHistoryPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [直出获取投票历史↗](https://yapi.yuewen.com/project/2309/interface/api/207125) 的 **请求函数**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPage`
 * @更新时间 `2024-08-23 15:49:18`
 */ const goPcmTranslationVoteGetHistoryPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTranslationVoteGetHistoryPageRequestConfig, requestData), ...args);
};
goPcmTranslationVoteGetHistoryPage.requestConfig = goPcmTranslationVoteGetHistoryPageRequestConfig;
/**
 * 接口 [ajax获取历史投票记录↗](https://yapi.yuewen.com/project/2309/interface/api/207130) 的 **请求配置**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPageAjax`
 * @更新时间 `2021-04-29 16:02:08`
 */ const goPcmTranslationVoteGetHistoryPageAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_40,
    devUrl: devUrl_0_0_0_40,
    prodUrl: prodUrl_0_0_0_40,
    path: "/go/pcm/translationVote/getHistoryPageAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_40,
    paramNames: [],
    queryNames: [
        "pageIndex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTranslationVoteGetHistoryPageAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ajax获取历史投票记录↗](https://yapi.yuewen.com/project/2309/interface/api/207130) 的 **请求函数**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getHistoryPageAjax`
 * @更新时间 `2021-04-29 16:02:08`
 */ const goPcmTranslationVoteGetHistoryPageAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTranslationVoteGetHistoryPageAjaxRequestConfig, requestData), ...args);
};
goPcmTranslationVoteGetHistoryPageAjax.requestConfig = goPcmTranslationVoteGetHistoryPageAjaxRequestConfig;
/**
 * 接口 [getAjax↗](https://yapi.yuewen.com/project/2309/interface/api/207238) 的 **请求配置**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getAjax`
 * @更新时间 `2021-04-29 19:04:58`
 */ const goPcmTranslationVoteGetAjaxRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_40,
    devUrl: devUrl_0_0_0_40,
    prodUrl: prodUrl_0_0_0_40,
    path: "/go/pcm/translationVote/getAjax",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_40,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "gender"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmTranslationVoteGetAjax",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getAjax↗](https://yapi.yuewen.com/project/2309/interface/api/207238) 的 **请求函数**
 *
 * @分类 [translationVote↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27125)
 * @请求头 `GET /go/pcm/translationVote/getAjax`
 * @更新时间 `2021-04-29 19:04:58`
 */ const goPcmTranslationVoteGetAjax = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmTranslationVoteGetAjaxRequestConfig, requestData), ...args);
};
goPcmTranslationVoteGetAjax.requestConfig = goPcmTranslationVoteGetAjaxRequestConfig;
const mockUrl_0_0_0_41 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_41 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_41 = "https://www.webnovel.com";
const dataKey_0_0_0_41 = "data";
/**
 * 接口 [GetCosKey↗](https://yapi.yuewen.com/project/2309/interface/api/207272) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/utils/get-cos-temp-key`
 * @更新时间 `2024-09-05 10:35:14`
 */ const goPcmUtilsGetCosTempKeyRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/get-cos-temp-key",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [
        "fileName"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsGetCosTempKey",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [GetCosKey↗](https://yapi.yuewen.com/project/2309/interface/api/207272) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/utils/get-cos-temp-key`
 * @更新时间 `2024-09-05 10:35:14`
 */ const goPcmUtilsGetCosTempKey = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUtilsGetCosTempKeyRequestConfig, requestData), ...args);
};
goPcmUtilsGetCosTempKey.requestConfig = goPcmUtilsGetCosTempKeyRequestConfig;
/**
 * 接口 [gaIdReport↗](https://yapi.yuewen.com/project/2309/interface/api/215726) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/gaIdReport`
 * @更新时间 `2022-06-23 11:17:59`
 */ const goPcmUtilsGaIdReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/gaIdReport",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsGaIdReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [gaIdReport↗](https://yapi.yuewen.com/project/2309/interface/api/215726) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/gaIdReport`
 * @更新时间 `2022-06-23 11:17:59`
 */ const goPcmUtilsGaIdReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUtilsGaIdReportRequestConfig, requestData), ...args);
};
goPcmUtilsGaIdReport.requestConfig = goPcmUtilsGaIdReportRequestConfig;
/**
 * 接口 [realtimeReport↗](https://yapi.yuewen.com/project/2309/interface/api/256811) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/realtimeReport`
 * @更新时间 `2023-03-13 16:23:20`
 */ const goPcmUtilsRealtimeReportRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/realtimeReport",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.json */.Py.json,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsRealtimeReport",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [realtimeReport↗](https://yapi.yuewen.com/project/2309/interface/api/256811) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/realtimeReport`
 * @更新时间 `2023-03-13 16:23:20`
 */ const goPcmUtilsRealtimeReport = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUtilsRealtimeReportRequestConfig, requestData), ...args);
};
goPcmUtilsRealtimeReport.requestConfig = goPcmUtilsRealtimeReportRequestConfig;
/**
 * 接口 [ping 探活接口↗](https://yapi.yuewen.com/project/2309/interface/api/289508) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/ping`
 * @更新时间 `2024-07-22 10:44:32`
 */ const goPcmPingRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/ping",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmPing",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [ping 探活接口↗](https://yapi.yuewen.com/project/2309/interface/api/289508) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `GET /go/pcm/ping`
 * @更新时间 `2024-07-22 10:44:32`
 */ const goPcmPing = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmPingRequestConfig, requestData), ...args);
};
goPcmPing.requestConfig = goPcmPingRequestConfig;
/**
 * 接口 [uploadImage↗](https://yapi.yuewen.com/project/2309/interface/api/291868) 的 **请求配置**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/uploadImage`
 * @更新时间 `2024-09-02 19:59:40`
 */ const goPcmUtilsUploadImageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_41,
    devUrl: devUrl_0_0_0_41,
    prodUrl: prodUrl_0_0_0_41,
    path: "/go/pcm/utils/uploadImage",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_41,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmUtilsUploadImage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [uploadImage↗](https://yapi.yuewen.com/project/2309/interface/api/291868) 的 **请求函数**
 *
 * @分类 [utils↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27131)
 * @请求头 `POST /go/pcm/utils/uploadImage`
 * @更新时间 `2024-09-02 19:59:40`
 */ const goPcmUtilsUploadImage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmUtilsUploadImageRequestConfig, requestData), ...args);
};
goPcmUtilsUploadImage.requestConfig = goPcmUtilsUploadImageRequestConfig;
const mockUrl_0_0_0_42 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_42 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_42 = "https://www.webnovel.com";
const dataKey_0_0_0_42 = "data";
/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/2309/interface/api/214797) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2022-10-14 13:48:37`
 */ const goPcmSeoGetTagBookList2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/getTagBookList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: [
        "tagId",
        "tagName",
        "type",
        "pageIndex",
        "order"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetTagBookList2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getTagBookList↗](https://yapi.yuewen.com/project/2309/interface/api/214797) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getTagBookList`
 * @更新时间 `2022-10-14 13:48:37`
 */ const goPcmSeoGetTagBookList2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGetTagBookList2RequestConfig, requestData), ...args);
};
goPcmSeoGetTagBookList2.requestConfig = goPcmSeoGetTagBookList2RequestConfig;
/**
 * 接口 [getBookDetail↗](https://yapi.yuewen.com/project/2309/interface/api/290511) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getBookDetail`
 * @更新时间 `2024-08-21 14:04:17`
 */ const goPcmSeoBookGetBookDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/book/getBookDetail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: [
        "bookId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetBookDetail",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getBookDetail↗](https://yapi.yuewen.com/project/2309/interface/api/290511) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getBookDetail`
 * @更新时间 `2024-08-21 14:04:17`
 */ const goPcmSeoBookGetBookDetail = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoBookGetBookDetailRequestConfig, requestData), ...args);
};
goPcmSeoBookGetBookDetail.requestConfig = goPcmSeoBookGetBookDetailRequestConfig;
/**
 * 接口 [getChapterInfo↗](https://yapi.yuewen.com/project/2309/interface/api/290716) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterInfo`
 * @更新时间 `2024-08-21 14:03:38`
 */ const goPcmSeoBookGetChapterInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/book/getChapterInfo",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: [
        "bookId",
        "chapterId",
        "encryptType",
        "font"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetChapterInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getChapterInfo↗](https://yapi.yuewen.com/project/2309/interface/api/290716) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterInfo`
 * @更新时间 `2024-08-21 14:03:38`
 */ const goPcmSeoBookGetChapterInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoBookGetChapterInfoRequestConfig, requestData), ...args);
};
goPcmSeoBookGetChapterInfo.requestConfig = goPcmSeoBookGetChapterInfoRequestConfig;
/**
 * 接口 [getChapterList↗](https://yapi.yuewen.com/project/2309/interface/api/291197) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterList`
 * @更新时间 `2024-08-21 15:43:39`
 */ const goPcmSeoBookGetChapterListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/book/getChapterList",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: [
        "bookId",
        "pageIndex",
        "pageSize",
        "encryptType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoBookGetChapterList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getChapterList↗](https://yapi.yuewen.com/project/2309/interface/api/291197) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/book/getChapterList`
 * @更新时间 `2024-08-21 15:43:39`
 */ const goPcmSeoBookGetChapterList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoBookGetChapterListRequestConfig, requestData), ...args);
};
goPcmSeoBookGetChapterList.requestConfig = goPcmSeoBookGetChapterListRequestConfig;
/**
 * 接口 [getTopicDetail↗](https://yapi.yuewen.com/project/2309/interface/api/295540) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-11-05 15:52:56`
 */ const goPcmSeoTopicDetail2RequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/topic/detail",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: [
        "topicId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoTopicDetail2",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getTopicDetail↗](https://yapi.yuewen.com/project/2309/interface/api/295540) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/topic/detail`
 * @更新时间 `2024-11-05 15:52:56`
 */ const goPcmSeoTopicDetail2 = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoTopicDetail2RequestConfig, requestData), ...args);
};
goPcmSeoTopicDetail2.requestConfig = goPcmSeoTopicDetail2RequestConfig;
/**
 * 接口 [getFriendShipLink↗](https://yapi.yuewen.com/project/2309/interface/api/295600) 的 **请求配置**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getFriendShipLink`
 * @更新时间 `2024-11-08 11:09:16`
 */ const goPcmSeoGetFriendShipLinkRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_42,
    devUrl: devUrl_0_0_0_42,
    prodUrl: prodUrl_0_0_0_42,
    path: "/go/pcm/seo/getFriendShipLink",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_42,
    paramNames: [],
    queryNames: [
        "domainIds",
        "linkTypes",
        "pubStates"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmSeoGetFriendShipLink",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [getFriendShipLink↗](https://yapi.yuewen.com/project/2309/interface/api/295600) 的 **请求函数**
 *
 * @分类 [seo↗](https://yapi.yuewen.com/project/2309/interface/api/cat_27412)
 * @请求头 `GET /go/pcm/seo/getFriendShipLink`
 * @更新时间 `2024-11-08 11:09:16`
 */ const goPcmSeoGetFriendShipLink = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmSeoGetFriendShipLinkRequestConfig, requestData), ...args);
};
goPcmSeoGetFriendShipLink.requestConfig = goPcmSeoGetFriendShipLinkRequestConfig;
const mockUrl_0_0_0_43 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_43 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_43 = "https://www.webnovel.com";
const dataKey_0_0_0_43 = "data";
/**
 * 接口 [Affiliate申请↗](https://yapi.yuewen.com/project/2309/interface/api/225293) 的 **请求配置**
 *
 * @分类 [Affiliate↗](https://yapi.yuewen.com/project/2309/interface/api/cat_29300)
 * @请求头 `POST /go/pcm/affiliate/add`
 * @更新时间 `2022-06-23 16:14:42`
 */ const goPcmAffiliateAddRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_43,
    devUrl: devUrl_0_0_0_43,
    prodUrl: prodUrl_0_0_0_43,
    path: "/go/pcm/affiliate/add",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_43,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmAffiliateAdd",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Affiliate申请↗](https://yapi.yuewen.com/project/2309/interface/api/225293) 的 **请求函数**
 *
 * @分类 [Affiliate↗](https://yapi.yuewen.com/project/2309/interface/api/cat_29300)
 * @请求头 `POST /go/pcm/affiliate/add`
 * @更新时间 `2022-06-23 16:14:42`
 */ const goPcmAffiliateAdd = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmAffiliateAddRequestConfig, requestData), ...args);
};
goPcmAffiliateAdd.requestConfig = goPcmAffiliateAddRequestConfig;
const mockUrl_0_0_0_44 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_44 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_44 = "https://www.webnovel.com";
const dataKey_0_0_0_44 = "data";
/**
 * 接口 [get-pool 获取广告池↗](https://yapi.yuewen.com/project/2309/interface/api/234593) 的 **请求配置**
 *
 * @分类 [ad 广告↗](https://yapi.yuewen.com/project/2309/interface/api/cat_30340)
 * @请求头 `GET /go/pcm/ad/get-pool`
 * @更新时间 `2022-03-09 13:35:09`
 */ const goPcmAdGetPoolRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_44,
    devUrl: devUrl_0_0_0_44,
    prodUrl: prodUrl_0_0_0_44,
    path: "/go/pcm/ad/get-pool",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_44,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmAdGetPool",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [get-pool 获取广告池↗](https://yapi.yuewen.com/project/2309/interface/api/234593) 的 **请求函数**
 *
 * @分类 [ad 广告↗](https://yapi.yuewen.com/project/2309/interface/api/cat_30340)
 * @请求头 `GET /go/pcm/ad/get-pool`
 * @更新时间 `2022-03-09 13:35:09`
 */ const goPcmAdGetPool = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmAdGetPoolRequestConfig, requestData), ...args);
};
goPcmAdGetPool.requestConfig = goPcmAdGetPoolRequestConfig;
const mockUrl_0_0_0_45 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_45 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_45 = "https://www.webnovel.com";
const dataKey_0_0_0_45 = "data";
/**
 * 接口 [获取矩阵page↗](https://yapi.yuewen.com/project/2309/interface/api/250623) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/page`
 * @更新时间 `2022-12-02 15:33:35`
 */ const goPcmMatrixBookcityPageRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/bookcity/page",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: [
        "country",
        "sex",
        "language"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixBookcityPage",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取矩阵page↗](https://yapi.yuewen.com/project/2309/interface/api/250623) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/page`
 * @更新时间 `2022-12-02 15:33:35`
 */ const goPcmMatrixBookcityPage = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixBookcityPageRequestConfig, requestData), ...args);
};
goPcmMatrixBookcityPage.requestConfig = goPcmMatrixBookcityPageRequestConfig;
/**
 * 接口 [获取feed流数据↗](https://yapi.yuewen.com/project/2309/interface/api/253258) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-feed-list`
 * @更新时间 `2022-12-05 13:50:15`
 */ const goPcmMatrixBookcityGetFeedListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/bookcity/get-feed-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "sex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixBookcityGetFeedList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取feed流数据↗](https://yapi.yuewen.com/project/2309/interface/api/253258) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-feed-list`
 * @更新时间 `2022-12-05 13:50:15`
 */ const goPcmMatrixBookcityGetFeedList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixBookcityGetFeedListRequestConfig, requestData), ...args);
};
goPcmMatrixBookcityGetFeedList.requestConfig = goPcmMatrixBookcityGetFeedListRequestConfig;
/**
 * 接口 [获取书城content里面的信息↗](https://yapi.yuewen.com/project/2309/interface/api/253282) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-content-info`
 * @更新时间 `2022-12-15 15:11:22`
 */ const goPcmMatrixBookcityGetContentInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/bookcity/get-content-info",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: [
        "contentId"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixBookcityGetContentInfo",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取书城content里面的信息↗](https://yapi.yuewen.com/project/2309/interface/api/253282) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/bookcity/get-content-info`
 * @更新时间 `2022-12-15 15:11:22`
 */ const goPcmMatrixBookcityGetContentInfo = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixBookcityGetContentInfoRequestConfig, requestData), ...args);
};
goPcmMatrixBookcityGetContentInfo.requestConfig = goPcmMatrixBookcityGetContentInfoRequestConfig;
/**
 * 接口 [获取榜单↗](https://yapi.yuewen.com/project/2309/interface/api/253348) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-list`
 * @更新时间 `2022-12-07 19:03:10`
 */ const goPcmMatrixRankGetListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/rank/get-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: [
        "listType",
        "bookType",
        "rankId",
        "rankType",
        "language",
        "pageIndex",
        "sourceType",
        "sex",
        "status",
        "signed",
        "vipStatus",
        "categoryType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixRankGetList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取榜单↗](https://yapi.yuewen.com/project/2309/interface/api/253348) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-list`
 * @更新时间 `2022-12-07 19:03:10`
 */ const goPcmMatrixRankGetList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixRankGetListRequestConfig, requestData), ...args);
};
goPcmMatrixRankGetList.requestConfig = goPcmMatrixRankGetListRequestConfig;
/**
 * 接口 [获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/253678) 的 **请求配置**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-config`
 * @更新时间 `2022-12-14 10:27:50`
 */ const goPcmMatrixRankGetConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_45,
    devUrl: devUrl_0_0_0_45,
    prodUrl: prodUrl_0_0_0_45,
    path: "/go/pcm/matrix/rank/get-config",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_45,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixRankGetConfig",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取榜单配置↗](https://yapi.yuewen.com/project/2309/interface/api/253678) 的 **请求函数**
 *
 * @分类 [矩阵find-book 找书↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32815)
 * @请求头 `GET /go/pcm/matrix/rank/get-config`
 * @更新时间 `2022-12-14 10:27:50`
 */ const goPcmMatrixRankGetConfig = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixRankGetConfigRequestConfig, requestData), ...args);
};
goPcmMatrixRankGetConfig.requestConfig = goPcmMatrixRankGetConfigRequestConfig;
const mockUrl_0_0_0_46 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_46 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_46 = "https://www.webnovel.com";
const dataKey_0_0_0_46 = "data";
/**
 * 接口 [同步接口↗](https://yapi.yuewen.com/project/2309/interface/api/252522) 的 **请求配置**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `POST /go/pcm/readsdk/setConfig`
 * @更新时间 `2022-11-24 14:52:16`
 */ const goPcmReadsdkSetConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_46,
    devUrl: devUrl_0_0_0_46,
    prodUrl: prodUrl_0_0_0_46,
    path: "/go/pcm/readsdk/setConfig",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_46,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadsdkSetConfig",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [同步接口↗](https://yapi.yuewen.com/project/2309/interface/api/252522) 的 **请求函数**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `POST /go/pcm/readsdk/setConfig`
 * @更新时间 `2022-11-24 14:52:16`
 */ const goPcmReadsdkSetConfig = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadsdkSetConfigRequestConfig, requestData), ...args);
};
goPcmReadsdkSetConfig.requestConfig = goPcmReadsdkSetConfigRequestConfig;
/**
 * 接口 [获取配置↗](https://yapi.yuewen.com/project/2309/interface/api/252540) 的 **请求配置**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `GET /go/pcm/readsdk/getConfig`
 * @更新时间 `2022-11-24 14:56:51`
 */ const goPcmReadsdkGetConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_46,
    devUrl: devUrl_0_0_0_46,
    prodUrl: prodUrl_0_0_0_46,
    path: "/go/pcm/readsdk/getConfig",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_46,
    paramNames: [],
    queryNames: [
        "siteId",
        "identity"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmReadsdkGetConfig",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取配置↗](https://yapi.yuewen.com/project/2309/interface/api/252540) 的 **请求函数**
 *
 * @分类 [阅读SDK↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32905)
 * @请求头 `GET /go/pcm/readsdk/getConfig`
 * @更新时间 `2022-11-24 14:56:51`
 */ const goPcmReadsdkGetConfig = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmReadsdkGetConfigRequestConfig, requestData), ...args);
};
goPcmReadsdkGetConfig.requestConfig = goPcmReadsdkGetConfigRequestConfig;
const mockUrl_0_0_0_47 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_47 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_47 = "https://www.webnovel.com";
const dataKey_0_0_0_47 = "data";
/**
 * 接口 [获取联想结果↗](https://yapi.yuewen.com/project/2309/interface/api/253096) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-auto-complete`
 * @更新时间 `2022-12-02 15:45:58`
 */ const goPcmMatrixSearchGetAutoCompleteRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-auto-complete",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [
        "keyWord"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetAutoComplete",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取联想结果↗](https://yapi.yuewen.com/project/2309/interface/api/253096) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-auto-complete`
 * @更新时间 `2022-12-02 15:45:58`
 */ const goPcmMatrixSearchGetAutoComplete = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixSearchGetAutoCompleteRequestConfig, requestData), ...args);
};
goPcmMatrixSearchGetAutoComplete.requestConfig = goPcmMatrixSearchGetAutoCompleteRequestConfig;
/**
 * 接口 [获取搜索结果↗](https://yapi.yuewen.com/project/2309/interface/api/253105) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-result`
 * @更新时间 `2022-12-08 13:57:39`
 */ const goPcmMatrixSearchGetResultRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-result",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [
        "pageIndex",
        "pageSize",
        "keyWord",
        "sortType",
        "chapters",
        "status",
        "itemType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetResult",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取搜索结果↗](https://yapi.yuewen.com/project/2309/interface/api/253105) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-result`
 * @更新时间 `2022-12-08 13:57:39`
 */ const goPcmMatrixSearchGetResult = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixSearchGetResultRequestConfig, requestData), ...args);
};
goPcmMatrixSearchGetResult.requestConfig = goPcmMatrixSearchGetResultRequestConfig;
/**
 * 接口 [筛选项配置↗](https://yapi.yuewen.com/project/2309/interface/api/253114) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-filter-config`
 * @更新时间 `2022-12-02 15:47:03`
 */ const goPcmMatrixSearchGetFilterConfigRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-filter-config",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetFilterConfig",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [筛选项配置↗](https://yapi.yuewen.com/project/2309/interface/api/253114) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-filter-config`
 * @更新时间 `2022-12-02 15:47:03`
 */ const goPcmMatrixSearchGetFilterConfig = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixSearchGetFilterConfigRequestConfig, requestData), ...args);
};
goPcmMatrixSearchGetFilterConfig.requestConfig = goPcmMatrixSearchGetFilterConfigRequestConfig;
/**
 * 接口 [获取搜索热词↗](https://yapi.yuewen.com/project/2309/interface/api/253123) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-hot-word`
 * @更新时间 `2022-12-02 15:47:34`
 */ const goPcmMatrixSearchGetHotWordRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-hot-word",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [
        "sex"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetHotWord",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取搜索热词↗](https://yapi.yuewen.com/project/2309/interface/api/253123) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-hot-word`
 * @更新时间 `2022-12-02 15:47:34`
 */ const goPcmMatrixSearchGetHotWord = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixSearchGetHotWordRequestConfig, requestData), ...args);
};
goPcmMatrixSearchGetHotWord.requestConfig = goPcmMatrixSearchGetHotWordRequestConfig;
/**
 * 接口 [获取推荐榜单list↗](https://yapi.yuewen.com/project/2309/interface/api/253128) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-top-list`
 * @更新时间 `2022-12-02 15:47:58`
 */ const goPcmMatrixSearchGetTopListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-top-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetTopList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取推荐榜单list↗](https://yapi.yuewen.com/project/2309/interface/api/253128) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-top-list`
 * @更新时间 `2022-12-02 15:47:58`
 */ const goPcmMatrixSearchGetTopList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixSearchGetTopListRequestConfig, requestData), ...args);
};
goPcmMatrixSearchGetTopList.requestConfig = goPcmMatrixSearchGetTopListRequestConfig;
/**
 * 接口 [获取tag书↗](https://yapi.yuewen.com/project/2309/interface/api/253360) 的 **请求配置**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-tag-book-list`
 * @更新时间 `2024-10-16 17:02:16`
 */ const goPcmMatrixSearchGetTagBookListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_47,
    devUrl: devUrl_0_0_0_47,
    prodUrl: prodUrl_0_0_0_47,
    path: "/go/pcm/matrix/search/get-tag-book-list",
    method: types/* Method.GET */.n$.GET,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.query */.Py.query,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_47,
    paramNames: [],
    queryNames: [
        "tagId",
        "pageIndex",
        "sortType",
        "chapters",
        "status",
        "pageSize",
        "categoryType"
    ],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmMatrixSearchGetTagBookList",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [获取tag书↗](https://yapi.yuewen.com/project/2309/interface/api/253360) 的 **请求函数**
 *
 * @分类 [矩阵搜索↗](https://yapi.yuewen.com/project/2309/interface/api/cat_32954)
 * @请求头 `GET /go/pcm/matrix/search/get-tag-book-list`
 * @更新时间 `2024-10-16 17:02:16`
 */ const goPcmMatrixSearchGetTagBookList = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmMatrixSearchGetTagBookListRequestConfig, requestData), ...args);
};
goPcmMatrixSearchGetTagBookList.requestConfig = goPcmMatrixSearchGetTagBookListRequestConfig;
const mockUrl_0_0_0_48 = "https://yapi.yuewen.com/mock/2309";
const devUrl_0_0_0_48 = "https://oawww.webnovel.com";
const prodUrl_0_0_0_48 = "https://www.webnovel.com";
const dataKey_0_0_0_48 = "data";
/**
 * 接口 [Bind 账号绑定↗](https://yapi.yuewen.com/project/2309/interface/api/257620) 的 **请求配置**
 *
 * @分类 [discord↗](https://yapi.yuewen.com/project/2309/interface/api/cat_33460)
 * @请求头 `POST /go/pcm/discord/bind`
 * @更新时间 `2023-08-24 14:17:05`
 */ const goPcmDiscordBindRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_48,
    devUrl: devUrl_0_0_0_48,
    prodUrl: prodUrl_0_0_0_48,
    path: "/go/pcm/discord/bind",
    method: types/* Method.POST */.n$.POST,
    requestHeaders: {},
    requestBodyType: types/* RequestBodyType.form */.Py.form,
    responseBodyType: types/* ResponseBodyType.json */.b.json,
    dataKey: dataKey_0_0_0_48,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {},
    responseDataJsonSchema: {},
    requestFunctionName: "goPcmDiscordBind",
    queryStringArrayFormat: types/* QueryStringArrayFormat.brackets */.s0.brackets,
    extraInfo: {}
};
/**
 * 接口 [Bind 账号绑定↗](https://yapi.yuewen.com/project/2309/interface/api/257620) 的 **请求函数**
 *
 * @分类 [discord↗](https://yapi.yuewen.com/project/2309/interface/api/cat_33460)
 * @请求头 `POST /go/pcm/discord/bind`
 * @更新时间 `2023-08-24 14:17:05`
 */ const goPcmDiscordBind = /*#__PURE__*/ function(requestData) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return request((0,helpers/* prepare */.Pl)(goPcmDiscordBindRequestConfig, requestData), ...args);
};
goPcmDiscordBind.requestConfig = goPcmDiscordBindRequestConfig; /* prettier-ignore-end */ 


/***/ }),

/***/ 32508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ CoveringCorner; },
/* harmony export */   "em": function() { return /* binding */ CoveringBottom; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39349);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Cover = (param)=>{
    let { className ="" , width =52 , height , auto =false , children , src , alt ="" , imgClassName ="" , ...otherProps } = param;
    const _height = height || width * 3 / 2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "".concat(className, " ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bookCover), " pr br4 dib vam bc_default bsbb"),
        style: auto ? {
            width: "100%",
            height: "100%"
        } : {
            width: "".concat(width / 16, "rem"),
            height: "".concat(_height / 16, "rem")
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pa t0 l0 br2 w100% h100% ".concat(imgClassName),
                style: {
                    width: width,
                    height: _height,
                    background: "url(".concat(src, ") center/auto 100% no-repeat border-box border-box")
                },
                ...otherProps
            }),
            children
        ]
    });
};
const CoveringCorner = (param)=>{
    let { className ="" , backgroundColor , position , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "".concat(className, " ").concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cornerBadge), " pa _").concat(position, " df aic jcc t_label_l"),
        style: {
            backgroundColor
        },
        children: children
    });
};
const CoveringBottom = (param)=>{
    let { backgroundColor , color , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bottomPart), " pa b0 l0 r0 w100% t_label_m ell tac pl8 pr8"),
        style: {
            backgroundColor,
            color
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(Cover));


/***/ }),

/***/ 35393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* reexport */ CornerPos; },
  "Z": function() { return /* binding */ Cover; }
});

// EXTERNAL MODULE: ./src/read-ui/Cover/cover.tsx
var cover = __webpack_require__(32508);
;// CONCATENATED MODULE: ./src/read-ui/Cover/interfaces.ts
var CornerPos;
(function(CornerPos) {
    CornerPos["leftTop"] = "leftTop";
    CornerPos["rightTop"] = "rightTop";
    CornerPos["leftBottom"] = "leftBottom";
    CornerPos["rightBottom"] = "rightBottom";
})(CornerPos || (CornerPos = {}));

;// CONCATENATED MODULE: ./src/read-ui/Cover/index.tsx


/* harmony default export */ var Cover = (cover/* default */.ZP);


/***/ }),

/***/ 39349:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bookCover":"style_bookCover__EKwKC","cornerBadge":"style_cornerBadge__PfuC8","bottomPart":"style_bottomPart__dH9vV"};

/***/ })

}]);